export default {
  es: {
    langs: {
      es: "0",
      en: "1",
    },
    paths: {
      home: "/",
      "nuestra-historia": "nuestra-historia",
      "proyectos-ayudas": "proyectos-ayudas-subvenciones",
      "proyectos-rsc": "proyectos-rsc",
      "proyectos-rsc-ficha": "proyectos-rsc",
      "quienes-somos": "quienes-somos",
      innovacion: "innovacion",
      "calidad–y-seguridad-alimentaria": "calidad-y-seguridad-alimentaria",
      "mision-vision": "mision-vision",
      "nuestras-marcas": "nuestras-marcas",
      "empresas-grupo": "plantas-grupo",
      "empresas-grupo-norenense": "la-norenense",
      exportacion: "exportacion",
      certificaciones: "certificaciones",
      "sala-de-prensa": "sala-de-prensa",
      contacto: "contacto",
      "compromiso-ian": "compromiso-ian",
      productos: "productos",
      "ficha-categoria-producto": "productos",
      "conservas-vegetales": "conservas-vegetales",
      "platos-preparados": "platos-preparados",
      "ficha-producto": "producto",
      avisolegal: "aviso-legal",
      politica_privacidad: "politica-privacidad",
      politica_cookies: "politica-cookies",
      mapa_web: "mapa-web",
      "carretilla-info": "https://carretilla.info/",
      formaciondeacogida: "formaciondeacogida",
      interoliva: "https://www.interoliva.com/",
      ian50: "/es/proyectos-rsc/celebracion-del-50-aniversario-de-grupo-ian-una-historia-compartida-de-ilusion-y-tradicion"
    },
    links: {
      nuestra_historia: "/nuestra-historia",
      proyectos: "/proyectos-ayudas-subvenciones",
      proyectos_rsc: "/proyectos-rsc",
      quienes_somos: "/quienes-somos",
      calidad_innovacion: "/calidad–y-seguridad-alimentaria",
      mision_vision: "/proposito-vision-valores",
      nuestras_marcas: "/nuestras-marcas",
      exportacion: "/exportacion",
      empresas_grupo: "/plantas-del-grupo",
      certificaciones: "/certificaciones",
      sala_prensa: "/sala-de-prensa",
      contacto: "/contacto",
      compromiso_ian: "/compromiso-ian",
      productos: "/productos",
      producto: "/producto",
      conservasvegetales: "/conservas-vegetales",
      esparragos: "/esparragos",
      avisolegal: "/aviso-legal",
      politica_privacidad: "/politica-privacidad",
      politica_cookies: "/politica-cookies",
      mapa_web: "/mapa-web",
      rsc: "/rsc",
    },
    seo: {
      default: {
        title:
          "Conservas vegetales y platos preparados | Grupo Alimentario IAN",
        description:
          "Somos una compañía de alimentación referente en la elaboración de una amplia variedad de conservas vegetales y platos preparados listos para comer.",
      },
      home: {
        title:
          "Conservas vegetales y platos preparados | Grupo Alimentario IAN",
        description:
          "Somos una compañía de alimentación referente en la elaboración de una amplia variedad de conservas vegetales y platos preparados listos para comer.",
      },
      "quienes-somos": {
        title:
          "Referentes en conservas vegetales y platos preparados| Grupo Alimentario IAN",
        description:
          "Somos una compañía de alimentación referente en conservas vegetales y platos preparados. Con nuestra marca Carretilla, somos líderes nacionales en el mercado de espárragos, pimientos y platos listos para comer.",
      },
      "mision-vision": {
        title:
          "Misión, visión y valores | Crecer siendo sostenibles |Grupo Alimentario IAN",
        description:
          "Excelencia, calidad, innovación ,naturalidad y sostenibilidad, valores que nos han llevado a ser lo que hoy es nuestra compañía.",
      },
      "nuestra-historia": {
        title: "Nuestra historia, más de 145 años | Grupo Alimentario IAN",
        description:
          "Nuestra historia comenzó en 1875 de la mano de nuestra emblemática marca Carretilla. Descubre lo que ha pasado en todos estos años.",
      },
      "empresas-grupo": {
        title: "Nuestras plantas productivas: IAN, Ian Aceitunas, Taboada, Noreñense",
        description:
          "Nuestras plantas productivas: IAN, Ian Aceitunas, Taboada y Noreñense han llevado a consolidar a nuestra compañía, como referente en el sector de alimentación español.",
      },
      productos: {
        title: "Productos | Grupo Alimentario IAN",
        description:
          "Somos una compañía de alimentación referente en la elaboración de una amplia variedad de conservas vegetales y platos preparados listos para comer. ",
      },
      innovacion: {
        title: "Innovación e I+D+i | Grupo Alimentario IAN",
        description:
          "En Grupo Alimentario IAN, trabajamos cada día a la vanguardia de la innovación, para ofrecer productos adaptados al estilo y ritmo de vida actual de la sociedad. Conoce nuestra cultura de la innovación.",
      },
      "calidad–y-seguridad-alimentaria": {
        title: "Calidad y seguridad alimentaria |Grupo Alimentario IAN",
        description:
          "Trabajamos bajo los más estrictos controles de calidad y seguridad alimentaria. Entre otros, contamos con el certificado IFS en todas nuestras plantas, actualmente la certificación más exigente reconocida a nivel mundial en términos de calidad y seguridad alimentaria.",
      },
      certificaciones: {
        title: "Certificaciones | Grupo Alimentario IAN",
        description:
          "Fabricamos bajo estándares de calidad y seguridad alimentaria, cumpliendo con los estándares de calidad más exigentes, tanto a nivel nacional como internacional.",
      },
      "proyectos-ayudas": {
        title: "Proyectos, ayudas y subvenciones | Grupo Alimentario IAN",
        description:
          "En Grupo Alimentario IAN, bajo nuestro firme compromiso con el desarrollo sostenible, participamos en diversos proyectos de I+D+i nacionales e internacionales. Conócelos.",
      },
      "nuestras-marcas": {
        title: "Carretilla |Nuestras marcas | Grupo Alimentario IAN",
        description:
          "Con nuestra centenaria marca Carretilla somos líderes nacionales en el mercado de espárragos, pimientos y de platos preparados listos para comer. Además, contamos con otras marcas que nos permiten ser una compañía referente en el sector de la alimentación.",
      },
      "compromiso-ian": {
        title: "Compromiso sostenible |Grupo Alimentario IAN",
        description:
          "Grupo Alimentario IAN, compromiso para un futuro mejor. Nuestro propósito es crecer siendo sostenibles, bajo un firme compromiso con el medioambiente, con las personas y con las buenas prácticas.",
      },
      "proyectos-rsc": {
        title: "Proyectos RSC |Grupo Alimentario IAN",
        description:
          "En Grupo Alimentario IAN, trabajamos en proyectos e iniciativas para apoyar y acelerar transformaciones medioambientales, sociales y económicas que contribuyan al desarrollo sostenible. ",
      },
      exportacion: {
        title: "Exportación |Grupo Alimentario IAN",
        description:
          "Somos uno de los grupos de alimentación español con mayor presencia internacional. Exportamos nuestras conservas vegetales y platos preparados a los cinco continentes.",
      },
      contacto: {
        title: "Contacto Grupo Alimentario IAN",
        description:
          "Contáctanos para cualquier información, duda o sugerencia sobre Grupo Alimentario IAN.",
      },
      "sala-de-prensa": {
        title: "Prensa | Grupo Alimentario IAN",
        description:
          "Contáctanos si eres un profesional de los medios de comunicación y necesitas información sobre Grupo Alimentario IAN.",
      },
    },
    navbar_menu: {
      group_ian: {
        title: "Somos Grupo IAN",
        sub_groups: {
          quienes_somos: {
            title: "¿Quiénes Somos?",
            to: "quienes-somos",
          },
          mision_vision: {
            title: "Propósito, Visión y Valores",
            to: "mision-vision",
          },
          nuestra_historia: {
            title: "Nuestra Historia",
            to: "nuestra-historia",
          },
          empresas_grupo: {
            title: "Plantas del Grupo",
            to: "empresas-grupo",
          },
        },
      },
      products: {
        title: "Productos",
        sub_groups: {
          "conservas-vegetales": {
            title: "Conservas Vegetales",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "conservas-vegetales" },
            },
          },
          "platos-preparados": {
            title: "Platos Preparados",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "platos-preparados" },
            },
          },
        },
      },
      quality_innovation: {
        title: "Innovación y Calidad",
        sub_groups: {
          innovacion: {
            title: "Innovación",
            to: "innovacion",
          },
          calidad_innovacion: {
            title: "Calidad y Seguridad Alimentaria",
            to: "calidad–y-seguridad-alimentaria",
          },
          certificaciones: {
            title: "Certificaciones",
            to_params: {
              name: "certificaciones",
              params: "",
            },
          },
          proyectos: {
            title: "Proyectos, Ayudas y Subvenciones",
            to: "proyectos-ayudas",
          },
        },
      },
      our_brands: {
        title: "Carretilla | Nuestras Marcas",
        to: "nuestras-marcas",
      },
      commitment: {
        title: "RSC",
        sub_groups: {
          compromiso_ian: {
            title: "Compromiso IAN",
            to: "compromiso-ian",
          },
          proyectos_rsc: {
            title: "Proyectos RSC",
            to: "proyectos-rsc",
          }
        },
      },
      export: {
        title: "Exportación",
        to: "exportacion",
      },
      food_service_channel: {
        title: "Canal Food Service",
        href: "https://rfh.grupoian.com/",
      },
      contact: {
        title: "Contacto",
        sub_groups: {
          contacto: {
            title: "¡Contáctanos!",
            to: "contacto",
          },
          sala_prensa: {
            title: "Sala de Prensa",
            to: "sala-de-prensa",
          },
        },
      },
      trabaja_ian: {
        title: "Trabaja en Grupo IAN",
        href:
          "https://grupoian.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=1&id_origen=web+corporativa",
      }
    },
    footer: {
      footer: {
        title: "Somos Grupo IAN",
        logos: [
          {
            href: "https://www.carretilla.info/",
            target: "_blank",
            "img-path": "/img/logos/carretilla_footer.png",
            "img-alt": "Ogo Carretilla IAN - Grupo Alimentario",
          },
          {
            href: "https://www.camaranavarra.com/",
            target: "_blank",
            "img-path": "/img/logos/camaraNavarraLogoEn.jpg",
            "img-alt": "Logo Camara Navarra IAN - Grupo Alimentario",
          },
          {
            href: "https://www.ifs-certification.com/index.php/es/",
            target: "_blank",
            "img-path": "/img/logos/calidad.png",
            "img-alt": "Logo ifs-certification IAN - Grupo Alimentario",
          },
          {
            href: "https://gesprodat.com/",
            target: "_blank",
            "img-path": "/img/logos/gesprodat.png",
            "img-alt": "Logo Esprodat IAN - Grupo Alimentario",
          },
          {
            href: "https://www.orizont.es/",
            target: "_blank",
            "img-path": "/img/logos/logo_orizon.png",
            "img-alt": "Logo Orizon IAN - Grupo Alimentario",
            text: "INNOVACIÓN <br>AGROALIMENTARIA",
          },
        ],
        sub_groups: {
          quienes_somos: {
            title: "¿Quiénes Somos?",
            to: "quienes-somos",
          },
          mision_vision: {
            title: "Propósito, Visión y Valores",
            to: "mision-vision",
          },
          nuestra_historia: {
            title: "Nuestra Historia",
            to: "nuestra-historia",
          },
          empresas_grupo: {
            title: "Plantas del Grupo",
            to: "empresas-grupo",
          },
        },
      },
      commitment: {
        title: "RSC",
        sub_groups: {
          compromiso_ian: {
            title: "Compromiso IAN",
            to: "compromiso-ian",
          },
          proyectos_rsc: {
            title: "Proyectos RSC",
            to: "proyectos-rsc",
            lang: "es"
          },
          service: {
            title: "Política de Sostenibilidad y RSC",
            href: "/docs/politica-sostenibilidad-rsc-grupo-ian.pdf",
          }
        },
      },
      our_brands: {
        title: "Carretilla | Nuestras Marcas",
        sub_groups: {
          brands: {
            title: "Marcas Grupo Alimentario IAN",
            to: "nuestras-marcas",
          },
        },
      },
      quality_innovation: {
        title: "Innovación y Calidad",
        sub_groups: {
          innovacion: {
            title: "Innovación",
            to: "innovacion",
          },
          calidad_innovacion: {
            title: "Calidad y Seguridad Alimentaria",
            to: "calidad–y-seguridad-alimentaria",
          },
          certificaciones: {
            title: "Certificaciones",
            to_params: {
              name: "certificaciones",
              params: "",
            },
          },
          proyectos: {
            title: "Proyectos, Ayudas y Subvenciones",
            to: "proyectos-ayudas",
          },
        },
      },
      products: {
        title: "Productos",
        sub_groups: {
          "conservas-vegetales": {
            title: "Conservas Vegetales",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "conservas-vegetales" },
            },
          },
          "platos-preparados": {
            title: "Platos Preparados",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "platos-preparados" },
            },
          },
        },
      },
      export: {
        title: "Exportación",
        sub_groups: {
          export: {
            title: "Exportación Grupo Alimentario IAN",
            to: "exportacion",
          },
        },
      },
      food_service_channel: {
        title: "Canal Food Service",
        sub_groups: {
          service: {
            title: "Hostelería y Restauración",
            href: "https://rfh.grupoian.com/",
          },
        },
      },
      contact: {
        title: "Contacto",
        sub_groups: {
          contacto: {
            title: "¡Contáctanos!",
            to: "contacto",
          },
          trabaja_ian: {
            title: "Trabaja en Grupo IAN",
            href:
              "https://grupoian.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=1&id_origen=web+corporativa",
          },
          sala_prensa: {
            title: "Sala de Prensa",
            to: "sala-de-prensa",
          },
          siguenos: {
            title: "Síguenos",
            href: "https://www.linkedin.com/company/carretilla/",
            icon: "fa fa-linkedin",
          },
        },
      },
    },
    sub_footer: {
      0: {
        title: "Aviso legal",
        to: "avisolegal",
      },
      1: {
        title: "Canal de Comunicación",
        href: "https://canal-de-comunicacion.grupoian.com/",
      },
      2: {
        title: "Política de Privacidad",
        to: "politica_privacidad",
      },
      3: {
        title: "Política de Cookies",
        to: "politica_cookies",
      },
      4: {
        title: "Mapa web",
        to: "mapa_web",
      },
      5: {
        title: "Contacto",
        to: "contacto",
      },
    },
    home: {
      intro: {
        juntos: "#SomosGrupoIAN",
        atulado: "A tu Lado, desde 1875",
        apostamos: "Apostamos por la Innovación",
        conoce: "Conoce nuestros proyectos rsc",
        exportamos: "EXPORTAMOS A LOS 5 CONTINENTES",
        nuestros_productos: "Nuestros Productos",
        rsc: "COMPROMISO PARA UN FUTURO MEJOR",
        rsc_background: "/img/banner-rsc-home.jpg",
        interoliva: "NUEVA INCORPORACIÓN A GRUPO ALIMENTARIO IAN",
      },
      proyects_home: {
        img: "/img/logo-rsc.png",
        text:
          "<p>Además de <strong>nuestro firme compromiso con el desarrollo sostenible</strong> y el cuidado del medioambiente, en Grupo IAN también impulsamos nuestro desarrollo socioeconómico a través de <strong>diversas políticas de RSC</strong>.</p>",
      },
      banner_calidad: {
        img: "/img/banner-calidad.jpg",
        title: "Calidad y<br> Seguridad Alimentaria",
      },
      banner_our_brand: {
        title: "Conoce Nuestra <br/> Centenaria Marca <br/>Carretilla",
        img: "/img/banner-carretilla-new.png",
      },
      banner_foodservice: {
        title: "Canal<br>Food Service",
        img: "/img/mercados-3.jpg",
        exportacion: {
          titulo: "Exportación",
          cuerpo:
            "Exportamos el <strong>43%</strong> de la facturación a más de <strong>54</strong> países en los <strong>5</strong> continentes.",
        },
      },
    },
    our_history: {
      init_view: {
        title: "Nuestra historia comenzó en <strong>1875</strong>",
        action: "¿Quieres saber cómo sigue?",
      },
      "1875_view": {
        title: "Carretilla, nuestra historia",
        text:
          "<p>Comenzamos en San Adrián (Navarra), trabajando en un pequeño taller artesano en la elaboración de espárragos y verduras en conserva.</p><p>Poco a poco nuestro taller fue creciendo y contribuyendo al desarrollo económico y social de la zona.</p>",
        sub_img: "/img/historia/1875-1.png",
        action: "¡Curiosidad!",
        modal_text:
          "<p class='title'>Las Mujeres en Grupo IAN</p><p> Desde nuestros inicios la mujer jugó un papel muy importante en nuestro desarrollo. Gran parte de nuestra plantilla eran mujeres, algo poco frecuente en esa época.</p><p>¡Gracias a todas!</p><img class='hidde-destop w-100' src='/img/historia/mobile-1875.png'>",
      },
      "1975_view": {
        title: "Nuestro nacimiento",
        text_1:
          "<p>Nuestra fundación como Grupo IAN surgió a través de una cooperativa de trabajo asociado situada en la localidad de Villafranca (Navarra), creada por un grupo de profesionales y familias agricultoras de la ribera de Navarra.</p>",
        text_2:
          "<p>La empresa se orientó en la elaboración de productos que permitieran mantener el trabajo de las cooperativas durante todo el año, algo poco habitual hasta entonces en el sector conservero, con el objetivo de garantizar el trabajo en el pueblo y así evitar su despoblación.</p>",
        action: "¡Curiosidad!",
        modal_title: "Curiosidad",
        modal_text:
          "<p>Durante los años previos a nuestro nacimiento, registramos la marca de conservas vegetales “La Flor de Navarra” y fue unos años después cuando registramos la marca “La Carretilla” para nuestros espárragos y conservas vegetales.</p><p>Además, conseguimos el título de Empresa Ejemplar como reconocimiento a nuestro comportamiento económico y, sobre todo, social.</p>",
        modal_img: "/img/historia/curiosidad-1975.png",
      },
      "1988_view": {
        title: "Crecemos en el mercado",
        text:
          "<p>En 1988 pasamos a formar parte del Grupo Viscofán. A partir de ese momento comienza un proceso de expansión, iniciado con la incorporación de la Factoría Comaro (en Casas del Monte, Cáceres y Morón de la Frontera, Sevilla), dedicada a la elaboración y comercialización de aceituna de mesa.</p>",
        logo_1: "/img/historia/1988-2.png",
        logo_2: "/img/empresa-comaro.svg",
        sub_img: "/img/historia/1988-1.png",
      },
      "1989_view": {
        title: "Incorporamos Industrias Muerza",
        text:
          "<p>Seguimos creciendo con la adquisición de la empresa Industrias Muerza de San Adrián (Navarra), conocida por ser líder en mermeladas y propietaria de las marcas Carretilla y Bebé.</p><p>Esta última marca, así como la planta productiva de mermeladas, se vendió para invertir en nuestro proyecto de innovación de Platos Listos Carretilla.</p>",
      },
      "1998_view": {
        title: "Líderes en el mercado nacional de espárragos.",
        text:
          "<p>En 1997 se relanza la marca Carretilla a nivel de comunicación, y, en 1998, conseguimos ser líderes del mercado de espárragos.</p>",
        sub_img: "/img/historia/1998-1.png",
        action: "¡ver spot!",
        modal_title: "Spot de televisión",
        modal_iframe: "https://www.youtube.com/embed/AwUwFdfGsbk",
      },
      "2005_view": {
        title: "Lanzamiento de los Nuevos Platos Listos Carretilla",
        text:
          "<p>A lo largo de 2005, seguimos innovando en nuevas propuestas de productos y platos preparados de la marca Carretilla.</p><p>Gracias a estas recetas de sabor natural e intenso, hoy somos líderes en el mercado nacional de Platos Preparados Ambiente en envase microondable y de Ensaladas Ambiente.</p>",
        sub_img: "/img/historia/2004-1.png",
      },
      "2015_view": {
        title: "Somos parte de Portobello Capital e incorporamos Taboada",
        text:
          "<p>En el año 2015, nuestro grupo fue adquirido por Portobello Capital, Sociedad de inversión española con amplia experiencia de éxito en el mercado alimentario. </p><p>A partir de este momento, comenzamos una estrategia de crecimiento con la integración de nuevas empresas. La primera de ellas en unirse fue Taboada, una compañía de larga tradición en el sector de conservas vegetales ubicada en Funes (Navarra).</p>",
        logo_1: "/img/historia/2015-2.svg",
        logo_2: "/img/empresa-taboada.svg",
      },
      "2016_view": {
        title: "Productos Noreñenses se une al grupo",
        text:
          "<p>La empresa Productos Noreñenses, S.L., referente en platos preparados cárnicos y legumbres basados en la cocina casera de siempre, principalmente asturiana, y situada en Noreña (Asturias), pasó a formar parte del grupo en este año.</p><p>Esta compañía, de larga tradición y referente en el sector, ampliaba y complementaba el catálogo de productos en formato lata de Grupo Alimentario IAN.</p>",
        logo_1: "/img/historia/logo-norenense.svg",
        sub_img: "/img/historia/2016-1.png",
        sub_title: "Platos Bien Cocinados",
      },
      "2020_view": {
        background: "/img/historia/libro-historia-completo.png",
        title: "¡Carretilla cumple 145 años!",
        text:
          "<p>En 2020 celebramos el 145 aniversario de nuestra emblemática marca Carretilla.</p><p>Actualizamos y renovamos su logotipo con una nueva imagen, consiguiendo el premio Best Awards 2020 en la categoría Best Branding: Packaging.</p><p>Coincidiendo con la pandemia por Covid-19, en Grupo Alimentario IAN reforzamos nuestro compromiso socioeconómico por medio de diversas políticas RSC.</p><p>Inauguramos en este año nuevas oficinas corporativas del grupo, situadas en el Polígono Berroa de Tajonar – Pamplona.</p> <img class='hidde-destop img-video-2020' src='/img/historia/mobile-historia-2020.png'>",
        link: "https://www.youtube.com/watch?v=D8wLZoTncHU",
      },
      "2021_view": {
        title: "Seguimos apostando por la Innovación",
        text:
          "<p>En Grupo Alimentario IAN seguimos apostando firmemente por la innovación, participando en distintos proyectos y ofreciendo nuevos productos con el objetivo de satisfacer las demandas y necesidades de todas nuestras personas consumidoras, desde niños y mayores, hasta otros públicos como las personas celíacas, vegetarianas o veganas.</p>",
      },
      "2023_view": {
        sub_img_1: "/img/historia/circle_2023.svg",
        title: "Plan de Sostenibilidad y RSC del grupo",
        text:
          "<p>Hemos desarrollado nuestro I Plan de Sostenibilidad de Grupo Alimentario IAN 2022-2026, involucrando a todas los órganos y áreas de nuestra entidad y estableciendo palancas de acción y transformación en tres ejes estratégicos en los que ya trabajamos: el Compromiso con el Medioambiente, el Compromiso con las Personas y el Compromiso con las Buenas Prácticas.</p>",
        sub_img_2: "/img/historia/images-sostenibilidad.png",
      },
      "2024_view": {
        title: "¡Seguimos creciendo!",
        text:
          "<p>La empresa Internacional Olivarera, S.A, (Interoliva), ubicada en Dos hermanas (Sevilla) y dedicada desde 1898, a la producción, envasado y comercialización de aceitunas, pasa a formar parte de Grupo Alimentario IAN este año 2024.</p>",
        logo_1: "/img/historia/interoliva-logo.svg",
        sub_img: "/img/historia/2024-1.png",
        text_img: "¡Aceitunas verdes de mesa!",
      },
      "2025_view": {
        title: "Este año Grupo Alimentario IAN, tiene mucho que celebrar:",
        text:
          "Nuestra marca Carretilla cumple 150 años y #NoEsCasualidad…</p><p>Es Tradición, es Calidad, es Naturalidad, es Sabor, es Innovación…es nunca dejar de sorprender a las personas que están a nuestro lado.</p><p>Además, conmemoramos el 50 aniversario de la inauguración de la fábrica de Industrias Alimentarias de Navarra, en Villafranca (Navarra).",
        btn: "¡Descúbre nuestra historia!",
        logo_1: "/img/historia/ian50.svg",
      },
    },
    projects_grants_subsidies: {
      title: "Proyectos, Ayudas y Subvenciones",
      main_banner: {
        img: "/img/intro-proyectos.jpg",
        text:
          "<p>Participamos en <strong>distintos proyectos</strong> relacionados con la I+D+i, tanto<strong> nacionales</strong> como <strong>internacionales</strong>, para ofrecer nuevos productos adaptados a las demandas y necesidades de nuestros clientes y personas consumidoras.</p>",
        sub_text:
          "<p class='paragraph waypoints'>A continuación se presentan las ayudas y subvenciones que Grupo Alimentario IAN ha recibido para el desarrollo de diferentes proyectos llevados a cabo en sus plantas.</p>",
      },
      btn_more_info: "Más información",
    },
    projects_rsc: {
      title: "Proyectos RSC",
      main_banner: {
        img: "/img/intro-proyectos-rsc.jpg",
        title: "Iniciativas",
        text:
          "<p>Desde Grupo Alimentario IAN desarrollamos iniciativas relacionadas con el compromiso social y económico para contribuir al impulso de nuestro entorno y comunidades en las que estamos presentes.</p>",
      },
      filters: {
        default_opt: "Todas las categorías",
        btn_text: "Buscar",
      },
      result_projects: {
        not_result: "No hay resultados para la búsqueda",
        show_project: "Ver proyecto",
      },
    },
    project_rsc_details: {
      btn_back: "Volver",
      share: "Compartir",
      tips: "Te puede interesar",
    },
    about_us: {
      title: "¿Quiénes Somos?",
      main_banner: {
        img: "/img/intro-quienes-somos.jpg",
        imgMobile: "/img/intro-quienes-somos_responsive.jpg",
        title: "¡Somos referentes!",
        text:
          "<p><strong>Grupo Alimentario IAN</strong> (Industrias Alimentarias de Navarra) somos la compañía de alimentación referente y pionera en la elaboración de una amplia variedad de <strong>conservas vegetales y platos preparados</strong> en ambiente.</p>",
      },
      groupIAN_banner: {
        img: "/img/banner-sobre-nosotros.jpg",
        title: "Sobre Grupo IAN",
        text:
          "<p>Nuestro trabajo se desarrolla en las oficinas centrales de <strong>Grupo Alimentario IAN</strong> (Tajonar, Navarra ) así como en las principales plantas productivas del grupo: <strong>IAN</strong> (Villafranca, Navarra), <strong>IAN Aceitunas</strong> (Casas del Monte, Cáceres y Morón de lafrontera, Sevilla), <strong>Taboada</strong> (Funes, Navarra), <strong>Productos Noreñenses</strong> (Noreña, Asturias) e <strong>Interoliva</strong> (Dos Hermanas, Sevilla).</p><p>Damos servicio a los mercados de Gran Consumo, Food Service, Venta Industrial, así como Marcas de Distribución y Entidades Terceras, tanto para el mercado nacional como internacional.</p>",
      },
      history_banner: {
        title: "Carretilla,<br> desde 1875",
        text:
          "<p>Con <strong>más 145 años de historia</strong>, nuestra marca más emblemática, Carretilla, nos ha llevado a ser líderes nacionales en el mercado de espárragos y platos preparados ambiente en envase microondable.</p><p><a href='https://www.carretilla.info/' class='enlace-flecha' target='_blank'>VISITAR LA WEB</a></p>",
        img1: "/img/quienes-somos-1.jpg",
        img2: "/img/quienes-somos-2.jpg",
      },
      markets_banner: {
        title: "Mercados",
        text:
          "<p>Desde Grupo Alimentario IAN damos respuesta personalizada a los Mercados de <strong>Gran Consumo, Food Service, Venta Industrial, así como Marcas de Distribución y de Entidades Terceras, tanto para el mercado nacional como internacional.</strong> Gracias a nuestra amplia experiencia y nuestro potente departamento de I+D+i damos respuesta a las necesidades concretas de cada mercado y cada cliente en cuanto a recetas, formatos, marcas, etc.</p>",
        large_consumption: {
          img: "/img/mercados-1.jpg",
          title: "Gran Consumo",
          text:
            "<p>A la vanguardia de la innovación, elaboramos para el mercado de gran consumo, una variedad de productos alimenticios de calidad orientados a satisfacer las actuales demandas de la sociedad.</p>",
        },
        distribution_entities: {
          img: "/img/mercados-2.jpg",
          title: "Marcas de Distribución y Entidades Terceras",
          text:
            "<p>Elaboramos productos y recetas personalizadas para Marcas de Distribución y Entidades Terceras.</p>",
        },
        food_service: {
          img: "/img/mercados-3.jpg",
          title: "Food Service",
          text:
            "<p>Con el propósito de ayudar a profesionales de la restauración en su día a día y rentabilizar su negocio, ofrecemos una gran variedad de soluciones culinarias a través de nuestras diferentes marcas y productos.</p><a target='_blank' href='https://rfh.grupoian.com/' class='flecha-white'>Saber más</a>",
        },
        industrial_sales: {
          img: "/img/mercados-4.jpg",
          title: "Venta industrial",
          text:
            "<p>Fabricamos productos específicos en formatos industriales que son utilizados, más adelante, como ingredientes en los productos de nuestros clientes.</p>",
        },
      },
    },
    innovacion: {
      title: "Innovación",
      main_banner: {
        img: "/img/intro-innovacion.jpg",
        title: "¡A la vanguardia de la innovación!",
        text:
          "<p>La innovación, uno de nuestros principales valores y pieza clave de nuestra cultura.</p>",
      },
      security_banner: {
        title: "Seguridad Alimentaria",
        text:
          "<p>Fabricamos bajo <strong>estrictos estándares de calidad</strong> y seguridad alimentaria, alcanzando el <strong>máximo nivel de excelencia</strong> y cumpliendo con los estándares más exigentes, tanto a nivel nacional como internacional.</p>",
        img1: "/img/innovacion-4.jpg",
        img2: "/img/innovacion-2.jpg",
        img3: "/img/innovacion-3.jpg",
      },
      innovation: {
        img: "/img/imagen-idi.jpg",
        title: "Innovación e I+D+i",
        text:
          "<p>Contamos con un equipo de Investigación, Desarrollo e Innovación multidisciplinar que ha conseguido implantar una <strong>cultura de innovación</strong> en todas nuestras plantas.</p>",
      },
    },
    quality_security: {
      title: "Calidad y Seguridad Alimentaria",
      main_banner: {
        img: "/img/intro-calidad.jpg",
        title: "Calidad y Seguridad Alimentaria",
        text:
          "<p>Tenemos un firme compromiso con el riguroso cumplimiento de las normas nacionales e internacionales relacionadas con la salud e higiene, así como los requisitos de las certificaciones más exigentes para garantizar la calidad en la elaboración de todos nuestros productos.</p>",
      },
      security_banner: {
        title: "Seguridad Alimentaria",
        text:
          "<p>Fabricamos bajo <strong>estrictos estándares de calidad</strong> y seguridad alimentaria, alcanzando el <strong>máximo nivel de excelencia</strong> y cumpliendo con los estándares más exigentes, tanto a nivel nacional como internacional.</p>",
        img1: "/img/seguridad-1.jpg",
        img2: "/img/seguridad-2.jpg",
        img3: "/img/seguridad-3.jpg",
      },
      innovation: {
        img: "/img/imagen-idi.jpg",
        title: "Innovación e I+D+i",
        text:
          "<p>Contamos con un equipo de Investigación, Desarrollo e Innovación multidisciplinar que ha conseguido implantar una <strong>cultura de innovación</strong> en todas nuestras plantas.</p><p>Realizando <strong>inversiones en I+D+i superiores a la media nacional</strong>, navarra y europea.</p>",
      },
    },
    purpose_vision_values: {
      title: "Propósito, Visión y Valores",
      main_banner: {
        img: "/img/intro-proposito.jpg",
        title: "Somos Grupo Alimentario IAN",
        text:
          "<p>Nuestros valores, lo que somos, hacemos y lo que queremos ser, marcan el rumbo de nuestro grupo y definen nuestro propósito, el por qué y el para qué de nuestra existencia.</p>",
      },
      purpose_banner: {
        title: "Propósito",
        text:
          "<p>Tenemos un firme propósito que nos inspira y nos guía: <strong> crecer siendo sostenibles</strong>, desde la honestidad, desde la humildad, desde la equidad, desde el respeto y desde la solidaridad. Construyendo grandes cambios, a partir de pequeñas acciones alineadas a los Objetivos de Desarrollo Sostenible.</p><p>En base a nuestro compromiso con la sociedad, ponemos al alcance de nuestros clientes y personas consumidoras una <strong> amplia variedad de productos de alimentación de máxima calidad y seguridad</strong>, contribuyendo a que las personas tengan una alimentación más sana y equilibrada y haciéndoles más fácil su día a día.</p>",
        img1: "/img/banner-proposito-1-qs.jpg",
        img2: "/img/banner-proposito-2.jpg",
        img3: "/img/banner-proposito-3.jpg",
      },
      vision_banner: {
        img: "/img/imagen-vision.jpg",
        title: "Visión",
        text:
          "<p>Trabajamos para seguir siendo una compañía reconocida, <strong>referente y pionera en el ámbito de la alimentación</strong> por parte de personas consumidoras, plantilla, clientes, empresas proveedoras, propiedad y por la sociedad en general. Todo ello a través de la <strong>permanente innovación</strong>, el <strong>aseguramiento de la calidad</strong> de nuestros productos y el <strong>desarrollo sostenible</strong> para contribuir a un futuro mejor.</p>",
      },
      circles_banner: {
        title: "Valores y Principios Estratégicos",
        text:
          "<p>Desde la fundación de Grupo Alimentario IAN, los principios y valores que nos guían son <strong>la excelencia, la calidad, la naturalidad y la innovación.</strong> Tenemos un firme compromiso con el desarrollo de nuestra actividad de forma ética, responsable y transparente y trabajamos en favor de una economía generadora de valor, empleo y bienestar, así como de una sociedad sostenible allá donde estemos presentes.</p>",
        circles: {
          0: {
            id: "calidad",
            title: "Calidad e Innovación",
            text:
              "En grupo IAN realizamos inversiones en I+D+i superiores a la media nacional, navarra y europea. Todas nuestras plantas tienen la certificación IFS.",
          },
          1: {
            id: "marca-carretilla",
            title: "Carretilla",
            text:
              "Carretilla, marca centenaria desde 1875, es reconocida por su calidad, naturalidad y confianza, siendo una simbiosis entre tradición e innovación.",
          },
          2: {
            id: "persona",
            title: "EQUIPO HUMANO",
            text:
              '<span><i class="fa-solid fa-check"></i> Promoción y desarrollo de las personas y de su talento. </span><br> <span><i class="fa-solid fa-check"></i> Creación de un ambiente de trabajo inclusivo, colaborativo y positivo.</span>',
          },
          3: {
            id: "produccion",
            title: "Centros de producción especializados",
            text:
              "Cada factoría del Grupo está especializada por productos y son autónomas. I+D+i logra sinergias implantando mejoras comunes.",
          },
          4: {
            id: "vocacion",
            title: "Vocación Internacional",
            text:
              "En Grupo IAN exportamos el 43% de nuestra facturación a clientes en los 5 continentes.",
          },
          5: {
            id: "sostenibilidad",
            title: "Sostenibilidad",
            text:
              "Nuestro Plan de Sostenibilidad y RSC establece tres ejes estratégicos: el Compromiso con el Medioambiente, el Compromiso con las Personas y el Compromiso con las Buenas Prácticas.",
          },
          6: {
            id: "dimension",
            title: "Dimensión y desarrollos a medida del cliente",
            text:
              "La gran capacidad de nuestras plantas nos permite importantes acuerdos con la Distribución y Entidades Terceras con desarrollos a medida.",
          },
        },
      },
    },
    our_brands: {
      title: "Carretilla | Nuestras marcas",
      main_banner: {
        text:
          "<p>Contamos con diversas marcas que comercializamos tanto en el mercado nacional como exterior, entre las que destaca Carretilla, líder del mercado nacional de Espárragos, Pimientos, así como de Platos Preparados ambiente en envase microondable.</p>",
        img: "/img/intro-nuestras-marcas.jpg",
      },
      history_banner: {
        title: "Carretilla, desde 1875",
        text:
          "<p><strong>Espárrragos, Conservas Vegetales y Platos Preparados</strong></p><p>Desde 1875 innovamos día a día para ofrecer productos de máxima calidad adaptados al estilo y ritmo de vida actual. Gracias al reconocimiento de personas consumidoras, hoy Carretilla es líder nacional reconocida por la calidad de sus productos.</p>",
        img: "/img/imagen-banner-carreta.jpg",
        btn_text: "Visitar la web",
      },
      other_brands_banner: {
        title: "Otras Marcas del Grupo",
        categories: [
          {
            id: "salsas-tomate",
            name: "Salsas de Tomate y Derivados",
            slug: "salsas-tomate",
            dropdown: {
              title: "IAN",
              text:
                "<p>Con una larga experiencia de casi <strong>50 años en la elaboración de tomate</strong>, seleccionamos los frutos y cuidamos su preparación para mantener su sabor, aroma y textura. Así nace nuestra gama de <strong>Tomates IAN</strong>, que se diferencian por su sabor totalmente natural, sin conservadores ni espesantes. Una amplia gama de salsas de tomate para cubrir todos los usos tanto en el hogar como en hostelería.</p>",
            },
          },
          {
            id: "esparragos",
            name: "Espárragos y<br>Conservas Vegetales",
            slug: "esparragos",
            dropdown: {
              title: "Alesves",
              text:
                "<p>Distribuimos <strong>espárragos en conserva, tomate triturado, frito y salsas</strong> a través de nuestra marca Alesves.</p><p>En concreto, nuestros espárragos Alesves son especiales para Food Service y reconocidos por su inconfundible sabor, color blanco y textura tierna, sin hebras.</p>",
            },
          },
          {
            id: "aceitunas-2",
            name: "Aceitunas",
            slug: "aceitunas",
            dropdown: {
              title: "Comaro y Morenita",
              text:
                "<p>Desde 1988 procesamos <strong>aceitunas verdes y negras</strong> en nuestra planta de COMARO en la provincia de Cáceres y de Sevilla (Extremadura y Andalucía respectivamente), para su exportación a más de 50 países en todo el mundo.</p>",
            },
          },
          {
            id: "platos-en-lata",
            name: "Platos Preparados en Lata",
            slug: "platos-en-lata",
            dropdown: {
              title: "La Noreñense y El Yantar de Pepe",
              text:
                "<p><strong>EL YANTAR DE PEPE</strong></p><p>Con nuestra marca Gourmet, comercializada en tiendas especializadas, elaboramos <strong>recetas basadas en la cocina casera asturiana</strong>, cuyo proceso de producción se realiza con la tecnología más puntera y respetando los controles de calidad más exhaustivos.</p><p>Nuestras referencias de Fabada Asturiana y Pote Asturiano se elaboran con fabas de la Indicación Geográfica Faba Asturiana.</p><p></br><strong>LA NOREÑENSE</strong></p><p>Ofrecemos un amplio catálogo de <strong>productos para el mercado de gran consumo</strong>, bajo un estricto control de calidad en su elaboración, sin potenciadores, ni conservadores, elaborados con base de cerdo, pollo, vacuno, pescado y vegetal.</p>",
            },
          },
          {
            id: "salsas-tomate-verduras-legumbres",
            name: "Tomate, Verduras<br>y Legumbres",
            slug: "salsas-tomate-verduras-legumbres",
            dropdown: {
              title: "Taboada",
              text:
                "<p>Bajo esta marca ofrecemos un extenso catálogo de productos, entre los que destacan las conservas de <strong>tomate y salsas, legumbre cocida y verduras</strong>, dirigidas principalmente al mercado exterior y de Food Service.</p>",
            },
          },
          {
            id: "aceitunas",
            name: "Aceitunas de mesa",
            slug: "aceitunas",
            dropdown: {
              title: "Marios y Marismas",
              text:
                "<p>En nuestra planta de Interoliva, ubicada en Dos hermanas (Sevilla) <strong>cuna de la aceituna de mesa</strong>, nos dedicamos desde 1898 a la <strong>producción, envasado y comercialización</strong> de aceitunas, principalmente verde con las variedades Gordal y Manzanilla, través de nuestras marcas <strong>Mario´s</strong> y <strong>Marismas</strong></p>",
            },
          },
        ],
      },
      contact_banner: {
        img: "/img/banner-hablamos.jpg",
        title: "MDD y marcas de Entidades Terceras",
        text:
          "<p><strong>Nos adaptamos a tus necesidades</strong></p><p>Nuestros años de experiencia, especialización y flexibilidad nos permite trabajar y desarrollar de manera personalizada las soluciones, recetas y formatos que más se adecúen a tus necesidades.</p>",
        btn_text: "Contacta aquí",
      },
      carretilla_150: {
        title: "Cumplir 150 años,",
        text:
          "<p><strong>No es Casualidad…</strong></p><p>Es Tradición, es Calidad, es Naturalidad, es Sabor, es Innovación… es nunca dejar de sorprender a las personas que están a nuestro lado.</p>",
        img: "/img/imagen-banner-carreta-150.jpg",
        btn_text: "Visitar la web",
      },
    },
    companies_group: {
      title: "Plantas del Grupo",
      main_banner: {
        text:
          "<p>Cada una de nuestras plantas productivas cuenta con una trayectoria propia y gracias a ellas, Grupo Alimentario IAN se ha consolidado como referente en el sector alimentario español.</p>",
      },
      companies: [
        {
          id: "ian",
          history_banner: {
            title: "IAN",
            text:
              "<p>En la planta de IAN situada en Villafranca (Navarra) elaboramos diferentes <strong>conservas vegetales, platos preparados en envase microondable, tomates y salsas.</strong></p>",
            certifications_slug: "ian",
            btn_text: "Ver certificaciones",
            img1: "/img/empresa-grupo-carretilla.jpg",
            img2: "/img/empresa-grupo-carretilla-1.jpg",
            img3: "/img/empresa-grupo-carretilla-2.jpg",
          },
          company_banner: {
            title: "Planta Productiva",
            text: "Villafranca - Navarra, España",
            img1: "/img/imagen-somos-carretilla-1.jpg",
            img2: "/img/imagen-somos-carretilla-2.jpg",
            img3: "/img/imagen-somos-carretilla-3.jpg",
          },
        },
        {
          id: "ian-aceitunas",
          history_banner: {
            title: "IAN Aceitunas",
            text:
              "<p>En la planta de IAN Aceitunas, con sede en Casas del Monte (Cáceres) y Morón de la Frontera (Sevilla), nos dedicamos al aderezo, envasado y comercialización de aceituna de mesa a través de nuestras propias marcas <strong>Carretilla, Morenita y Comaro</strong>, además de contar con un alto grado de especialización en el desarrollo de marcas blancas.</p><p>Para elaborar nuestras <strong>aceitunas de mesa negras y verdes</strong> contamos con un equipo humano con amplia experiencia y la tecnología más moderna del sector. Además, <strong>manufacturamos aceitunas en distintas presentaciones</strong> para todos los gustos y necesidades, ya sean enteras, deshuesadas, en rodajas, en gajos, en mitades, etc., y envasadas por ejemplo en formato lata, vidrio, etc. y en distintos tamaños.</p>",
            certifications_slug: "ian-aceitunas",
            btn_text: "Ver certificaciones",
            img1: "/img/empresa-grupo-comaro.jpg",
            img2: "/img/empresa-grupo-comaro-1.jpg",
            img3: "/img/empresa-grupo-comaro-2.jpg",
          },
          company_banner: {
            title: "Plantas Productivas",
            text:
              "<p>Casas del Monte - Cáceres, España</p><p>Morón de la Frontera - Sevilla, España</p>",
            img1: "/img/imagen-somos-comaro-1.jpg",
            img2: "/img/imagen-somos-comaro-2.jpg",
            img3: "/img/imagen-somos-comaro-3.jpg",
          },
        },
        {
          id: "taboada",
          history_banner: {
            title: "Taboada",
            text:
              "<p>En esta planta ubicada en Funes (Navarra) con más de 60 años de trayectoria, nos dedicamos a la elaboración de <strong>conservas vegetales y de legumbres de calidad</strong>, como alubias, lentejas, garbanzos o tomate preparado en distintos formatos. A través de Taboada somos referentes en dar soluciones alimentarias para Food Service y Colectividades en el mercado exterior.</p>",
            certifications_slug: "taboada",
            btn_text: "Ver certificaciones",
            img1: "/img/empresa-grupo-taboada.jpg",
            img2: "/img/empresa-grupo-taboada-1.jpg",
            img3: "/img/empresa-grupo-taboada-2.jpg",
          },
          company_banner: {
            title: "Planta Productiva",
            text: "<p>Funes - Navarra, España</p>",
            img1: "/img/imagen-somos-taboada-1.jpg",
            img2: "/img/imagen-somos-taboada-2.jpg",
            img3: "/img/imagen-somos-taboada-3.jpg",
          },
        },
        {
          id: "norenense",
          history_banner: {
            title: "La Noreñense",
            text:
              "<p>Nuestra planta de La Noreñense, es referente en el sector de <strong>platos preparados en formato lata con base cárnica y legumbres</strong>, y está ubicada en Noreña (Asturias).</p><p>Sus comienzos se remontan al <strong>año 1966</strong> con la aparición de los platos enlatados, una <strong>tecnología muy novedosa</strong> en aquella época. Esta innovación llegó a manos de tres amigos fabricantes de embutidos en la Villa de Noreña, quienes empezaron a trabajar en la producción de fabada y callos, siendo el comienzo de nuestra marca La Noreñense.</p>",
            certifications_slug: "norenense",
            btn_text: "Ver certificaciones",
            img1: "/img/empresa-grupo-norenense.jpg",
            img2: "/img/empresa-grupo-norenense-1.jpg",
            img3: "/img/empresa-grupo-norenense-2.jpg",
          },
          other_history_banner: {
            img: "/img/banner-empresa-norenense.jpg",
            text:
              " <p> Tres años después, en febrero de 1969, se fundó de manera oficial la empresa Productos Noreñenses con dos socios al frente. Durante la época de los años 70, la marca contaba con una plantilla de 14 trabajadores y fue incorporando nuevas referencias de cocido, manos de cerdo y lomo. Con la llegada de los años 80, la fábrica experimentó un <strong>proceso de modernización y ampliación de sus instalaciones</strong>.</p>",
            tetx_view_more:
              "<p>De este modo, afianzó su apuesta por los <strong>platos preparados</strong>, lo que le permitió adentrase a nuevos mercados nacionales e internacionales. Durante la década de los 90 se produjo una nueva ampliación de la fábrica, momento en el que se lanzó la <strong>línea gourmet</strong> de la compañía, El Yantar de Pepe. En el año 2016 se produjo un punto de inflexión en la historia de Productos Noreñense y pasó a integrarse dentro de Grupo Alimentario IAN. Adicionalmente a su gama de productos y marcas propias y de entidades terceras, se lanzó la gama de platos preparados en lata con marca Carretilla. Actualmente en esta planta elaboramos una amplia gama de platos preparados enlatados, con base de cerdo, pollo, vacuno, pescado, vegetal y legumbres que distribuimos principalmente en el mercado nacional.</p>",
            btn_text_more: "Ver más",
            btn_text_less: "Ver menos",
          },
          video_banner: {
            title: "¡Conoce nuestra historia!",
            link: "https://www.youtube.com/watch?v=FOKiKdhJdGk",
          },
          company_banner: {
            title: "Planta Productiva",
            text: "<p>Noreña - Asturias, España</p>",
            img1: "/img/imagen-somos-norenense-1.jpg",
            img2: "/img/imagen-somos-norenense-2.jpg",
            img3: "/img/imagen-somos-norenense-3.jpg",
          },
        },
        {
          id: "interoliva",
          history_banner: {
            title: "Interoliva",
            text:
              "<p>En nuestra planta de Interoliva, ubicada en Dos hermanas (Sevilla) <strong>cuna de la aceituna de mesa</strong>, nos dedicamos <strong>desde 1898</strong> a la <strong>producción, envasado y comercialización</strong> de aceitunas, principalmente verde con las variedades Gordal y Manzanilla, través de nuestras marcas <strong>Mario´s y Marismas</strong> .</p>",
            certifications_slug: "interoliva",
            btn_text: "Ver certificaciones",
            img1: "/img/empresa-grupo-interoliva.jpg",
            img2: "/img/empresa-grupo-interoliva-1.jpg",
            img3: "/img/empresa-grupo-interoliva-2.jpg",
          },
          company_banner: {
            title: "Planta Productiva",
            text: "<p>Dos Hermanas – Sevilla, España</p>",
            img1: "/img/imagen-somos-interoliva-1.jpg",
            img2: "/img/imagen-somos-interoliva-2.jpg",
            img3: "/img/imagen-somos-interoliva-3.jpg",
          },
        },
      ],
    },
    export: {
      title: "Exportación",
      groupIAN_banner: {
        img: "/img/banner-sobre-nosotros-exportacion.jpg",
        title: "Sobre Grupo IAN",
        text:
          "<p>En Grupo Alimentario IAN tenemos vocación por llevar nuestros productos más allá de nuestras fronteras, lo que nos lleva a ser <strong>uno de los grupos españoles con mayor presencia internacional. Exportamos nuestros productos a más de 54 países,</strong> entre los que destacan Alemania, Francia, Estados Unidos, Canadá, Australia y Japón. En definitiva, como referentes en <strong>Conservas Vegetales y pioneros en Platos Preparados Ambiente</strong>, nos esforzamos en hacer llegar a todas las personas consumidoras propuestas de alimentación saludables y de calidad allí donde se encuentren. Además de nuestras conservas vegetales, contamos con un amplio catálogo de Platos Preparados, basados en recetas de nuestra gastronomía reconocidas a nivel internacional, como Fabada Asturiana o Paella Valenciana.",
        btn_text: "CONOCE MÁS",
      },
      in_the_world_banner: {
        title: "Grupo IAN, en el mundo",
        text:
          "<p>El 46% de nuestra facturación proviene de la exportación de productos fuera de España, llegando a los cinco continentes. Todos nuestros productos son adaptables para que los clientes y mercados a los que abastecemos puedan incorporar fácilmente sus marcas y se encuentran disponibles en distintos envases adecuados para cada necesidad.</p>",
        img1: "/img/banner-proposito-1.jpg",
        img2: "/img/bol-aceitunas.jpg",
        img3: "/img/bodegon-frasco-esparragos.jpg",
        img4: "/img/banner-proposito-4.jpg",
        img5: "/img/banner-proposito-5.jpg",
      },
      branding_banner: {
        img: "/img/banner-creamos-tu-marca.jpg",
        title: "Creamos tu marca",
        text:
          "<p>Además de llevar nuestros propios productos a distintos países, contamos con una <strong>amplia experiencia en la elaboración de marcas blancas</strong> para diversos clientes. De esta manera, les ofrecemos la posibilidad de elaborar su propia marca a través de nuestra producción, ya sean marcas de importador como de la distribución, y en los cinco continentes.</p>",
      },
      circles_banner: {
        title: "Valores y Principios Estratégicos",
        text:
          "<p>Desde la fundación de Grupo Alimentario IAN, los principios y valores que nos guían son <strong>la excelencia, la calidad, la naturalidad y la innovación.</strong> Tenemos un firme compromiso con el desarrollo de nuestra actividad de forma ética, responsable y transparente y trabajamos en favor de una economía generadora de valor, empleo y bienestar, así como de una sociedad sostenible allá donde estemos presentes.</p>",
        circles: {
          0: {
            id: "calidad",
            title: "Innovación y Calidad",
            text:
              "En grupo IAN realizamos inversiones en I+D+i superiores a la media nacional, navarra y europea. Todas nuestras plantas tienen la certificación IFS.",
          },
          1: {
            id: "marca-carretilla",
            title: "Marca Carretilla",
            text:
              "Carretilla, marca centenaria desde 1875, es reconocida por su calidad, naturalidad y confianza, siendo una simbiosis entre tradición e innovación.",
          },
          2: {
            id: "produccion",
            title: "Centros de producción especializados",
            text:
              "Cada factoría del Grupo está especializada por productos y son autónomas. I+D+i logra sinergias implantando mejoras comunes.",
          },
          3: {
            id: "vocacion",
            title: "Vocación Internacional",
            text:
              "En Grupo IAN exportamos el 43% de nuestra facturación a clientes en los 5 continentes.",
          },
          4: {
            id: "sostenibilidad",
            title: "Sostenibilidad",
            text:
              "Nuestro Plan de Sostenibilidad y RSC establece tres ejes estratégicos: el Compromiso con el Medioambiente, el Compromiso con las Personas y el Compromiso con las Buenas Prácticas.",
          },
          5: {
            id: "dimension",
            title: "Dimensión y desarrollos a medida del cliente",
            text:
              "La gran capacidad de nuestras plantas nos permite importantes acuerdos con la Distribución y Entidades Terceras con desarrollos a medida.",
          },
        },
      },
      form: {
        title: "¿Hablamos?",
        text:
          "<p><strong>Si deseas realizar cualquier consulta o necesitas información sobre Grupo Alimentario IAN puedes hacerlo a través de este formulario de contacto.<strong></p>",
      },
    },
    certifications: {
      title: "Certificaciones",
      text:
        "<p>En Grupo IAN fabricamos bajo estándares de calidad y seguridad alimentaria, cumpliendo con los estándares de calidad más exigentes, tanto a nivel nacional como internacional.</p>",
      brands: {
        group_ian: {
          id: "ian",
          facilities: [
            {
              title:
                "<p>Planta Productiva | Villafranca - Navarra, España</p><p>Platos preparados en envases microondables</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text:
                    "<p>Certificado IFS<br>Calidad y Seguridad Alimentaria</p>",
                },
                {
                  img: "/img/logo-AAI.png",
                  text: "<p>AAI Autorización Ambiental Integrada</p>",
                },
                {
                  img: "/img/logo-ecologico.png",
                  text: "<p>Certificado Producto Ecológico</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>Registro FDA</p>",
                },
                {
                  img: "/img/logo-reconcilia.png",
                  text: "<p>Sello Reconcilia</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>Certificado SAE</p>",
                },
              ],
            },
            {
              title:
                "<p>Planta Productiva | Villafranca - Navarra, España</p><p>Tomates y Salsas</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text:
                    "<p>Certificado IFS<br>Calidad y Seguridad Alimentaria</p>",
                },
                {
                  img: "/img/logo-AAI.png",
                  text: "<p>AAI Autorización Ambiental Integrada</p>",
                },
                {
                  img: "/img/logo-ecologico.png",
                  text: "<p>Certificado Producto Ecológico</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>Registro FDA</p>",
                },
                {
                  img: "/img/logo-reconcilia.png",
                  text: "<p>Sello Reconcilia</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>Certificado SAE</p>",
                },
              ],
            },
          ],
        },
        'ian-aceitunas': {
          id: "ian-aceitunas",
          facilities: [
            {
              title:
                "<p>Planta Productiva | Casas del Monte - Cáceres,<br> Morón de la Frontera - Sevilla, España</p><p>Aceitunas</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text:
                    "<p>Certificado IFS<br>Calidad y Seguridad Alimentaria</p>",
                },
                {
                  img: "/img/logo-AAI.png",
                  text: "<p>AAI Autorización Ambiental Integrada</p>",
                },
                {
                  img: "/img/logo-ecologico.png",
                  text: "<p>Certificado Producto Ecológico</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>Registro FDA</p>",
                },
                {
                  img: "/img/logo-orthodox.png",
                  text: "<p>Orthodox Union (Kosher)</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>Certificado SAE</p>",
                },
              ],
            },
          ],
        },
        taboada: {
          id: "taboada",
          facilities: [
            {
              title:
                "<p>Planta Productiva | Funes - Navarra, España</p><p>Tomate, verduras y legumbres</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text:
                    "<p>Certificado IFS<br>Calidad y Seguridad Alimentaria</p>",
                },
                {
                  img: "/img/logo-brc-new.png",
                  text: "<p>Certificado BRC</p>",
                },
              ],
            },
          ],
        },
        norenense: {
          id: "norenense",
          facilities: [
            {
              title:
                "<p>Planta Productiva | Noreña - Asturias, España</p><p>Platos preparados en formato lata</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text:
                    "<p>Certificado IFS<br>Calidad y Seguridad Alimentaria</p>",
                },
                {
                  img: "/img/logo-iso.png",
                  text: "<p>ISO 14000 (Certificación Medioambiental)</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>Certificado SAE</p>",
                },
              ],
            },
          ],
        },
        interoliva: {
          id: "interoliva",
          facilities: [
            {
              title:
                "<p>Planta Productiva | Dos Hermanas – Sevilla, España</p><p>Aceitunas</p>",
              certifications: [
                {
                  img: "/img/logo-brc-new.png",
                  text: "<p>Global Food Safety Standard</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>Registro FDA</p>",
                },
                {
                  img: "/img/logo-orthodox.png",
                  text: "<p>Orthodox Union (Kosher)</p>",
                },
              ],
            },
          ],
        },
      },
      btn_text: "VER PLANTA",
    },
    press_room: {
      title: "Sala de Prensa",
      main_banner: {
        img: "/img/intro-sala-prensa.jpg",
        title: "¡Contáctanos!",
        text:
          "<p>¿Te dedicas al sector de los medios de comunicación? Te ayudaremos en todo lo que necesites conocer sobre Grupo Alimentario IAN.</p>",
      },
    },
    contact: {
      title: "Contacto",
      main_banner: {
        img: "/img/intro-contacto.jpg",
        title: "Grupo Alimentario IAN <span>(Oficinas Centrales)</span>",
        text:
          "<p class='direccion'>Pol. Ind. Berroa. C/ Berroa 13, 1ª planta. 31192, Tajonar (Navarra)</p><p class='telefono'><a href='tel:948843360'>948 84 33 60</a></p><p class='email'><a href='mailto:info@grupoian.com'>info@grupoian.com</a></p>",
      },
      map: {
        title: "Dónde estamos",
        locations: {
          "grupo-ian": {
            id: "grupo-ian",
            slug: "grupo-ian",
            name: "Grupo Alimentario IAN",
            subname: "Oficinas Centrales",
            pos: {
              lat: 42.77302062940062,
              lng: -1.626974947202869,
            },
            address:
              "Pol. Ind. Berroa. C/ Berroa 13, 1ª planta. 31192, Tajonar (Navarra)",
            phone: ["948 84 33 60", "948 84 33 87"],
            email: ["info@grupoian.com"],
          },
          "ian-sau": {
            id: "ian-sau",
            slug: "ian-sau",
            name: "IAN, S.A.U.",
            subname: "(Villafranca)",
            pos: {
              lat: 42.3022871,
              lng: -1.7381284,
            },
            address: "Pol Peñalfons s/n, 31330 Villafranca, Navarra",
            phone: ["948 84 33 60", "948 84 33 87"],
            email: ["info@grupoian.com"],
          },
          'ian-aceitunas': {
            id: "ian-aceitunas",
            slug: "ian-aceitunas",
            name: "IAN Aceitunas",
            subname: "(Casas del Monte)",
            pos: {
              lat: 40.2084173,
              lng: -5.9851828,
            },
            address:
              "Barrio de la estación, s/n – 10730, Casas del Monte (Cáceres)",
            phone: ["927 179 031"],
          },
          "ian-aceitunas-moron": {
            id: "ian-aceitunas-moron",
            slug: "ian-aceitunas-moron",
            name: "IAN Aceitunas",
            subname: "(Morón de la Frontera)",
            pos: {
              lat: 37.1245881,
              lng: -5.4630408,
            },
            address:
              "Carretera A 361 Marchena p k 12, 41530 Morón de la Frontera, (Sevilla)",
            phone: ["673 29 27 54"],
          },
          taboada: {
            id: "taboada",
            slug: "taboada",
            name: "Taboada",
            subname: "(Funes)",
            pos: {
              lat: 42.3340688,
              lng: -1.7895691,
            },
            address: "Ctra.Marcilla, s/n, 31360, Funes (Navarra), España",
            phone: ["948 754 228"],
          },
          norenense: {
            id: "norenense",
            slug: "norenense",
            name: "Productos Noreñense",
            subname: "(Noreña)",
            pos: {
              lat: 43.3912238,
              lng: -5.7167731,
            },
            address: "Avenida de Oviedo, 31, 33180, Noreña, (Asturias)",
            phone: ["958 740 276"],
          },
          interoliva: {
            id: "interoliva",
            slug: "interoliva",
            name: "Interoliva",
            subname: "(Dos Hermanas)",
            pos: {
              lat: 37.293047719427456,
              lng: -5.927835131585038,
            },
            address: "Garcilaso de la Vega 2, 41704, Dos Hermanas (Sevilla)",
            phone: ["955 660 440"],
          },
        },
      },
      form: {
        title: "¿Hablamos?",
        text:
          "<p class='waypoints'><strong>Si deseas realizar cualquier consulta o necesitas información sobre Grupo Alimentario IAN puedes hacerlo a través de este formulario de contacto.</strong></p>",
        inputs: [
          {
            id: "communication_media",
            type: "text",
            rules: "required",
            placeholder: "Medio de Comunicación*",
            middle: 0,
            view: "sala-de-prensa",
          },
          {
            id: "fullname",
            type: "text",
            rules: "required",
            placeholder: "Nombre y Apellidos*",
            middle: 0,
          },
          {
            id: "email",
            type: "text",
            rules: "required|email",
            placeholder: "Email",
            middle: 1,
          },
          {
            id: "phone",
            type: "text",
            rules: "required",
            placeholder: "Teléfono*",
            middle: 1,
          },
          {
            id: "subject",
            type: "text",
            rules: "required",
            placeholder: "Asunto*",
            middle: 0,
          },
          {
            id: "message",
            type: "textarea",
            rules: "required",
            placeholder: "Cuerpo del mensaje*",
            middle: 0,
          },
          {
            id: "privacy",
            type: "checkbox",
            rules: "required",
            label:
              "He leído y acepto la <a style='text-decoration: underline;' href='/es/politica-privacidad' target='_blank'>Política de Privacidad</a>.",
          },
        ],
        legal_text:
          "<p class='legal waypoints'>En cumplimiento de la normativa vigente en materia de protección de datos le informamos que el responsable de sus datos personales es INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U., y los utilizará para atender las solicitudes de información. Este tratamiento está basado en su consentimiento. Los datos personales recabados no serán en ningún caso cedidos a terceros salvo por obligaciones legales expresas. Puede ejercer los derechos que le asisten sobre protección de datos en la dirección info@grupoian.com. Puede consultar información adicional sobre Protección de Datos en este enlace.</p>",
        btn_text: "Enviar",
        success_popup: {
          title: "¡Mensaje recibido!",
          text:
            "<p>Gracias por contactar con Grupo Alimentario IAN.</p><p>Nos pondremos en contacto a la mayor brevedad posible.</p>",
          btn_text: "Volver",
        },
      },
      information_banner: {
        img: "/img/banner-trabaja.jpg",
        title: "Trabaja en Grupo IAN",
        text:
          "<p class='waypoints'>¿Quieres formar parte de nuestro equipo?<br><strong>Buscamos personas como tú.</strong></p>",
        btn_href:
          "https://grupoian.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=1&id_origen=web+corporativa",
        btn_text: "Infórmate aquí",
      },
    },
    commitment: {
      title: "Compromiso IAN",
      main_banner: {
        img: "/img/rsc/banner-intro.jpg",
        btn_img: "/img/rsc/hoja-down.svg",
      },
      objectives_banner: {
        text:
          "<p>En Grupo Alimentario IAN mantenemos un propósito claro que nos inspira y guía:<strong> crecer siendo sostenibles</strong>, desde la honestidad, la humildad, la equidad, el respeto y la solidaridad. Creemos que los grandes cambios comienzan con pequeñas acciones diarias, alineadas con los Objetivos de Desarrollo Sostenible (ODS) de Naciones Unidas.</p><p>Nuestro Plan de Sostenibilidad y RSC 2026-2030, refuerza nuestro compromiso con el entorno y con la sociedad,<strong> ampliando nuestro alcance hacia 14 de los 17 ODS</strong>. De ellos, priorizamos los ODS 2, ODS 3, ODS 6, ODS 7,ODS 8, ODS 12, ODS 13, como objetivos prioritarios a los que enfocar las acciones tácticas de nuestra estrategia.</p><p>Asimismo, contribuimos de forma activa a otros ODS relevantes como el ODS 4, ODS 5, ODS 9, ODS 10, ODS 11, ODS 16 y ODS 17.</p>",
        img: "/img/rsc/grafica-objetivos.svg",
      },
      option_commitments_banner: {
        options: [
          {
            id: "environment",
            img: "/img/rsc/comprometidos-ma.svg",
            imgMobile: "/img/rsc/comprometidos-ma-responsive.svg",
            alt: "Compromiso con el Medioambiente",
          },
          {
            id: "people",
            img: "/img/rsc/comprometidos-personas.svg",
            imgMobile: "/img/rsc/comprometidos-personasa-responsive.svg",
            alt: "Compromiso con las personas",
          },
          {
            id: "good-practice",
            img: "/img/rsc/comprometidosbuenas-practicas.svg",
            imgMobile: "/img/rsc/comprometidosbuenas-practicas-responsive.svg",
            alt: "Compromiso con las buenas prácticas",
          },
        ],
        btn_text: "SABER MÁS",
        img: "/img/rsc/bg-campo.svg",
      },
      commitments: [
        {
          id: "environment",
          img: "/img/rsc/img-medio-ambiente.png",
          alt: "Compromiso con el Medioambiente",
          title:
            "<p class='title'>COMPROMISO<br><span>con el <span class='green'> Medioambiente</span></span></p>",
          icons: [
            {
              img: "/img/rsc/ma-1.svg",
            },
            {
              img: "/img/rsc/ma-2.svg",
            },
            {
              img: "/img/rsc/sello-9.svg",
            },
            {
              img: "/img/rsc/ma-3.svg",
            },
            {
              img: "/img/rsc/ma-4.svg",
            },
          ],
          text:
            "<p>Promovemos y reforzamos el cuidado de nuestro entorno medioambiental.</p>",
          objectives: [
            {
              img: "/img/rsc/eficiencia-energetica.jpg",
              title: "Plan de Eficiencia Energética:<br> Agua y Energía",
              text:
                "<p>Optimizamos el consumo de energía y fomentamos el uso de las renovables.</p>",
            },
            {
              img: "/img/rsc/reduccion-impactos.jpg",
              title: "Plan de Reducción<br>  de Emisiones",
              text:
                "<p>Avanzamos hacia la descarbonización con un plan integral que reduce nuestra huella de carbono e impulsa el uso de energías renovables.</p>",
            },
            {
              img: "/img/rsc/economia-circular.jpg",
              title: "Envases<br>  Sostenibles",
              text:
                "<p>Impulsamos soluciones de envasado con menor impacto ambiental, apostando por materiales biodegradables y fomentando su reciclabilidad.</p>",
            },
          ],
        },
        {
          id: "people",
          img: "/img/rsc/img-personas.png",
          alt: "Compromiso con las personas",
          title:
            "<p class='title'>COMPROMISO<br><span>con las <span class='green'> Personas</span></span></p>",
          icons: [
            {
              img: "/img/rsc/cp-1.svg",
            },
            {
              img: "/img/rsc/cp-2.svg",
            },
            {
              img: "/img/rsc/cp-3.svg",
            },
            {
              img: "/img/rsc/cp-4.svg",
            },
            {
              img: "/img/rsc/sello-8.svg",
            },
            {
              img: "/img/rsc/cp-6.svg",
            },
            {
              img: "/img/rsc/sello-11.svg",
            }
          ],
          text:
            "<p>Involucramos a nuestra plantilla y a la comunidad en una gestión sostenible basada en la comunicación, participación, colaboración y transparencia.</p>",
          objectives: [
            {
              img: "/img/rsc/alimentacion-equilibrada.jpg",
              title: "Alimentación Equilibrada",
              text:
                "<p>Impulsamos una propuesta alimentaria equilibrada y alineada con un estilo de vida saludable, basada en el sabor, la calidad y el respeto a las personas.</p>",
            },
            {
              img: "/img/rsc/hambre-pobreza.jpg",
              title: "Compromiso Social y Vínculo con el Entorno",
              text:
                "<p>Desde el compromiso social, impulsamos acciones solidarias, colaboramos con entidades sociales y apoyamos el desarrollo local, social y cultural.</p>",
            },
            {
              img: "/img/rsc/integridad.jpg",
              id: "integridad",
              title: "Talento, Inclusión y Desarrollo Profesional",
              text:
                "<p>Impulsamos un entorno estable e inclusivo, que reconoce el talento y apuesta por la formación y la integración de las personas.</p>",
            },
            {
              img: "/img/rsc/personas-empleadas.jpg",
              title: "Seguridad y Salud de la Plantilla",
              text:
                "<p>Promovemos un entorno laboral seguro y saludable, impulsando medidas de prevención y bienestar que contribuyen a proteger la salud de toda la plantilla.</p>",
            },
            {
              img: "/img/rsc/bienestar-beneficios-sociales.jpg",
              title: "Bienestar y Beneficios Sociales",
              text:
                "<p>Trabajamos para generar un entorno laboral que acompañe a la plantilla en sus distintas etapas y necesidades.</p>",
            },
          ],
        },
        {
          id: "good-practice",
          img: "/img/rsc/img-buenas-practicas.png",
          alt: "Compromiso con las buenas prácticas",
          title:
            "<p class='title'>COMPROMISO<br><span>con las <span class='green'> Buenas Prácticas</span></span></p>",
          icons: [
            {
              img: "/img/rsc/cp-1.svg",
            },
            {
              img: "/img/rsc/cp-5.svg",
            },
            {
              img: "/img/rsc/bp-9.jpg",
            },
            {
              img: "/img/rsc/ma-3.svg",
            },
            {
              img: "/img/rsc/sello-16.svg",
            },
            {
              img: "/img/rsc/bp-17.jpg",
            },
          ],
          text:
            "<p>Impulsamos nuestro crecimiento económico de manera sostenible.</p>",
          objectives: [
            {
              id: "rural",
              img: "/img/rsc/innovacion-investigacion.jpg",
              title: "Innovación e Investigación",
              text:
                "<p>Investigamos soluciones alimentarias con impacto positivo, impulsando la innovación para crear nuevos productos y avanzar en sostenibilidad.</p>",
            },
            {
              id: "culturaEtica",
              img: "/img/rsc/derechos-humanos-cadena-valor.jpg",
              title: "Derechos Humanos en la Cadena de Valor",
              text:
                "<p>Fomentamos relaciones responsables con nuestras empresas proveedoras para garantizar una cadena de suministro ética.</p><p style='font-size: 14px;text-decoration: underline;'><a href='https://empresasproveedoras.grupoian.com/' target='_blank'><strong>VER MÁS</strong></p> <strong></strong></a>",
              // knowMore:
              //   "<p style='font-size: 14px;'><strong>VER MÁS</strong><img style='margin-left:5px;width:12px;height:10px;position:relative;' src='/img/arrow-down-white.svg'></p>",
              // banner_consult_code_ethics: {
              //   img: "/img/rsc/banner-consult-code-ethics.png",
              //   alt: "Consultar nuestro código ético",
              //   options: [
              //     {
              //       text: "Consulta nuestro Código Ético y de Conducta",
              //       link: "/pdf/GRUPO_IAN_Codigo_Etico_Conducta.pdf",
              //     },
              //     {
              //       text:
              //         "Consulta nuestro Código Ético de Empresas Proveedoras",
              //       link: "https://empresasproveedoras.grupoian.com/",
              //     },
              //   ],
              // },
            },
            {
              id: "rural",
              img: "/img/rsc/seguridad-alimentaria.jpg",
              title: "Seguridad Alimentaria",
              text:
                "<p>Mantenemos nuestro firme compromiso con la seguridad alimentaria a través de procesos certificados y la apuesta por la mejora continua.</p>",
            },
            {
              id: "digitalizacion",
              img: "/img/rsc/cultura-corporativa.jpg",
              title: "Cultura Corporativa",
              text:
                "<p>Nuestra actividad se guía por la transparencia, la ética empresarial y la sostenibilidad, mediante una comunicación activa y cumplimiento normativo certificado.</p>",
            },
            {
              id: "idi",
              img: "/img/rsc/gestion-riesgos.jpg",
              title: "Gestión de Riesgos",
              text:
                "<p>Promovemos una cultura de gestión responsable, centrada en la calidad, la seguridad y la mejora constante de nuestros procesos.</p>",
            },
          ],
        },
      ],
      commitment_banner: {
        img: "/img/rsc/futuro-mejor.svg",
        alt: "Compromiso por un futuro mejor",
        img_bottom: "/img/rsc/bg-campo.svg",
      },
      banner_consult_code_ethics: {
        img: "/img/rsc/banner-consult-code-ethics.png",
        alt: "Consultar nuestro código ético",
        options: [
          {
            text: "Consulta nuestro Código Ético y de Conducta",
            link: "/pdf/GRUPO_IAN_Codigo_Etico_Conducta.pdf",
          },
          {
            text: "Consulta nuestro Código Ético de Empresas Proveedoras",
            link: "https://empresasproveedoras.grupoian.com/",
          },
        ],
      },
      rsc_projects_banner: {
        title: "Conoce nuestros proyectos RSC",
        text:
          "<p class='waypoints'>Desde Grupo Alimentario IAN desarrollamos iniciativas relacionadas con el compromiso social y económico para contribuir al impulso de nuestro entorno y comunidades en las que estamos presentes.</p>",
        subtitle:
          "Más información sobre nuestro <br>Plan de Sostenibilidad y RSC 2026 - 2030",
        download_pdf: "https://youtu.be/-ehQ-vayd7M",
        download: "Ver vídeo",
      },
    },
    show_more: "Ver más",
    show_less: "Ver menos",
    gamas_y_formatos: "Gama y Formatos",
    quieres_conocer_nuestra_gama:
      "¿Quieres conocer nuestra gama completa y sus formatos",
    nos_adaptamos:
      "Nos adaptamos a todo tipo de necesidades. Cuéntanos las tuyas.",
    categorias_productos: {
      "conservas-vegetales": {
        id: "conservas-vegetales",
        name: "Conservas Vegetales",
        seo: {
          title: "Conservas vegetales| Grupo Alimentario IAN",
          description:
            "Deliciosas conservas vegetales de calidad. Espárragos, tomates y salsas, aceitunas, pimientos, verduras y legumbres.  ",
        },
        descripcion:
          "<p>Nuestra amplia gama de conservas vegetales de gran calidad son perfectas para consumir en el hogar y en hostelería. Además, seleccionamos los mejores productos y los envasamos aplicando las técnicas más avanzadas para mantener sus propiedades.</p>",
        productos: {
          esparragos: {
            id: "esparragos",
            name: "Espárragos",
            categoria: "Conservas Vegetales",
            title: "Desde 1875",
            seo: {
              title:
                "Espárragos blancos calidad extra | Grupo Alimentario IAN | Carretilla",
              description:
                "Deliciosos espárragos blancos enteros de calidad extra. Inconfundibles por su sabor, color y textura tierna, sin hebras. ¿Con cuál te quedas?",
            },
            subtitle:
              "Del campo a tu despensa con la mejor calidad. Inconfundibles por su sabor, color blanco y textura tierna, sin hebras. ",
            descripcion:
              "<p>En Carretilla seleccionamos los mejores espárragos, los pelamos a mano y los envasamos inmediatamente después de la recogida para que mantengan todas sus cualidades.</p>",
            cta_link: "WEB ESPÁRRAGOS CARRETILLA",
            link: "https://esparragoscarretilla.es/",
            texto_gama_formatos:
              "<p>Además de nuestros reconocidos espárragos blancos, yemas y tallos, disponemos de espárragos verdes Carretilla (Trigueros). Todos ellos disponibles en frasco, lata o latones, en tamaños adaptados a cualquier necesidad.</p>",
          },
          "tomates-y-salsas": {
            id: "tomates-y-salsas",
            name: "Tomates y salsas",
            categoria: "Conservas Vegetales",
            title: "Ideales para el hogar y la hostelería",
            seo: {
              title: "Tomates en conserva y salsas | Grupo Alimentario IAN",
              description:
                "Te ofrecemos la mayor calidad y sabor natural en nuestras distintas variedades de tomate en conserva: entero, triturado, frito y en nuestras salsas de tomate. ¡Descúbrelas!",
            },
            subtitle:
              "Reconocibles por su sabor totalmente natural y elaborados sin añadir conservadores ni espesantes.",
            descripcion:
              "<p>Contamos con una <strong>larga experiencia </strong> en la elaboración de tomate, en distintas variedades, a través de nuestras marcas Carretilla e IAN: tomate entero natural pelado, triturado, frito, tamizado, gazpacho, tumaca y otras salsas a base de tomate, que  elaboramos en nuestras plantas de Villafranca y Funes.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Seleccionamos los frutos y cuidamos al máximo su preparación para mantener su sabor, textura y aroma natural. Nuestro tomate y salsas de tomate están elaborados en diferentes tipos de formatos pensados para satisfacer cualquier necesidad en la cocina.</p>",
          },
          aceitunas: {
            id: "aceitunas",
            name: "Aceitunas",
            categoria: "Conservas Vegetales",
            title: "¡Sabrosas y nutritivas!",
            seo: {
              title: "Aceitunas negras y verdes | Grupo Alimentario IAN",
              description:
                "Disfruta la calidad y el sabor de nuestras aceitunas negras y verdes, uno de los alimentos más típicos de la dieta mediterránea. Encontrarás nuestras aceitunas en diversos formatos: enteras, deshuesadas, rellenas y en rodajas.",
            },
            subtitle:
              "Uno de los alimentos más tradicionales de nuestra dieta mediterránea.",
            descripcion:
              "<p><strong>Desde 1975</strong> procesamos aceitunas verdes y negras en nuestra planta de COMARO situada en Casas del Monte,  (Cáceres) y Morón de la Frontera (Sevilla).</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Comercializamos nuestras aceitunas en distintos formatos: enteras, deshuesadas, rellenas y en rodajas. Además, producimos aceitunas verdes con rellenos de especialidad, para todos los gustos: anchoa, queso, pimienta, limón, almendra, salmón, atún, pasta de pimiento y más.</p>",
          },
          pimientos: {
            id: "pimientos",
            name: "Pimientos del Piquillo",
            categoria: "Conservas Vegetales",
            title: "De gran calidad",
            seo: {
              title:
                "Pimientos del Piquillo en conserva |Grupo Alimentario IAN",
              description:
                "Pimientos del piquillo Carretilla, un alimento ideal y versátil para seguir una alimentación sana y equilibrada. Descubre nuestras variedades de pimientos del piquillo.",
            },
            subtitle:
              "Nuestros Pimientos del Piquillo son homogéneos y los seleccionamos uno a uno de manera tradicional. ",
            descripcion:
              "<p>Nuestros Pimientos del Piquillo Carretilla <strong>los recogemos a mano</strong>, los asamos y pelamos, y los presentamos sin corazón, ni prácticamente semillas.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Posteriormente, los envasamos para que lleguen a las personas consumidoras con la calidad extra, tamaño, color, textura y el mismo sabor de siempre, además del asado distintivo de Carretilla. También disponibles en tiras, y en la variedad “Al ajillo”.</p>",
          },
          "verduras-y-legumbres": {
            id: "verduras-y-legumbres",
            name: "Verduras y legumbres",
            categoria: "Conservas Vegetales",
            title: "Con todo el sabor natural",
            seo: {
              title: "Verduras y legumbres en conserva | Grupo Alimentario IAN",
              description:
                "Con nuestras marcas Carretilla y Taboada, elaboramos una amplia gama de verduras y legumbres en conserva. Ingredientes indispensables en nuestra cocina con los que elaborar una gran variedad de recetas. ",
            },
            subtitle:
              "Ingredientes indispensables y versátiles para la cocina.",
            descripcion:
              "<p>Recogemos nuestras verduras y legumbres en su estado <strong>óptimo de madurez</strong> y los seleccionamos y procesamos manteniendo todas sus propiedades.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Ofrecemos una amplia gama de verduras y legumbres con nuestras marcas Taboada y Carretilla. Permiten elaborar infinidad de combinaciones para crear platos más completos y equilibrados.</p>",
          },
        },
      },
      "platos-preparados": {
        id: "platos-preparados",
        name: "Platos Preparados",
        seo: {
          title:
            "Platos preparados Carretilla |Sabor casero  | Grupo Alimentario IAN",
          description:
            "¡Descubre nuestros platos preparados! Con nuestra marca Carretilla, elaboramos más de 60 recetas variadas de platos preparados, listos para comer, con solo 1 minuto de microondas: ensaladas, platos de pasta, platos de arroz, platos de legumbres, platos de verduras o platos Tex-Mex.",
        },
        descripcion:
          "<p>Elaboramos una amplia variedad de recetas con la máxima calidad y tradición. Además, están dispuestas en cómodos formatos: microondable (en bol o barqueta) y lata.</p>",
        productos: {
          "platos-preparados-en-envase-microondable": {
            id: "platos-preparados-en-envase-microondable",
            name: "Platos preparados en envase microondable",
            categoria: "Platos Preparados",
            title: "La carta más amplia del mercado",
            seo: {
              title:
                "Platos preparados en envase microondable | Grupo alimentario IAN",
              description:
                "Platos listos Carretilla en 1 minuto, cómodos y muy ricos. Elaborados con ingredientes naturales, no necesitan frío para su conservación, gracias al Proceso Exclusivo Carretilla.",
            },
            subtitle:
              "Todo listo para comer de forma más variada y equilibrada. Contamos con diferentes opciones de platos a base de pasta, arroz, carne, verduras, legumbres, cremas, ensaladas e incluso tapas y comida mexicana.",
            descripcion:
              "<p>Platos <strong>listos en 1 minuto</strong>, cómodos ¡y muy ricos!, que te hacen la vida más fácil. Elaborados con <strong>ingredientes naturales, no necesitan frío</strong> para su conservación, gracias al <strong>Proceso Exclusivo Carretilla</strong>, lo que permite que las personas consumidoras puedan disfrutar de ellos donde y cuando quieran.</p>",
            cta_link: "PLATOS LISTOS CARRETILLA",

            link: "https://www.carretilla.info/platos-preparados",
            texto_gama_formatos:
              "<p>Todas nuestras recetas, están adaptadas a las necesidades de nuestros clientes y mercados, ya que se encuentran disponibles tanto en formatos individuales como en bol o barqueta, así como en bandejas ½ Gastronorm, perfectas para su uso en hostelería.</p>",
          },
          "platos-preparados-en-lata": {
            id: "platos-preparados-en-lata",
            name: "Platos preparados en Lata",
            categoria: "Platos Preparados",
            title: "Recetas de carne y legumbres desde 1969",
            seo: {
              title:
                "Platos preparados en lata | Recetas tradicionales | Grupo Alimentario IAN",
              description:
                "¡Descubre nuestros platos preparados en lata! Una amplia gama de platos de carne y legumbres elaborados con la receta tradicional. Ingredientes 100% naturales, sin aditivos añadidos.",
            },
            subtitle:
              "Elaboradas con el saber hacer de siempre y la tecnología alimentaria más puntera. Ya listas con solo calentar.",
            descripcion:
              "<p>Tenemos una gran experiencia  en la elaboración de platos con carne y legumbres de máxima calidad que siguen la <strong>receta tradicional</strong> para su creación, con <strong>ingredientes 100% naturales</strong>, sin aditivos añadidos y acompañados de embutido de elaboración propia en nuestra fábrica de Noreña (Asturias).</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Con nuestras marcas Carretilla, La Nora, y la línea gourmet El Yantar de Pepe, disponemos de un amplio catálogo de platos preparados en lata de diferentes tamaños, elaborados sin potenciadores, ni conservadores, hechos con base de cerdo, pollo, vacuno, vegetal y legumbres.</p>",
          },
        },
      },
    },
    map_web: {
      title: "Mapa web",
    },
    reception_training: {
      title: "Formación Manual de Acogida",
      main_banner: {
        img: "/img/formacion_acogida/intro_banner.jpg",
        imgMobile: "/img/formacion_acogida/intro_banner.jpg",
        title: "¡Te damos la bienvenida a Grupo Alimentario IAN! ",
      },
      subtitle:
        "A continuación te indicamos los pasos a seguir para llevar a cabo con éxito tu formación en IAN.",
      step1: {
        title: "Paso 1",
        content:
          "<p>Llevaremos a cabo la formación de acogida a través de <strong>7 vídeos formativos</strong> organizados por distintas temáticas.<p>Deberás ver y escuchar atentamente cada uno de estos vídeos.",
        linkCta: "VER VÍDEOS",
      },
      step2: {
        title: "Paso 2",
        content:
          "<p>Un vez <strong>visionados todos los vídeos</strong> de la formación podrás realizar el test de nuestra formación de acogida.<p>(*Recuerda que si tienes alguna duda al contestar el test, siempre podrás volver acceder a los vídeos formativos)",
        linkCta: "Test formación de acogida",
      },
      accessText: "Acceso al puesto de manejo de carretillas",
      step3: {
        content:
          "<p>Para acceder al puesto de manejo de carretillas, deberás <strong>ver y escuchar de manera adicional</strong> a los vídeos anteriores, este vídeo.",
        linkCta: "VER VÍDEO",
      },
      step4: {
        content:
          "<p>Una vez visionado el vídeo anterior de acceso a puesto de manejo de carretillas, podrás realizar el test.",
        linkCta: "Test puesto manejo de carretillas",
      },
      thanks: "¡Gracias!",
    },
    policy_cookies:
      '<h1>Política de cookies</h1> <p dir="ltr"> Fecha de última actualización: 08/05/2025</p><h2 dir="ltr"> ¿QUÉ SON LAS COOKIES?</h2><p dir="ltr"> Las cookies son pequeños ficheros que se instalan en el disco duro o en el navegador del ordenador, tablet, smartphone o dispositivo equivalente con funciones de navegación a través de Internet y ayudan a, entre otros: personalizar los servicios del titular de la web, facilitar la navegación y usabilidad a través de la misma, obtener información agregada de los visitantes de la web, posibilitar la reproducción y visualización de contenido multimedia en la propia web, permitir elementos de interactuación entre el usuario y la propia web, habilitar herramientas de seguridad, etcétera.</p><p dir="ltr"> DEFINICIONES UTILIZADAS EN ESTA POLÍTICA DE COOKIES</p><p dir="ltr"> § Dato: Es la información que se obtiene por medio del equipo terminal del usuario a través del dispositivo de almacenamiento y recuperación de datos (cookies u otros). El dato será personal cuando se trata de información sobre personas físicas identificadas o identificables, en los términos que establece el artículo 4 del RGPD</p><p dir="ltr"> § Información agregada: información no nominal, típicamente numérica y a efectos de proporcionar información estadística</p><p dir="ltr"> § Equipo terminal: Es el dispositivo desde el cual el usuario accede al servicio, como un ordenador personal, un teléfono móvil, una tablet, etc., y a partir del cual se obtiene la información</p><p dir="ltr"> § Editor: responsable o titular de la página web</p><p dir="ltr"> § Tercero: entidad externa, colaboradora, prestadora de servicios o relacionada con el editor, interviniente en la gestión de algunas cookies</p><p dir="ltr"> § Responsable de la cookie: el editor, responsable, titular de la página web o, incluso, el tercero en algunos casos</p><p dir="ltr"> § Hábitos de navegación: tendencias que muestra el usuario cuando navega través de una página web como, por ejemplo, tiempo que visita la página, partes que visita, secciones más frecuentes, origen de la visita, destino de la visita, entre otros.</p><h2 dir="ltr"> ¿QUÉ TIPO DE COOKIES EXISTEN?</h2><p dir="ltr"> Según la entidad que la gestiona:</p><p dir="ltr"> Cookies propias: son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.</p><p dir="ltr"> Cookies de terceros: son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies.</p><p dir="ltr"> Según el plazo de tiempo que permanecen activadas en el equipo terminal:</p><p dir="ltr"> Cookies de sesión: son aquellas diseñadas para recabar y almacenar datos mientras el usuario accede a una página web. Se suelen emplear para almacenar información que solo interesa conservar para la prestación del servicio solicitado por el usuario en una sola ocasión (por ejemplo, una lista de productos adquiridos) y desaparecen al terminar la sesión.</p><p dir="ltr"> Cookies persistentes: son aquellas en las que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie, y que puede ir de unos minutos a varios años.</p><p dir="ltr"> Según la finalidad para la que se traten los datos obtenidos a través de las cookies:</p><p dir="ltr"> Cookies técnicas: son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan, incluyendo aquellas que el editor utiliza para permitir la gestión y operativa de la página web y habilitar sus funciones y servicios, como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, gestionar el pago, controlar el fraude vinculado a la seguridad del servicio, realizar la solicitud de inscripción o participación en un evento, contar visitas a efectos de la facturación de licencias del software con el que funciona servicio (sitio web, plataforma o aplicación), utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de vídeos o sonido, habilitar contenidos dinámicos (por ejemplo, animación de carga de un texto o imagen) o compartir contenidos a través de redes sociales. También pertenecen a esta categoría, por su naturaleza técnica, aquellas cookies que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, como un elemento más de diseño o “maquetación” del servicio ofrecido al usuario, el editor haya incluido en una página web, aplicación o plataforma en base a criterios como el contenido editado, sin que se recopile información de los usuarios con fines distintos, como puede ser personalizar ese contenido publicitario u otros contenidos.</p><p dir="ltr"> Cookies de preferencias o personalización: son aquellas que permiten recordar información para que el usuario acceda al servicio con determinadas características que pueden diferenciar su experiencia de la de otros usuarios, como, por ejemplo, el idioma, el número de resultados a mostrar cuando el usuario realiza una búsqueda, el aspecto o contenido del servicio en función del tipo de navegador a través del cual el usuario accede al servicio o de la región desde la que accede al servicio, etc .</p><p dir="ltr"> Cookies de análisis o medición: son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</p><p dir="ltr"> Cookies publicitarias: son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncio.</p><p dir="ltr"> Cookies de publicidad comportamental: son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</p><p dir="ltr"> Lista de cookies que recopilamos</p><br/><div dir="ltr" align="left"><table><colgroup><col width="77"/><col width="118"/><col width="93"/><col width="114"/><col width="104"/><col width="85"/></colgroup><tbody><tr><td><p dir="ltr"> Nombre de la cookie </p></td><td><p dir="ltr"> Propia / De Terceros*<br>*(incluye url a política de cookies) </p></td><td><p dir="ltr"> Tipo de cookies </p></td><td><p dir="ltr"> Finalidad </p></td><td><p dir="ltr"> Permanencia </p></td><td><p dir="ltr"> Transferencia de datos fuera de la Unión Europea </p></td></tr><tr><td><p dir="ltr"> CookieConsent </p></td><td><p dir="ltr"> De Terceros ( <a href="https://www.cookiebot.com/goto/privacy-policy/" > Cookiebot </a> ) </p></td><td><p dir="ltr"> Técnicas </p></td><td><p dir="ltr"> Almacena el estado de consentimiento de cookies del usuario para el dominio actual </p></td><td><p dir="ltr"> Es una cookie con una permanencia de 1 año </p></td><td><p dir="ltr"> No </p></td></tr><tr><td><p dir="ltr"> PHPSESSID </p><br/></td><td><p dir="ltr"> Propia </p></td><td><p dir="ltr"> Técnicas </p></td><td><p dir="ltr"> Almacenar un identificador único de sesión para Conservar los estados de los usuarios en todas las peticiones de la página. </p></td><td><p dir="ltr"> Temporal (Cookies de sesió) </p></td><td><p dir="ltr"> No </p></td></tr><tr><td><p dir="ltr"> CONSENT </p></td><td><p dir="ltr"> De Terceros <a href="https://policies.google.com/privacy"> YouTube </a></p></td><td><p dir="ltr"> Técnicas </p></td><td><p dir="ltr"> Utilizada para detectar si el visitante ha aceptado la categoría de marketing en el banner de cookies. Esta cookie es necesaria para que la web cumpla con el RGPD. </p><br/></td><td><p dir="ltr"> Es una cookie con una permanencia de 6079 días </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> lang </p></td><td><p dir="ltr"> Propia </p></td><td><p dir="ltr"> Cookies de preferencias </p></td><td><p dir="ltr"> La cookie determina el idioma preferido y la configuración de país del visitante - Esto permite a la web mostrar contenido más relevante para esa región e idioma. </p><br/></td><td><p dir="ltr"> Persistente </p></td><td><p dir="ltr"> No </p></td></tr><tr><td><p dir="ltr"> _ga </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Análisis o medición </p></td><td><p dir="ltr"> Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web. </p><br/></td><td><p dir="ltr"> Es una cookie con una permanencia de 2 años </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> _gat </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Análisis o medición </p></td><td><p dir="ltr"> Utilizado por Google Analytics para controlar la tasa de peticiones </p></td><td><p dir="ltr"> Es una cookie con una permanencia de 1 día. </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> _gid </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Análisis o medición </p></td><td><p dir="ltr"> Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web. </p></td><td><p dir="ltr"> Es una cookie con una permanencia de 1 día. </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> collect </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Análisis o medición </p></td><td><p dir="ltr"> Se utiliza para enviar datos a Google Analytics sobre el dispositivo del visitante y su comportamiento. Rastrea al visitante a través de dispositivos y canales de marketing. </p></td><td><p dir="ltr"> Temporal (Cookies de sesión) </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> IDE </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Utilizada por Google DoubleClick para registrar e informar sobre las acciones del usuario en el sitio web tras visualizar o hacer clic en uno de los anuncios del anunciante con el propósito de medir la eficacia de un anuncio y presentar anuncios específicos para el usuario. </p></td><td><p dir="ltr"> Es una cookie con una permanencia de 1 año </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> test_cookie </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Utilizada para comprobar si el navegador del usuario admite cookies. </p></td><td><p dir="ltr"> Es una cookie con una permanencia de 1 día </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> VISITOR_INFO1_LIVE </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Intenta calcular el ancho de banda del usuario en páginas con vídeos de YouTube integrados. </p></td><td><p dir="ltr"> Es una cookie con una permanencia de 179 día </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> YSC </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra una identificación única para mantener estadísticas de qué vídeos de YouTube ha visto el usuario. </p><br/></td><td><p dir="ltr"> Temporal (Cookies de sesión) </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> yt.innertube::nextId </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p><br/><br/></td><td><p dir="ltr"> Registra una identificación única para mantener estadísticas de qué vídeos de YouTube ha visto el usuario. </p></td><td><p dir="ltr"> Persistente </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> yt.innertube::requests </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra una identificación única para mantener estadísticas de qué vídeos de YouTube ha visto el usuario. </p></td><td><p dir="ltr"> Persistente </p></td><td><p dir="ltr"> Sí, Google LCC </p><br/><br/></td></tr><tr><td><p dir="ltr"> yt-remote-cast-installed </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra las preferencias del reproductor de vídeo del usuario al ver vídeos incrustados de YouTube </p></td><td><p dir="ltr"> Temporal (Cookies de sesión </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> yt-remote-connected-devices </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p><br/><br/></td><td><p dir="ltr"> Registra las preferencias del reproductor de vídeo del usuario al ver vídeos incrustados de YouTube </p></td><td><p dir="ltr"> Persistente </p></td><td><p dir="ltr"> Sí, Google LCC </p></td></tr><tr><td><p dir="ltr"> yt-remote-device-id </p><br/></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra las preferencias del reproductor de vídeo del usuario al ver vídeos incrustados de YouTube </p><br/></td><td><p dir="ltr"> Persistente </p></td><td><p dir="ltr"> Sí, Google LCC </p><br/><br/></td></tr><tr><td><p dir="ltr"> yt-remote-fast-check-period </p><br/></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra las preferencias del reproductor de vídeo del usuario al ver vídeos incrustados de YouTube </p><br/></td><td><p dir="ltr"> Temporal (Cookies de sesión </p></td><td><p dir="ltr"> Sí, Google LCC </p><br/></td></tr><tr><td><p dir="ltr"> yt-remote-session-app </p></td><td><p dir="ltr"> De Terceros ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra las preferencias del reproductor de vídeo del usuario al ver vídeos incrustados de YouTube </p><br/></td><td><p dir="ltr"> Temporal (Cookies de sesión </p></td><td><p dir="ltr"> Sí, Google LCC </p><br/></td></tr><tr><td><p dir="ltr"> yt-remote-session-name </p><br/></td><td><br/></td><td><p dir="ltr"> Cookies de publicidad comportamental </p></td><td><p dir="ltr"> Registra las preferencias del reproductor de vídeo del usuario al ver vídeos incrustados de YouTube </p><br/></td><td><p dir="ltr"> Temporal (Cookies de sesión </p></td><td><p dir="ltr"> Sí, Google LCC </p><br/></td></tr></tbody></table></div><p dir="ltr"> Mediante las cookies no se elaboran perfiles de los usuarios que navegan a través de la web ni, por tanto, se toman decisiones automatizadas basadas en estos datos.</p><p dir="ltr"> Puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies, así como de los riesgos que supone dicha transferencia de acuerdo con sus propias políticas ajenas a este sitio web, accediendo a sus correspondientes políticas de cookies facilitadas en cada caso en la tabla anterior.</p><h2 dir="ltr"> ¿CÓMO DESACTIVAR LAS COOKIES?</h2><p dir="ltr"> El bloqueo o desactivación de todas las cookies ayuda a proteger la privacidad, pero también puede limitar la experiencia en algunos sitios web, así como limitar funcionalidades o, incluso, no permitir la correcta navegación o utilización de algunos de sus servicios.</p><p dir="ltr"> Puedes activar o desactivar las cookies descritas anteriormente (a excepción de las cookies técnicas, que son necesarias para el correcto funcionamiento) a través del configurador que aparece en el aviso de uso de cookies, al acceder a nuestra página principal. Ten en cuenta que, si aceptas las cookies de terceros, deberás eliminarlas desde las opciones del navegador o desde el sistema ofrecido por el propio tercero.</p><p dir="ltr"> Del mismo modo, si quieres saber cómo desactivar las cookies en los navegadores web más populares, accede a los siguientes tutoriales:</p><p dir="ltr"> § <a href="http://support.google.com/chrome/answer/95647?hl=es"> Google Chrome </a></p><p dir="ltr"> § <a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we" > Mozilla Firefox </a></p><p dir="ltr"> § <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies" > Internet Explorer </a></p><p dir="ltr"> § <a href="http://support.apple.com/es-es/HT1677"> Safari</a></p><p dir="ltr"> § <a href="http://support.google.com/chrome/answer/2392971?hl=es"> Chrome para Android </a></p><p dir="ltr"> Si tienes alguna pregunta o duda acerca de esta Política de Cookies, puedes ponerte en contacto con nosotros a través de los medios de contacto de nuestra página web.</p><p dir="ltr"> Si deseas información completa y concreta sobre protección de datos personales, te remitimos a nuestra política de privacidad.</p>',
    policy_privacy:
      '<h1>POLÍTICA DE PRIVACIDAD</h1><p>Fecha de última actualización: 08/05/2025</p><p> La presente Política de Privacidad ha sido desarrollada teniendo en cuenta lo dispuesto en el Reglamento 2016/679 del Parlamento Europeo y del consejo del 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la circulación de estos datos, en adelante el RGPD, así como en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos y derechos digitales (en lo sucesivo, LOPDGDD) y demás normativa aplicable.</p><p> Esta Política de Privacidad tiene por objeto poner en conocimiento a las personas físicas que faciliten sus datos personales, y/o los de la persona a la que representa, respecto de los cuales se está recabando información, los aspectos específicos relativos al tratamiento sus datos, las finalidades de los tratamientos, los datos de contacto para ejercer los derechos que le asisten, los plazos de conservación de la información y las medidas de seguridad, entre otras cosas.</p><h2>¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO?</h2><p> En términos de protección de datos, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U debe ser considerado Responsable del Tratamiento, en relación a los tratamientos de datos de carácter personal realizados por la presente entidad.</p><p> A continuación, se indican los datos de contacto del Responsable del Tratamiento:</p><p> o Identidad del responsable: INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U (A31204175 )</p><p>• Dirección física: P.I. PEÑALFONS, S/N, 31330, VILLAFRANCA, NAVARRA</p><p>• Correo electrónico: <a href="mailto:info@grupoian.com">info@grupoian.com</a></p><p>Teléfono. Teléfono. 948 84 33 60</p><h2>¿QUIÉN ES EL DELEGADO DE PROTECCIÓN DE DATOS?</h2><p> En esta entidad se enmarca la figura de delegado de protección de datos, con quien se podrá poner en contacto a través de la siguiente dirección de correo electrónico: GESPRODAT S.L <a href="mailto:dpd@gesprodat.net">dpd@gesprodat.net</a> 902 929 926, o mediante escrito dirigido al domicilio de esta entidad a la atención del “Delegado de Protección de Datos”.</p><h2>¿QUÉ DATOS PERSONALES TRATAMOS?</h2><p> Toda la información recabada por parte de INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U será tratada de forma leal, lícita y transparente.</p><p> Asimismo, los datos solicitados en cada uno de los tratamientos realizados consistirán únicamente en aquellos estrictamente imprescindibles para realizar la finalidad pretendida e informada en cada caso.</p><p> De este modo, sus datos recogidos serán adecuados, pertinentes y no excesivos en relación con los fines para los que son tratados en cada caso. Por lo que, sus datos personales serán recogidos para finalidades determinadas explícitas y legítimas, no siendo tratados ulteriormente de manera con incompatible con dichos fines. Además, serán actualizados siempre que sea necesario.</p><p> En términos generales, en el marco de los distintos tratamientos de actividades realizadas en la organización, se recaban los siguiente tipos:</p><li>• Datos de carácter identificativos.</li><li>• Datos de carácter identificativos.</li><li>• Datos académicos, profesionales y de formación.</li><li>• Datos de detalle de empleo.</li><li>• Datos de carácter administrativo.</li><li>• Información Comercial.</li><h2>¿DE DÓNDE PROCEDEN LOS DATOS PERSONALES?</h2><p> Por regla general, los datos personales se recogen siempre directamente del titular de los mismos, no obstante, en determinadas excepciones, los datos pueden ser recogidos a través de terceras personas, entidades o servicios diferentes del interesado.</p><p> En este sentido, este extremo será trasladado al interesado a través de las cláusulas informativas contenidas en las diferentes vías de recogida de información y dentro de un plazo razonable o en la primera comunicación realizada al interesado.</p><h2> ¿CON QUÉ FINALIDAD Y CASOS ESPECÍFICOS CON QUE TRATAMOS LOS DATOS PERSONALES?</h2><p> En términos generales, se tratan los datos personales con las siguientes finalidades:</p><p> • <strong>Gestión de registro como usuario</strong>: La información que nos facilites en el formulario de registro se tratará para la gestión de los usuarios en nuestras plataformas. Tras dicho registro, podrás consultar tu historial de pedidos, canjear tarjetas de regalo o vales de descuento, modificar tus datos personales y/o direcciones de envío y facturación, listas de deseos, valoraciones o alertas.</p><p> • <strong>Gestión, cumplimiento y ejecución del contrato de compra</strong>: En concreto, se utilizarán los datos personales para la formalización del contrato de compra; para la gestión pago de transacciones; para contactarle en caso de cualquier incidencia relacionada con tu pedido; para la gestión de la facturación y entrega de tickets y facturas de compra; para la gestión de las devoluciones de productos adquiridos; para informarte sobre la disponibilidad de los productos solicitados; y/o para la gestión de cupones o tarjetas regalos que canjees en la web o nuestras tiendas.</p><p> • <strong>Newsletters</strong>: cuando se haya autorizado previamente, por email, fax, SMS, MMS, comunidades sociales o cualquier otro medio electrónico o físico, presente o futuro, que posibilite realizar comunicaciones comerciales, así como remitir el boletín de noticias de la página web. Estas comunicaciones serán realizadas por el Responsable o alguna de las empresas del grupo del Responsable, relacionadas sobre sus productos y servicios, o de sus colaboradores o proveedores con los que se haya alcanzado algún acuerdo de promoción. En este caso, los terceros nunca tendrán acceso a los datos personales.</p><p> • <strong>Contacto</strong>: Con la finalidad de dar respuesta a tu solicitud, trataremos los datos indispensables, que generalmente se corresponden con los datos de contacto (email) y los datos relacionados con tu pedido, o con la incidencia que nos comunique, así como responder a las solicitudes de información recibidas sobre los productos y servicios que se ofrecen o cualquier tipo de petición que sea realizada por el usuario a través de cualquiera de las formas de contacto que se ponen a su disposición</p><p> Cuando utilice las redes sociales para transmitirnos las consultas, evite introducir datos de carácter personal, recuerda que no tenemos el control sobre los datos introducidos en estas plataformas, por lo que aconsejamos que lea detenidamente las políticas de privacidad de la red social desde la que actúe.</p><p> • <strong>Encuestas</strong>: Para la realización de encuesta del servicio de atención al cliente y/o calidad de nuestros productos realizadas por el Responsable o alguna de las empresas del grupo del Responsable. Con la finalidad de mejorar estos servicios, trataremos tus datos personales al objeto de obtener información sobre nuestros productos o sobre la atención prestada por nuestro servicio de atención al cliente.</p><p> • <strong>Clientes</strong>: llevar a cabo la gestión de venta de bienes y servicios, facturación, contabilidad, cobros, impagos, ofertas, presupuestos y contratos, atención al cliente, contacto y relaciones comerciales.</p><p> • <strong>Clientes Potenciales</strong>: Realizar seguimiento y oportunidades comerciales para la organización.</p><p> • <strong>Proveedores</strong>: llevar a cabo la gestión de compras, contabilidad, pagos, gestión de albaranes y pedidos, contacto y relaciones comerciales.</p><p> Videovigilancia: Controlar el acceso a las instalaciones de la organización y velar por la seguridad de los bienes y las personas de la empresa.</p><p> • <strong>Candidatos</strong>: Realizar procesos internos de selección de personal, tanto actuales como futuros.</p><p> • <strong>Registros de Llamadas</strong>: Atender de manera eficiente a las llamadas telefónicas realizas a la organización, con posibilidad de grabación de las mismas.</p><p> Con los datos personales recabados no se elaboraran perfiles ni se realizarán decisiones automatizadas. No obstante, todas las finalidades explícitas para las cuales se llevan a cabo cada uno de los tratamientos vienen recogido en las cláusulas informativas incorporadas en cada una de las vías de toma de datos (formularios web, formularios en papel, locuciones o carteles y notas informativas, facturas, contratos y demás documentos que contengan datos personales).</p><h2>¿CUÁL ES LA LEGITIMACIÓN PARA EL TRATAMIENTO DE LOS DATOS?</h2><p> Por regla general, previo al tratamiento de los datos personales, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.Uinforma de la base jurídica por la cual establece la legitimación del tratamiento en cuestión.</p><p> No obstante, en la organización se pueden tratar información de carácter personal para:</p><p> • <strong>Cumplimiento de obligaciones Legales y regulatorias</strong>: A título enunciativo y no limitativo. Ley General para la Defensa de los Consumidores y Usuarios, Ley General Tributaria, Ley de Impuestos de Sociedades, Ley de Auditoría de Cuentas, Ley del Impuesto sobre el Valor Añadido, Código Civil, Código de Comercio, así como la existencia de una ley o norma específica que autorice o exija el tratamiento de los datos del interesado, la cual se enunciará en la cláusula informativa correspondiente.</p><p> • <strong>Ejecución de un Contrato</strong>: para la gestión previa de un servicio o producto contratado, desarrollo de la ejecución de un contrato o posteriores gestiones derivadas de dichas operaciones.</p><p> • <strong>Consentimiento</strong>: existen tratamientos basados en la obtención del consentimiento expreso e inequívoco del titular de los mismos, mediante la incorporación de cláusulas de consentimiento informado en los diferentes sistemas de recogida de información prestando el consentimiento mediante una declaración o una clara acción afirmativa como el marcado de una casilla dispuesta al efecto o la suscripción del documento oportuno o mediante el envío de datos a través de los medios de contacto indicados. Adicionalmente, te informamos que sólo usaremos la información de carácter personal en virtud de esta Política de Privacidad y, con carácter general, solicitaremos tu consentimiento para usos con fines distintos de aquéllos para los cuales los otorgaste inicialmente.</p><p> • <strong>Interés legítimo</strong>: el tratamiento de datos basado interés legítimo del responsable, se establecerá, principalmente, para el envío de comunicaciones o eventos comerciales sobre productos o servicios similares a los contratados. Según el artículo 21.2 de la Ley de Servicios de la Sociedad de la Información, este tratamiento solo será válido cuando, siendo cliente, no se haya negado expresamente al momento de recogida de los datos o en cualquiera de las comunicaciones que realicemos.</p><h2>¿DURANTE CUÁNTO TRATAMOS LOS DATOS PERSONALES?</h2><p> En <a href="http://www.carretilla.info" target="_blank" rel="noopener noreferrer">http://www.carretilla.info/</a> se tratan los datos personales durante el tiempo necesario para cumplir con la finalidad para la que fueron recogidos, mientras se mantenga la prestación del servicio o la relación laboral o contractual, exista un interés mutuo y/o durante el tiempo previsto en la normativa correspondiente</p><h2>¿CON QUIÉN COMPARTIMOS LOS DATOS PERSONALES?</h2><p> Por regla general, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U no procede a la cesión o comunicación de sus datos a terceras entidades, salvo las requeridas legalmente.</p><p> No obstante, en caso de que fuera necesario, dichas cesiones o comunicaciones de datos se informan al interesado a través de las cláusulas informativas contenidas en las diferentes vías de recogida de datos personales.</p><h2>¿SE REALIZAN TRANSFERENCIAS INTERNACIONALES?</h2><p>Asimismo le informamos de la transferencia de datos a Mailchimp (The Rocket Science Group) fuera del Espacio EconómicoEuropeo, basada en la existencia de garantías adecuadas de conformidad con el RGPD y quedando estas garantías adisposición de quien las solicite expresamente a <a href="mailto:rgpd@grupoian.com.">rgpd@grupoian.com</a>.</p><p>En concreto, se establecen las siguientes garantías:</p><p> • El responsable del tratamiento ha sido certificado conforme a mecanismos de certificación aprobado con arreglo al artículo 42 del RGPD, junto con compromisos vinculantes y exigibles en el tercer país de aplicar garantías adecuadas, incluidas las relativas a los derechos de los interesados.</p><h2>¿QUÉ DERECHOS PUEDES EJERCER?</h2><p> Según la normativa europea los derechos que le asisten son los siguientes:</p><p> • <strong>Derecho de Acceso</strong>, derecho a solicitar información al responsable de un fichero sobre si sus datos personales están siendo tratados.</p><p> • <strong>Derecho de Rectificación</strong>, derecho que permite a la persona afectada solicitar la modificación de datos que sean inexactos o incompletos.</p><p> • <strong>Derecho de Oposición</strong>, derecho de una persona a oponerse al tratamiento de sus datos personales o el cese de éstos.</p><p> • <strong>Derecho de Decisiones individuales automatizadas</strong>, derecho a no ser objeto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, que produzca efectos jurídicos en él o le afecte significativamente de modo similar</p><p> • <strong>Derecho de Limitación</strong>, derecho a suspender el tratamiento de los datos personales del usuario en determinados supuestos</p><p> • <strong>Derecho de Supresión u Olvido</strong>, derecho a supresión de los datos personales del interesado</p><p> • <strong>Derecho de Portabilidad</strong>, derecho a solicitar al responsable del tratamiento que se le faciliten los datos personales en un formato estructurado y claro a otro responsable.</p><p> • <strong>Derecho a presentar una reclamación</strong> ante la autoridad de control competente si considera que el tratamiento no se ajusta a la normativa vigente.</p><h2>¿CÓMO EJERCER SUS DERECHOS?</h2><p> El solicitante puede ejercer sus derechos a través de los siguientes medios:</p><p>•<strong>Email </strong>a <a href="mailto:rgpd@grupoian.com">rgpd@grupoian.com</a> pudiendo aportar documentación que acredite la identidad del solicitante (copia del anverso del Documento Nacional de Identidad, o equivalente)</p><p>•<strong>Correo postal</strong> a P.I. PEÑALFONS, S/N, 31330, VILLAFRANCA, NAVARRA pudiendo aportar documentación que acredite la identidad del solicitante (copia del anverso del Documento Nacional de Identidad, o equivalente) </p><p>En cualquier caso, puede solicitar la tutela de la Agencia Española de Protección de Datos a través de su <a href="https://www.aepd.es/" target="_blank" rel="noopener noreferrer">página web</a>.</p><p>En este sentido, INDUSTRIAS ALIMENTARIAS DENAVARRA S.A.U atenderá su solicitud a la mayor brevedad posible y teniendo en cuenta los plazos previstos en la normativa en materia de protección de datos.</p><h2>¿CUÁLES PODRÍAN SER LAS CONSECUENCIAS DE NO FACILITAR LA INFORMACIÓN?</h2><p> Los datos solicitados en los campos establecidos marcados con un asterisco (*) o los proporcionados en los documentos o medios dónde se presta la información, son aquellos estrictamente necesarios en relación con la finalidad para la cual se recaban, o bien para la prestación de un servicio óptimo al interesado o mediante una obligación legal impuesta al propio responsable del tratamiento o un requisito necesario para suscribir un contrato, siendo voluntaria la inclusión de datos en los campos restantes.</p><p> En caso de que no sean facilitados todos los datos, no se garantiza que la información y servicios facilitados sean completamente ajustados a sus necesidades.</p><p> Por lo que en el supuesto de que no se faciliten los datos exigidos o se realice de forma errónea o incompleta, no se podrá atender su solicitud, resultando del todo imposible proporcionarle la información solicitada o llevar a cabo la contratación de los servicios.</p><p> Del mismo modo, el usuario garantiza que la información transmitida en cualquiera de los formularios es veraz, exacta y se corresponde con datos propios de los que es titular.</p><p> Los servicios de nuestras plataformas no están previstos para menores de edad, por lo que solo se permite el registro de personas mayores de 18 años, en caso contrario se advierte que las posibles responsabilidades que pudieran devengarse como consecuencia del uso de nuestras Plataformas serán de cuenta de los padres o tutores del menor.</p><p> Para evitar el uso de nuestros servicios por menores de edad, tratamos de verificar la edad de nuestros usuarios cuando formalizan su registro mediante la solicitud de su fecha de nacimiento.</p><h2>¿QUÉ MEDIDAS DE SEGURIDAD TENEMOS IMPLANTADAS?</h2><p> Las medidas de seguridad adoptadas por INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U son aquellas requeridas, de conformidad con lo establecido en el artículo 32 del RGPD.</p><p> En este sentido, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U teniendo en cuenta el estado de la técnica, los costes de aplicación y la naturaleza, el alcance, el contexto y los fines del tratamiento, así como los riesgos de probabilidad y gravedad variables para los derechos y las libertades de las personas físicas, tiene establecidas las medidas técnicas y organizativas apropiadas para garantizar el nivel de seguridad adecuado al riesgo existente.</p><p> En todo caso, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U tiene implementados los mecanismos suficientes para:</p><p> Garantizar la confidencialidad, integridad, disponibilidad y resiliencia permanentes de los sistemas y servicios de tratamiento.</p><p> Restaurar la disponibilidad y el acceso a los datos personales de forma rápida, en caso de incidente físico o técnico.</p><p> Verificar, evaluar y valorar, de forma regular, la eficacia de las medidas técnicas y organizativas implantadas para garantizar la seguridad del tratamiento.</p><h2>CAMBIOS EN ESTA POLITICA DE PRIVACIDAD</h2><p> Eventualmente, esta Política de Privacidad puede ser revisada con el fin de actualizar los cambios en la legislación vigente, actualizar los procedimientos de recogida y uso de la información de carácter personal, la aparición de nuevos servicios o la exclusión de otros. Estos cambios serán vigentes a partir de su publicación en la web, por lo que es importante que revises regularmente esta Política de Privacidad con el fin de permanecer informado sobre los cambios habidos.</p>',
    legal_notice:
      ' <h1>Aviso Legal</h1><p>ÚLTIMA REVISIÓN. 08/05/2025<h2>1. Datos identificativos (Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico):</h2><p>Razón social: INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U.<br>CIF: A/31204175,<br>Domicilio: POLIGONO PEÑALFONS S/N 31330 VILLAFRANCA-NAVARRA-ESPAÑA<br>Teléfono: 948 84 33 60<br>Fax: 948 84 33 87<br>Datos registrales: Inscrita en el Registro Mercantil de Navarra al Tomo 606, Folio 93, Hoja NA-363<br><h2>2. Uso de la web:</h2><p><a href=http://carretilla.info target=_blank>www.carretilla.info</a> proporciona el acceso a numerosas informaciones y servicios (en adelante, “los contenidos”) pertenecientes a INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. (en adelante, “IAN S.A.U.”) El USUARIO asume la responsabilidad del uso de la web. Dicha responsabilidad se extiende a los registros que fuese necesario para acceder a determinados servicios o contenidos. En dichos registros el USUARIO será responsable de aportar información veraz y lícita. El USUARIO se compromete a hacer un uso adecuado de los contenidos y servicios que IAN S.A.U ofrece a través de su web y con carácter enunciativo pero no limitativo, a no emplearlos para:<p>(I) Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.<p>(II) Difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico-ilegal, de apología del terrorismo o atentatorio contra los derechos humanos.<p>(III) Provocar daños en los sistemas físicos y lógicos de IAN S.A.U de sus proveedores o de terceras personas, introducir o difundir en la red virus informáticos o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar los daños anteriormente mencionados .<p>(IV) Intentar acceder y, en su caso, utilizar las cuentas de correo electrónico de otros usuarios y modificar o manipular sus mensajes.<p>IAN S.A.U se reserva el derecho de retirar todos aquellos comentarios y aportaciones que vulneren el respeto a la dignidad de la persona, que sean discriminatorios, xenófobos, racistas, pornográficos, que atenten contra la juventud o la infancia, el orden o la seguridad pública o que, a su juicio, no resultaran adecuados para su publicación por no estar relacionados con el objetivo. En cualquier caso, IAN S.A.U como administrador de su web, actuará diligentemente nada más tenga conocimiento de actos cometidos en contra del presente Aviso Legal.<h2>3. Política de enlaces:</h2><p>Los sitios web enlazados no están controlados por IAN S.A.U y IAN S.A.U no se hace responsable de los contenidos de ningún sitio enlazado ni de ningún enlace que se encuentre en cualquier sitio web enlazado, ni de ningún cambio o actualización de tales sitios web (salvo lo estipulado en la cláusula 5). IAN S.A.U sólo le está proporcionando estos enlaces a usted para su comodidad, y la inclusión de cualquier enlace no implica la aprobación del sitio web por IAN S.A.U.<h2>4. Derechos de propiedad intelectual:</h2><p>IAN S.A.U por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo, imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.), titularidad de INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. o bien de sus licenciantes. Todos los derechos reservados. En virtud de lo dispuesto en los artículos 8 y 32.1, párrafo segundo, del Real Decreto Legislativo 1/1996, de 12 de abril, por el que se aprueba el texto refundido de la Ley de Propiedad Intelectual, regularizando, aclarando y armonizando las disposiciones legales vigentes sobre la materia, quedan expresamente prohibidas la reproducción, la distribución y la comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización de IAN S.A.U. El USUARIO se compromete a respetar los derechos de Propiedad Intelectual e Industrial titularidad de INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U.<p>Todos los contenidos publicados en el sitio web y especialmente los diseños, textos, imágenes, vídeos, gráficos, logos, iconos, botones, así como los IAN S.A.Us comerciales, las marcas o dibujos y cualquier otro signo susceptible de utilización industrial y comercial están sujetos a derechos de propiedad intelectual e industrial de INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. En ningún caso se entenderá que se concede licencia alguna o se efectúa renuncia, transmisión, cesión total o parcial de dichos derechos ni se confiere ningún derecho ni expectativa de derecho, y en especial, de alteración, explotación, reproducción, distribución o comunicación pública sobre dichos contenidos sin la previa autorización expresa de INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U.<p>INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. cuenta con la autorización para la publicación en su web de las imágenes, textos y logos de sus clientes.<h2>5. Limitación de responsabilidades:</h2><p>IAN S.A.U responderá de los daños y perjuicios que el usuario pueda sufrir como consecuencia de la utilización del sitio web cuando dichos daños sean directamente imputables a una actuación incorrecta de esta entidad, habiendo probado que no ha cumplido las exigencias y requisitos legales y reglamentariamente establecidos. Es responsabilidad del usuario adoptar todas las medidas técnicas adecuadas para controlar razonablemente los riesgos de la navegación abierta por Internet y evitar daños en sus equipos, pérdida de datos y robo de información confidencial. IAN S.A.U no se hace responsable de los perjuicios que se pudieran derivar de interferencias, omisiones, interrupciones, virus informáticos, averías y/o desconexiones en el funcionamiento operativo de este sitio web o en los aparatos y equipos informáticos de los usuarios, motivadas por causas ajenas a IAN S.A.U, que impidan o retrasen la prestación de los servicios o la navegación por el sitio web, ni de los retrasos o bloqueos en el uso causados por deficiencias o sobrecargas de Internet o en otros sistemas, ni de la imposibilidad de dar el servicio o permitir el acceso por causas no imputables a IAN S.A.U, debidas al usuario, a terceros, o a supuestos de fuerza mayor. IAN S.A.U no será responsable si no tiene conocimiento efectivo de que la actividad o la información a la que remite o recomienda a través de sus enlaces es ilícita o de que lesiona bienes o derechos de un tercero susceptibles de indemnización, o si lo tiene, actúa con diligencia para suprimir o inutilizar el enlace o la información correspondiente.<h2>6. Jurisdicción y leyes aplicables:</h2><p>La ley aplicable al presente contrato será la Ley Española. Para las controversias que pudieren surgir con ocasión del presente contrato, las partes, con renuncia de su fuero propio, se someten expresamente a los Juzgados y Tribunales de Navarra.<h2>7. Generalidades</h2><p>INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. perseguirá el incumplimiento de las presentes condiciones, así como cualquier utilización indebida de su web ejerciendo todas las acciones legales que le puedan corresponder en derecho.<h2>8. Modificación del Aviso Legal:</h2><p>Eventualmente, estas Condiciones de Uso pueden ser revisadas con el fin de actualizar los cambios en la legislación vigente, actualizar nuestros procedimientos de recogida y uso de la información, la aparición de nuevos servicios o la exclusión de otros. Estos cambios serán vigentes a partir de su publicación en la web, por lo que es importante que revises regularmente estas Condiciones de Uso con el fin de permanecer informado sobre los cambios habidos.',
  },
  en: {
    langs: {
      es: "0",
      en: "1",
    },
    paths: {
      home: "/",
      "nuestra-historia": "our-history",
      "proyectos-ayudas": "projects-aid-subsidies",
      "proyectos-rsc": "projects-rsc",
      "proyectos-rsc-ficha": "projects-rsc",
      "quienes-somos": "who-we-are",
      innovacion: "innovation",
      "calidad–y-seguridad-alimentaria": "food-quality-and-safety",
      "mision-vision": "mission-vision",
      "nuestras-marcas": "our-brands",
      "empresas-grupo": "companies-group",
      "empresas-grupo-norenense": "la-norenense",
      exportacion: "export",
      certificaciones: "certifications",
      "sala-de-prensa": "press-room",
      contacto: "contact",
      "compromiso-ian": "commitment-ian",
      productos: "products",
      "ficha-categoria-producto": "products",
      "conservas-vegetales": "vegetable-preserves",
      "platos-preparados": "ready-meals",
      "ficha-producto": "product",
      avisolegal: "legal-notice",
      politica_privacidad: "privacy-policy",
      politica_cookies: "policy-cookies",
      mapa_web: "map-web",
      "carretilla-info": "https://carretilla.info/home",
      interoliva: "https://www.interoliva.com/",
      ian50: "/en/projects-rsc/ian-groups-50th-anniversary-celebration-a-shared-history-of-passion-and-tradition"
    },
    links: {
      home: "/",
      nuestra_historia: "/nuestra-historia",
      proyectos: "/proyectos-ayudas-subvenciones",
      proyectos_rsc: "/proyectos-rsc",
      quienes_somos: "/quienes-somos",
      calidad_innovacion: "/calidad–y-seguridad-alimentaria",
      mision_vision: "/proposito-vision-valores",
      nuestras_marcas: "/nuestras-marcas",
      exportacion: "/exportacion",
      empresas_grupo: "/plantas-del-grupo",
      certificaciones: "/certificaciones",
      sala_prensa: "/sala-de-prensa",
      contacto: "/contacto",
      compromiso_ian: "/compromiso-ian",
      productos: "/productos",
      producto: "/producto",
      conservasvegetales: "/conservas-vegetales",
      esparragos: "/esparragos",
      avisolegal: "/aviso-legal",
      politica_privacidad: "/politica-privacidad",
      politica_cookies: "/politica-cookies",
      mapa_web: "/mapa-web",
      rsc: "/rsc",
    },
    seo: {
      default: {
        title: "Canned vegetables and ready meals | Grupo Alimentario IAN",
        description:
          "We are a leading food company in the production of a wide variety of canned vegetables and ready meals",
      },
      home: {
        title: "Canned vegetables and ready meals | Grupo Alimentario IAN",
        description:
          "We are a leading food company in the production of a wide variety of canned vegetables and ready meals",
      },
      "quienes-somos": {
        title:
          "Leaders in canned vegetables and ready meals| Grupo Alimentario IAN",
        description:
          "We are a leading food company in canned vegetables and ready meals Our Carretilla brand has established us as leaders in the Spanish market for asparagus, peppers and ready meals.",
      },
      "mision-vision": {
        title:
          "Mission, vision and values | Growing sustainably |Grupo Alimentario IAN",
        description:
          "Excellence, quality, innovation, naturalness and sustainability, values that have made our company what it is today.",
      },
      "nuestra-historia": {
        title: "Over 145 years of history | Grupo Alimentario IAN",
        description:
          "Our history began in 1875 with our iconic brand, Carretilla. Find out what has happened in all these years.",
      },
      "empresas-grupo": {
        title: "Our production plants: IAN, Ian Aceitunas, Taboada, Noreñense",
        description:
          "Our production plants: IAN, Ian Aceitunas, Taboada and Noreñense have helped consolidate our company as a leader in the Spanish food sector.",
      },
      productos: {
        title: "Products | Grupo Alimentario IAN",
        description:
          "We are a leading food company in the production of a wide variety of canned vegetables and ready-to-eat ready meals.",
      },
      innovacion: {
        title: "Innovation and R&D&I | Grupo Alimentario IAN",
        description:
          "At Grupo Alimentario IAN, we work every day at the forefront of innovation to offer products adapted to today’s society and pace of life. Learn about our culture of innovation.",
      },
      "calidad–y-seguridad-alimentaria": {
        title: "Food quality and safety | Grupo Alimentario IAN",
        description:
          "We operate under the strictest food quality and safety controls. For example, all our plants are IFS certified, currently the most stringent globally recognized certification in terms of food quality and safety.",
      },
      certificaciones: {
        title: "Certifications | Grupo Alimentario IAN",
        description:
          "We manufacture under quality and food safety standards, complying with the most demanding national and international quality standards.",
      },
      "proyectos-ayudas": {
        title: "Projects, grants and subsidies | Grupo Alimentario IAN",
        description:
          "At Grupo Alimentario IAN, in view of our firm commitment to sustainable development, we participate in various national and international R&D&I projects. Find out more.",
      },
      "nuestras-marcas": {
        title: "Carretilla |Our brands | Grupo Alimentario IAN",
        description:
          "Our century-old brand, Carretilla, has established us as leaders in the Spanish market for asparagus, peppers and ready meals. We also have other brands that make us a leading company in the food sector.",
      },
      "compromiso-ian": {
        title: "Sustainable commitment |Grupo Alimentario IAN",
        description:
          "Grupo Alimentario IAN, committed to a better future. Our purpose is to grow sustainably, with a firm commitment to the environment, to people and to good practices.",
      },
      "proyectos-rsc": {
        title: "CSR Projects |Grupo Alimentario IAN",
        description:
          "At Grupo Alimentario IAN, we work on projects and initiatives to support and accelerate environmental, social, and economic transformations that contribute to sustainable development.",
      },
      exportacion: {
        title: "Exports |Grupo Alimentario IAN",
        description:
          "We are one of the Spanish food groups with the largest international presence. We export our canned vegetables and ready meals to five continents.",
      },
      contacto: {
        title: "Contact Us Grupo Alimentario IAN",
        description:
          "Contact us for any information, questions or suggestions about Grupo Alimentario IAN.",
      },
      "sala-de-prensa": {
        title: "Press | Grupo Alimentario IAN",
        description:
          "Contact us if you are a media professional and need information about Grupo Alimentario IAN.",
      },
    },
    navbar_menu: {
      group_ian: {
        title: "We are grupo IAN",
        sub_groups: {
          quienes_somos: {
            title: "About Us",
            to: "quienes-somos",
          },
          mision_vision: {
            title: "Purpose, Vision and Values",
            to: "mision-vision",
          },
          nuestra_historia: {
            title: "Our Story",
            to: "nuestra-historia",
          },
          empresas_grupo: {
            title: "Our Sites",
            to: "empresas-grupo",
          },
        },
      },
      products: {
        title: "Products",
        sub_groups: {
          "conservas-vegetales": {
            title: "Vegetable Preserves",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "vegetable-preserves" },
            },
          },
          "platos-preparados": {
            title: "Ready Meals",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "ready-meals" },
            },
          },
        },
      },
      quality_innovation: {
        title: "Innovation and Quality",
        sub_groups: {
          innovacion: {
            title: "Innovation",
            to: "innovacion",
          },
          calidad_innovacion: {
            title: "Food Quality and Safety",
            to: "calidad–y-seguridad-alimentaria",
          },
          certificaciones: {
            title: "Certifications",
            to_params: {
              name: "certificaciones",
              params: "",
            },
          },
          proyectos: {
            title: "Projects, Grants and Subsidies",
            to: "proyectos-ayudas",
          },
        },
      },
      our_brands: {
        title: "Carretilla | Our Brands",
        to: "nuestras-marcas",
      },
      commitment: {
        title: "CSR",
        sub_groups: {
          compromiso_ian: {
            title: "IAN's Commitments",
            to: "compromiso-ian",
          },
          proyectos_rsc: {
            title: "CSR Projects",
            to: "proyectos-rsc",
            lang: "es",
          },
        },
      },
      export: {
        title: "Exports",
        to: "exportacion",
      },
      food_service_channel: {
        title: "Catering Sector",
        href: "https://rfh.grupoian.com/",
      },
      contact: {
        title: "Contact",
        sub_groups: {
          contacto: {
            title: "Contact us!",
            to: "contacto",
          },
          sala_prensa: {
            title: "Press Room",
            to: "sala-de-prensa",
          },
        },
      },
      trabaja_ian: {
        title: "IAN Group Works",
        href:
          "https://grupoian.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=2&id_origen=web+corporativa",
      }
    },
    footer: {
      footer: {
        title: "We are grupo IAN",
        logos: [
          {
            href: "https://www.carretilla.info/",
            target: "_blank",
            "img-path": "/img/logos/carretilla_footer.png",
            "img-alt": "Ogo Carretilla IAN - Grupo Alimentario",
          },
          {
            href: "https://www.camaranavarra.com/",
            target: "_blank",
            "img-path": "/img/logos/camaraNavarraLogoEn.jpg",
            "img-alt": "Logo Camara Navarra IAN - Grupo Alimentario",
          },
          {
            href: "https://www.ifs-certification.com/index.php/es/",
            target: "_blank",
            "img-path": "/img/logos/calidad.png",
            "img-alt": "Logo ifs-certification IAN - Grupo Alimentario",
          },
          {
            href: "https://gesprodat.com/",
            target: "_blank",
            "img-path": "/img/logos/gesprodat.png",
            "img-alt": "Logo Esprodat IAN - Grupo Alimentario",
          },
          {
            href: "https://www.orizont.es/",
            target: "_blank",
            "img-path": "/img/logos/logo_orizon.png",
            "img-alt": "Logo Orizon IAN - Grupo Alimentario",
            text: "INNOVACIÓN <br>AGROALIMENTARIA",
          },
        ],
        sub_groups: {
          quienes_somos: {
            title: "About Us",
            to: "quienes-somos",
          },
          mision_vision: {
            title: "Purpose, Vision and Values",
            to: "mision-vision",
          },
          nuestra_historia: {
            title: "Our Story",
            to: "nuestra-historia",
          },
          empresas_grupo: {
            title: "Our Sites",
            to: "empresas-grupo",
          },
        },
      },
      commitment: {
        title: "CSR",
        sub_groups: {
          compromiso_ian: {
            title: "IAN's Commitments",
            to: "compromiso-ian",
          },
          proyectos_rsc: {
            title: "CSR Projects",
            to: "proyectos-rsc",
            lang: "es",
          },
          service: {
            title: "Sustainability and CSR Policy",
            href: "/docs/politica-sostenibilidad-rsc-grupo-ian.pdf",
          }
          
        },
      },
      our_brands: {
        title: "Carretilla | Our Brands",
        sub_groups: {
          brands: {
            title: "Grupo Alimentario IAN Brands",
            to: "nuestras-marcas",
          },
        },
      },
      quality_innovation: {
        title: "Innovation and Quality",
        sub_groups: {
          innovacion: {
            title: "Innovation",
            to: "innovacion",
          },
          calidad_innovacion: {
            title: "Food Quality and Safety",
            to: "calidad–y-seguridad-alimentaria",
          },
          certificaciones: {
            title: "Certifications",
            to_params: {
              name: "certificaciones",
              params: "",
            },
          },
          proyectos: {
            title: "Projects, Grants and Subsidies",
            to: "proyectos-ayudas",
          },
        },
      },
      products: {
        title: "Products",
        sub_groups: {
          "conservas-vegetales": {
            title: "Vegetable Preserves",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "conservas-vegetales" },
            },
          },
          "platos-preparados": {
            title: "Ready Meals",
            to_params: {
              name: "ficha-categoria-producto",
              params: { id: "platos-preparados" },
            },
          },
        },
      },
      export: {
        title: "Exports",
        sub_groups: {
          export: {
            title: "Grupo Alimentario IAN Exports",
            to: "exportacion",
          },
        },
      },
      food_service_channel: {
        title: "Catering Sector",
        sub_groups: {
          service: {
            title: "Hospitality and Catering",
            href: "https://rfh.grupoian.com/",
          },
        },
      },
      contact: {
        title: "Contact",
        sub_groups: {
          contacto: {
            title: "Contact us!",
            to: "contacto",
          },
          trabaja_ian: {
            title: "Work for Grupo IAN",
            href:
              "https://grupoian.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=2&id_origen=web+corporativa",
          },
          sala_prensa: {
            title: "Press Room",
            to: "sala-de-prensa",
          },
          siguenos: {
            title: "Follow Us",
            href: "https://www.linkedin.com/company/carretilla/",
            icon: "fa fa-linkedin",
          },
        },
      },
    },
    sub_footer: {
      0: {
        title: "Terms and Conditions",
        to: "avisolegal",
      },
      1: {
        title: "Reporting Channel",
        href: "https://canal-de-comunicacion.grupoian.com/",
      },
      2: {
        title: "Privacy Policy",
        to: "politica_privacidad",
      },
      3: {
        title: "Cookies Policy",
        to: "politica_cookies",
      },
      4: {
        title: "Site Map",
        to: "mapa_web",
      },
      5: {
        title: "Contact",
        to: "contacto",
      },
    },
    home: {
      intro: {
        juntos: "#TogetherWeAreGrupoIAN",
        atulado: "WITH YOU SINCE 1875",
        apostamos: "WE STAND FOR QUALITY AND INNOVATION",
        conoce: "Conoce nuestros proyectos rsc",
        exportamos: "WE EXPORT TO  5 CONTINENTS",
        nuestros_productos: "Our Products",
        rsc: "OUR COMMITMENT TO MAKING A BETTER FUTURE",
        rsc_background: "/img/banner-rsc-home-en.jpg",
        interoliva: "NEW INCORPORATION TO IAN FOOD GROUP",
      },
      proyects_home: {
        img: "/img/logo-rsc-en.png",
        text:
          "<p>As well as <strong>our unwavering dedication to sustainable development</strong> and respect for the environment, Grupo IAN has also adopted a <strong>range of CSR policies</strong> that promote socio-economic development.</p>",
      },
      banner_calidad: {
        img: "/img/banner-calidad.jpg",
        title: "Food Quality and Safety",
      },
      banner_our_brand: {
        title: "Discover Our <br/>Centenary Marca <br/>Carretilla",
        img: "/img/banner-carretilla-new.png",
      },
      banner_foodservice: {
        title: "Catering Sector",
        img: "/img/mercados-3.jpg",
        exportacion: {
          titulo: "Exports",
          cuerpo:
            "Around <strong>43%</strong> of our sales consist of exports to more than <strong>54</strong> countries across <strong>5</strong> continents.",
        },
      },
    },
    our_history: {
      init_view: {
        title: "Our story begins in <strong>1875</strong>",
        action: "Would you like to hear about it?",
      },
      "1875_view": {
        title: "Carretilla - The Very Beginning",
        text:
          "<p>Carretilla began as a small artisan workshop in San Adrián, Navarre, producing jarred asparagus and other vegetables.</p><p>As the business grew, it gradually began to play a significant role in the town’s social and economic development.</p>",
        sub_img: "/img/historia/1875-1.png",
        action: "FUN FACT!",
        modal_text:
          "<p class='title'>Women at Grupo IAN</p><p>Women have played a very important role in the company’s history. Right from the very beginning, a large proportion of the workforce were women, something that wasn’t very common at the time.</p><p>We’re extremely grateful to all of them!</p>",
      },
      "1975_view": {
        title: "Grupo IAN",
        text_1:
          "<p>Grupo IAN was originally founded by a group of local businessmen and farmers who belonged to a workers’ cooperative in Villafranca, Navarre.</p>",
        text_2:
          "<p>They wanted to ensure that there was work for their members throughout the year and try to slow down the pace of depopulation in the local area. So, they established the company to make products that would guarantee steady work in the town. In the vegetable preserves sector, this was quite innovative at the time.</p>",
        action: "FUN FACT!",
        modal_title: "Fun fact",
        modal_text:
          "<p>Durante los años previos a nuestro nacimiento, registramos la marca de conservas vegetales “La Flor de Navarra” y fue unos años después cuando registramos la marca “La Carretilla” para nuestros espárragos y conservas vegetales.</p><p>Además, conseguimos el título de Empresa Ejemplar como reconocimiento a nuestro comportamiento económico y, sobre todo, social.</p>",
        modal_img: "/img/historia/curiosidad-1975.png",
      },
      "1988_view": {
        title: "Growth in The Market",
        text:
          "<p>In 1988, we became part of Grupo Viscofán and the business began to expand, starting with the acquisition of the Comaro Factory in Casas del Monte, Extremadura, which produced and sold table olives.</p>",
        logo_1: "/img/historia/1988-2.png",
        logo_2: "/img/empresa-comaro-old.svg",
        sub_img: "/img/historia/1988-1-en.png",
      },
      "1989_view": {
        title: "Industrias Muerza Joins The Family",
        text:
          "<p>The group continued to grow with the addition of Industrias Muerza, based in San Adrián, Navarre, which was a leading producer of jams and the owner of the Carretilla and Bebé brands.</p><p>The Bebé brand and the jam production factory were then sold in order to invest in our innovative Carretilla Ready Meals project.</p>",
      },
      "1998_view": {
        title: "Leaders in The National Asparagus Market",
        text:
          "<p>In 1997, the Carretilla brand was relaunched, and by 1998, we had consolidated our position as leaders in the asparagus market.</p>",
        sub_img: "/img/historia/1998-1.png",
        action: "SEE TV ADVERT!",
        modal_title: "TV ADVERT",
        modal_iframe: "https://www.youtube.com/embed/AwUwFdfGsbk",
      },
      "2005_view": {
        title: "Launch of Our New Carretilla Ready Meals",
        text:
          "<p>Throughout 2005, we continued to develop innovative new products for our Carretilla ready meals range.</p><p>Thanks to these recipes, with their intense, natural taste, today we are Spain’s leading producer of non-refrigerated ready meals and salads.</p>",
        sub_img: "/img/historia/2004-1.png",
      },
      "2015_view": {
        title: "We Become Part of Portobello Capital and Acquire Taboada",
        text:
          "<p>In 2015, the group was acquired by Portobello Capital, a Spanish investment company with a successful history in the food sector.</p><p>The group then pursued a growth strategy through the incorporation of new companies. The first to join was Taboada, a company based in Funes, Navarre, with a long history in the vegetable preserves sector.</p>",
        logo_1: "/img/historia/2015-2.svg",
        logo_2: "/img/empresa-taboada.svg",
      },
      "2016_view": {
        title: "Productos Noreñenses Joins The Group",
        text:
          "<p>Productos Noreñenses, S.L. became part of the group in 2016. The company is based in Noreña, Asturias, and is a leading producer of meat and legume-based ready meals, mainly inspired by traditional Asturian home cooking.</p><p>As a leader in the sector with a long and successful history, the company further complemented our range of canned products.</p>",
        logo_1: "/img/historia/logo-norenense.svg",
        sub_img: "/img/historia/2016-1.png",
        sub_title: "Well Cooked Dishes",
      },
      "2020_view": {
        background: "/img/historia/libro-historia-completo-en.png",
        title: "Carretilla Turns 145!",
        text:
          "<p>In 2020, our iconic Carretilla brand celebrated its 145th birthday.</p><p>To commemorate this milestone, we updated the logo and brand image, winning the Best Branding: Packaging category at the Best Awards 2020.</p><p>During the COVID-19 pandemic, Grupo Alimentario IAN continued to further consolidate its social and economic commitments through various CSR policies.</p><p>This same year, we unveiled our new corporate offices in Tajonar, Pamplona.</p> <img class='hidde-destop img-video-2020' src='/img/historia/mobile-historia-2020-en.png'>",
        link: "https://www.youtube.com/watch?v=D8wLZoTncHU",
      },
      "2021_view": {
        title: "Our Commitment to Innovation Continues",
        text:
          "<p>At Grupo Alimentario IAN, we have an unwavering commitment to innovation. We participate in various projects and constantly seek to offer new products that satisfy the needs and demands of our consumers, both young and old, as well as coeliacs, vegetarians and vegans.</p>",
      },
      "2023_view": {
        sub_img_1: "/img/historia/circle_2023.svg",
        title: "Sustainability and CSR Strategy",
        text:
          "<p>Through engagement with all our stakeholders, Grupo Alimentario IAN has developed a Sustainability and CSR Strategy for 2022-2026. This strategy details specific actions to drive transformation in three key areas: Commitment to the Environment, Commitment to People, and Commitment to Best Practices.</p>",
        sub_img_2: "/img/historia/images-sostenibilidad-en.png",
      },
      "2024_view": {
        title: "¡We keep growing!",
        text:
          "<p>The company Internacional Olivarera, S.A, (Interoliva), located in Dos Hermanas (Seville) and dedicated since 1898 to the production, packaging and marketing of olives, will become part of Grupo Alimentario IAN this year 2024.</p>",
        logo_1: "/img/historia/interoliva-logo.svg",
        sub_img: "/img/historia/2024-1.png",
        text_img: "Green table olives!",
      },
      "2025_view": {
        title: "This year, Grupo Alimentario IAN has much to celebrate:",
        btn: "Discover our story!",
        text:
          "<p>Our brand, Carretilla, is turning 150, and #ItIsNoCoincidence...</p><p>It is Tradition, it is Quality, it is Naturalness, it is Flavor, it is Innovation… It’s about never ceasing to amaze the people who stand by our side.</p><p>We are also commemorating the 50th anniversary of the opening of the Industrias Alimentarias de Navarra factory in Villafranca (Navarra).</p><p>Discover our history!</p>",
        logo_1: "/img/historia/ian50.svg",
      },
    },
    projects_grants_subsidies: {
      title: "Projects, Grants and Subsidies",
      main_banner: {
        img: "/img/intro-proyectos.jpg",
        text:
          "<p>Grupo IAN participates in a <strong>large number of national and international</strong> R&D+i projects to develop new products that best address the needs and demands of our customers and consumers.</p>",
        sub_text:
          "<p class='Below you will find information about all the grants and subsidies that Grupo Alimentario IAN has received to run these various projects at its production centres.</p>",
      },
      btn_more_info: "More information",
    },
    projects_rsc: {
      title: "CSR Projects",
      main_banner: {
        img: "/img/intro-proyectos-rsc.jpg",
        title: "Initiatives",
        text:
          "<p>Grupo Alimentario IAN runs several social and economic initiatives to ensure that we make a positive contribution to the regions and communities where we are present.</p>",
      },
      filters: {
        default_opt: "All categories",
        btn_text: "Search",
      },
      result_projects: {
        not_result: "There are no results for your search.",
        show_project: "Find out more",
      },
    },
    project_rsc_details: {
      btn_back: "Go Back",
      share: "Share",
      tips:
        "You might also be interested in the following projects and initiatives",
    },
    about_us: {
      title: "About Us",
      main_banner: {
        img: "/img/intro-quienes-somos.jpg",
        imgMobile: "/img/intro-quienes-somos_responsive.jpg",
        title: "We are leaders in our sector!",
        text:
          "<p><strong>Grupo Alimentario IAN</strong> (Industrias Alimentarias de Navarra) is a leading food company and a pioneering producer of a wide range of <strong>vegetable preserves and ready meals</strong>.</p>",
      },
      groupIAN_banner: {
        img: "/img/banner-sobre-nosotros.jpg",
        title: "About Grupo IAN",
        text:
          "<p>Aside from our head offices in <strong>Tajonar</strong> (Navarre), we also have important production sites in other locations across Spain, including our <strong>IAN</strong> site in Villafranca (Navarre), our <strong>Comaro</strong> plants in Casas del Monte (Cáceres) and Morón de la Frontera (Seville), our <strong>Taboada</strong> site in Funes (Navarre), the <strong>Productos Noreñenses</strong> plant in Noreña (Asturias) and <strong>Interoliva</strong> (Seville).</br> From these locations, we supply products both domestically and internationally to wholesalers, caterers, industrial customers, private labels and other third-party brands.</p>",
      },
      history_banner: {
        title: "Carretilla,<br> since 1875",
        text:
          "<p>With <strong>more than 145 years of history</strong>, Carretilla is our most iconic brand. Through Carretilla, we have established ourselves as the leading Spanish supplier of asparagus and non-refrigerated microwaveable ready meals.</p><p><a href='https://www.carretilla.info/home' class='enlace-flecha' target='_blank'>VISIT THE CARRETILLA WEBSITE</a></p>",
        img1: "/img/quienes-somos-1.jpg",
        img2: "/img/quienes-somos-2.jpg",
      },
      markets_banner: {
        title: "Markets",
        text:
          "<p>Grupo Alimentario IAN offers bespoke solutions for <strong>wholesalers, caterers, industrial customers, private labels and other third-party brands, both domestically and internationally.</strong> With our decades of experience and expert R&D+i team, we can adapt our recipes, formats and branding to satisfy the needs of each customer and market.</p>",
        large_consumption: {
          img: "/img/mercados-1.jpg",
          title: "Wholesale",
          text:
            "<p>As a company that is constantly innovating, we supply the wholesale sector with a wide variety of high-quality food products developed to satisfy current consumer demands and trends.</p>",
        },
        distribution_entities: {
          img: "/img/mercados-2.jpg",
          title: "Private labels and third-party brands",
          text:
            "<p>We produce bespoke products and recipes for private labels and third-party brands.</p>",
        },
        food_service: {
          img: "/img/mercados-3.jpg",
          title: "Catering sector",
          text:
            "<p>We make life easier for catering professionals and help make their businesses more successful by offering a wide range of catering solutions consisting of different brands and products.</p>",
        },
        industrial_sales: {
          img: "/img/mercados-4.jpg",
          title: "Industrial sales",
          text:
            "<p>We supply specific products in industrial formats for use as ingredients in our customers’ own products.</p>",
        },
      },
    },
    innovacion: {
      title: "Innovation",
      main_banner: {
        img: "/img/intro-innovacion.jpg",
        title: "At the forefront of innovation!",
        text:
          "<p>Innovation, one of our main values and a key part of our culture.</p>",
      },
      security_banner: {
        title: "Seguridad Alimentaria",
        text:
          "<p>Fabricamos bajo <strong>estrictos estándares de calidad</strong> y seguridad alimentaria, alcanzando el <strong>máximo nivel de excelencia</strong> y cumpliendo con los estándares más exigentes, tanto a nivel nacional como internacional.</p>",
        img1: "/img/innovacion-4.jpg",
        img2: "/img/innovacion-2.jpg",
        img3: "/img/innovacion-3.jpg",
      },
      innovation: {
        img: "/img/imagen-idi.jpg",
        title: "R&D+i",
        text:
          "<p>We are proud to have a multidisciplinary Research & Development and Innovation team that has implemented an <strong>innovation culture</strong> across all of our production sites.</p>",
      },
    },
    quality_security: {
      title: "Food Quality and Safety",
      main_banner: {
        img: "/img/intro-calidad.jpg",
        title: "Food Quality and Safety",
        text:
          "<p>We comply rigorously with both national and international health and hygiene standards. We also meet the requirements of the most demanding certifications to guarantee the highest quality standards in the production of all our products.</p>",
      },
      security_banner: {
        title: "Food Safety",
        text:
          "<p>All our products are produced according to <strong>strict food quality</strong> and safety regulations. We have a firm commitment to <strong>achieving excellence</strong> and complying with the most rigorous national and international standards.</p>",
        img1: "/img/seguridad-1.jpg",
        img2: "/img/seguridad-2.jpg",
        img3: "/img/seguridad-3.jpg",
      },
      innovation: {
        img: "/img/imagen-idi.jpg",
        title: "R&D+i",
        text:
          "<p>We are proud to have a multidisciplinary Research & Development and Innovation team that has implemented an <strong>innovation culture</strong> across all of our production sites.</p><p>Our levels of <strong>investment in R&D+i exceed current regional, national and European averages</strong>.</p>",
      },
    },
    purpose_vision_values: {
      title: "Purpose, Vision and Values",
      main_banner: {
        img: "/img/intro-proposito.jpg",
        title: "We are Grupo Alimentario IAN",
        text:
          "<p>Our purpose is our raison d’être. It is shaped by who we are, what we do and what we want to be. And coupled with our values, it guides us as we seek to move forward together.</p>",
      },
      purpose_banner: {
        title: "Purpose",
        text:
          "<p>At Grupo Alimentario IAN, we are inspired and driven by a <strong>desire to grow in a sustainable</strong> way while observing the key values of honesty, humility, equality, solidarity and respect. We want to contribute towards achieving great changes through small actions in accordance with the United Nations Sustainable Development Goals (SDGs).</p><p>We are committed to helping society. We offer our customers and consumers a <strong>wide range of safe, high-quality food products</strong> to make people’s lives easier and help them to maintain a healthier, more balanced diet.</p>",
        img1: "/img/banner-proposito-1-qs.jpg",
        img2: "/img/banner-proposito-2.jpg",
        img3: "/img/banner-proposito-3.jpg",
      },
      vision_banner: {
        img: "/img/imagen-vision.jpg",
        title: "Vision",
        text:
          "<p>Our goal is to be recognised by our owners, employees, customers, consumers, suppliers and wider society as <strong>leaders and pioneers in the food sector</strong>. We strive to achieve this through <strong>constant innovation, quality assurance and sustainable development</strong> to contribute towards making a better future for everyone.</p>",
      },
      circles_banner: {
        title: "Strategic Values and Principles",
        text:
          "<p>Ever since Grupo Alimentario IAN was first founded, we have been driven by the pursuit of <strong>excellence, quality, naturalness and innovation</strong>. We are firmly committed to running our business ethically, responsibly and transparently. We want to generate value and employment and contribute towards the well-being and sustainability of society wherever we are present.</p>",
        circles: {
          0: {
            id: "calidad",
            title: "QUALITY AND INNOVATION",
            text:
              "At Grupo IAN, our levels of investment in R&D+i exceed current regional, national and European averages. All our factories are IFS-certified.",
          },
          1: {
            id: "marca-carretilla",
            title: "CARRETILLA",
            text:
              "First created in 1875, today Carretilla is trusted for its high-quality, natural products that perfectly combine tradition with innovation.",
          },
          2: {
            id: "persona",
            title: "PEOPLE TEAM",
            text:
              '<span><i class="fa-solid fa-check"></i> Promotion and development of people and their talent</span><br> <span><i class="fa-solid fa-check"></i> Creating an inclusive, collaborative and positive working environment.</span>',
          },
          3: {
            id: "produccion",
            title: "SPECIALIST PRODUCTION CENTRES",
            text:
              "Each one of the group’s production centres is an independent, specialised factory. Our R&D+I department then achieves synergies by sharing improvements across our sites.",
          },
          4: {
            id: "vocacion",
            title: "INTERNATIONAL PERSPECTIVE",
            text:
              "At Grupo IAN, 43% of our sales consist of exports to customers across 5 continents.",
          },
          5: {
            id: "sostenibilidad",
            title: "SUSTAINABILITY",
            text:
              "Our 1st Sustainability and CSR Strategy establishes three key focus areas: Commitment to the Environment, Commitment to People and Commitment to Best Practices.",
          },
          6: {
            id: "dimension",
            title: "BESPOKE SCALING AND DEVELOPMENTS FOR OUR CUSTOMERS",
            text:
              "The capacity of our plants gives us the flexibility to develop bespoke solutions for private labels and third parties and scale them accordingly.",
          },
        },
      },
    },
    our_brands: {
      title: "Carretilla | Our Brands",
      main_banner: {
        text:
          "<p>Grupo IAN owns a number of brands that are distributed both domestically and internationally, the most iconic of which is Carretilla, the leading Spanish supplier of asparagus, peppers and non-refrigerated microwaveable ready meals.</p>",
        img: "/img/intro-nuestras-marcas.jpg",
      },
      history_banner: {
        title: "Carretilla, since 1875",
        text:
          "<p><strong>Asparagus, Vegetable Preserves and Ready Meals</strong></p><p>Since 1875, we have worked hard to offer top-quality products that are adapted to the pace and style of modern life. Thanks to its success, Carretilla is today a leading Spanish brand, recognised by consumers for the quality of its products.</p>",
        img: "/img/imagen-banner-carreta.jpg",
        btn_text: "Visit the Carretilla Website",
      },
      other_brands_banner: {
        title: "Other Grupo IAN Brands",
        categories: [
          {
            id: "salsas-tomate",
            name: "Tomato Sauces and Related Products",
            slug: "salsas-tomate",
            dropdown: {
              title: "IAN",
              text:
                "<p>With the valuable experience of almost <strong>50 years producing tomatoes</strong>, we carefully select and prepare the produce to preserve its taste, texture and aroma. Our <strong>Tomates IAN</strong> range stands out for its completely natural flavour and contains no preservatives or thickening agents. A wide variety of tomato sauces to cater for your every need, whether at home or in the hospitality sector.</p>",
            },
          },
          {
            id: "esparragos",
            name: "Asparagus and <br>Preserved Vegetables",
            slug: "esparragos",
            dropdown: {
              title: "Alesves",
              text:
                "<p>We distribute <strong>jarred asparagus, chopped and fried tomatoes and tomato sauces</strong> under our Alesves brand. Alesves white asparagus is especially targeted at the catering sector and is appreciated for its unmistakable taste, tender texture and lack of stringy fibres.</p>",
            },
          },
          {
            id: "aceitunas-2",
            name: "Olives",
            slug: "aceitunas",
            dropdown: {
              title: "Comaro y Morenita",
              text:
                "<p>Since 1988, we have processed both <strong>green and black olives</strong> at our COMARO site in the province of Cácares for export to more than 50 countries around the world.</p>",
            },
          },
          {
            id: "platos-en-lata",
            name: "Canned Ready Meals",
            slug: "platos-en-lata",
            dropdown: {
              title: "La Noreñense y El Yantar de Pepe",
              text:
                "<p><strong>EL YANTAR DE PEPE</strong></p><p>As our gourmet brand sold in specialist stores, El Yantar de Pepe <strong>produces canned meals based on traditional Asturian home recipes</strong>. The entire production process is performed using the very latest technology and follows the strictest quality controls.</p><p>Our Fabada Asturiana and Pote Asturiano products are made using Asturian Faba beans with the Protected Geographical Indication mark.</p><p></br><strong>LA NOREÑENSE</strong></p><p>We offer a large catalogue of <strong>products for the wholesale market</strong>, including pork, chicken, beef, fish and vegetable dishes, each one produced according to strict quality standards with absolutely no flavour enhancers or preservatives.</p>",
            },
          },
          {
            id: "salsas-tomate-verduras-legumbres",
            name: "Tomatoes, Vegetables<br>and Legumes",
            slug: "salsas-tomate-verduras-legumbres",
            dropdown: {
              title: "Taboada",
              text:
                "<p>We offer an extensive range of products under this brand, including jarred tomatoes and sauces, vegetables and cooked legumes. These products are mainly sold to the international market and the catering sector.</p>",
            },
          },
          {
            id: "aceitunas",
            name: "Table olives",
            slug: "aceitunas",
            dropdown: {
              title: "Marios y Marismas",
              text:
                "<p>In our Interoliva plant, located in Dos Hermanas (Seville), <strong>cradle of the table olive</strong>, we have been dedicated since 1898 to the <strong>production, packaging and marketing</strong> of olives, mainly green with the Gordal and Manzanilla varieties, through our brands <strong>Mario's</strong> and <strong>Marismas</strong></p>",
            },
          },
        ],
      },
      contact_banner: {
        img: "/img/banner-hablamos-en.jpg",
        title: "Private Labels and Third-party Brands",
        text:
          "<p><strong>We can deliver the right product for you</strong></p><p>Our years of experience, expertise and flexibility mean that we can develop bespoke solutions, recipes and formats to meet your requirements.</p>",
        btn_text: "Contact us",
      },
      carretilla_150: {
        title: "Celebrating 150 years,",
        text:
          "<p><strong>It's not a coincidence...</strong></p><p>It's tradition, it's quality, it's naturalness, it's flavor, it's innovation... It's about never ceasing to amaze the people by our side.</p>",
        img: "/img/imagen-banner-carreta-150.jpg",
        btn_text: "Visit the website",
      },
    },
    companies_group: {
      title: "Our Sites",
      main_banner: {
        text:
          "<p>Each one of our production centres has its own history. Thanks to their individual successes, Grupo Alimentario IAN has been able to consolidate itself as a leading producer in the Spanish food sector.</p>",
      },
      companies: [
        {
          id: "ian",
          history_banner: {
            title: "IAN",
            text:
              "<p>At the IAN factory in Villafranca, Navarre, we produce different <strong>preserved vegetables, microwaveable ready meals, tomatoes and sauces</strong>.</p>",
            certifications_slug: "ian",
            btn_text: "SEE CERTIFICATIONS",
            img1: "/img/empresa-grupo-carretilla.jpg",
            img2: "/img/empresa-grupo-carretilla-1.jpg",
            img3: "/img/empresa-grupo-carretilla-2.jpg",
          },
          company_banner: {
            title: "Production Site",
            text: "Villafranca - Navarra, España",
            img1: "/img/imagen-somos-carretilla-1.jpg",
            img2: "/img/imagen-somos-carretilla-2.jpg",
            img3: "/img/imagen-somos-carretilla-3.jpg",
          },
        },
        {
          id: "ian-aceitunas",
          history_banner: {
            title: "IAN Aceitunas",
            text:
              "<p>Our IAN Aceitunas sites in Casas del Monte (Cáceres) and Morón de la Frontera (Seville) are dedicated to dressing, packaging and marketing table olives through our own <strong>Carretilla, Morenita and Comaro</strong> brands. They are also highly specialised in the development of white-label products.</p><p>The processes to produce our <strong>green and black olives</strong> rely on a highly experienced team and the most modern technology in the sector. We <strong>manufacture different varieties of olives</strong>, whether whole, stoned, sliced or halved, to cater for all tastes and needs. We also supply in various packaging options of different sizes, including cans and glass jars.</p>",
            certifications_slug: "ian-aceitunas",
            btn_text: "SEE CERTIFICATIONS",
            img1: "/img/empresa-grupo-comaro.jpg",
            img2: "/img/empresa-grupo-comaro-1.jpg",
            img3: "/img/empresa-grupo-comaro-2.jpg",
          },
          company_banner: {
            title: "Production Site",
            text:
              "<p>Casas del Monte - Cáceres, España</p><p>Morón de la Frontera - Sevilla, España</p>",
            img1: "/img/imagen-somos-comaro-1.jpg",
            img2: "/img/imagen-somos-comaro-2.jpg",
            img3: "/img/imagen-somos-comaro-3.jpg",
          },
        },
        {
          id: "taboada",
          history_banner: {
            title: "Taboada",
            text:
              "<p>Our site in Funes, Navarre, has more than 60 years of history and is dedicated to the production of <strong>high-quality preserved vegetables and legumes</strong>, including beans, lentils, chickpeas and tomato products. Taboada is a leading provider of solutions for the catering sector and foreign markets.</p>",
            certifications_slug: "taboada",
            btn_text: "SEE CERTIFICATIONS",
            img1: "/img/empresa-grupo-taboada.jpg",
            img2: "/img/empresa-grupo-taboada-1.jpg",
            img3: "/img/empresa-grupo-taboada-2.jpg",
          },
          company_banner: {
            title: "Production Site",
            text: "<p>Funes - Navarra, España</p>",
            img1: "/img/imagen-somos-taboada-1.jpg",
            img2: "/img/imagen-somos-taboada-2.jpg",
            img3: "/img/imagen-somos-taboada-3.jpg",
          },
        },
        {
          id: "norenense",
          history_banner: {
            title: "La Noreñense",
            text:
              "<p>Our La Noreñense in Noreña, Asturias, is a <strong>leading producer of meat and legume-based canned ready meals</strong>.</p><p>Its history goes back to <strong>1966</strong> with the emergence of canned meals, a <strong>very new technology</strong> at the time. This innovation inspired three friends who manufactured sausages in Noreña, and they soon began to produce canned fabada and tripe dishes, thus creating the La Noreñense brand.</p>",
            certifications_slug: "norenense",
            btn_text: "SEE CERTIFICATIONS",
            img1: "/img/empresa-grupo-norenense.jpg",
            img2: "/img/empresa-grupo-norenense-1.jpg",
            img3: "/img/empresa-grupo-norenense-2.jpg",
          },
          other_history_banner: {
            img: "/img/banner-empresa-norenense.jpg",
            text:
              "<p>Three years later, in February 1969, the company Productos Noreñenses was officially founded with two partners at the helm. During the 1970s, the brand had a workforce of 14 workers and gradually incorporated new products such as stew, pig's trotters and pork loin. With the arrival of the 1980s, the factory underwent a process of <strong>modernisation and expansion of its facilities</strong>.</p>",
            tetx_view_more:
              "<p>In this way, it strengthened its commitment to <strong>ready meals</strong>, which allowed it to enter new national and international markets. During the 1990s, the factory was further expanded, at which time the company's <strong>gourmet line</strong>, El Yantar de Pepe, was launched. In 2016, a turning point in the history of Productos Noreñense took place and it became part of Grupo Alimentario IAN. In addition to its range of products and its own and third-party brands, it launched a range of canned ready meals under the Carretilla brand. We currently produce a wide range of canned ready meals in this plant, based on pork, chicken, beef, fish, vegetables and pulses, which we distribute mainly in the domestic market.</p>",
            btn_text_more: "See more",
            btn_text_less: "See less",
          },
          video_banner: {
            title: "Get to know our history!",
            link: "https://www.youtube.com/watch?v=FOKiKdhJdGk",
          },
          company_banner: {
            title: "Production Site",
            text: "<p>Noreña - Asturias, España</p>",
            img1: "/img/imagen-somos-norenense-1.jpg",
            img2: "/img/imagen-somos-norenense-2.jpg",
            img3: "/img/imagen-somos-norenense-3.jpg",
          },
        },
        {
          id: "interoliva",
          history_banner: {
            title: "Interoliva",
            text:
              "<p>In our Interoliva plant, located in Dos Hermanas (Seville), <strong>cradle of the table olive</strong>, we have been dedicated <strong>since 1898</strong> to <strong>production, packaging and marketing of olives, mainly green with the Gordal and Manzanilla varieties, through our brands <strong>Mario's and Marismas</strong> .</p>",
            certifications_slug: "interoliva",
            btn_text: "SEE CERTIFICATIONS",
            img1: "/img/empresa-grupo-interoliva.jpg",
            img2: "/img/empresa-grupo-interoliva-1.jpg",
            img3: "/img/empresa-grupo-interoliva-2.jpg",
          },
          company_banner: {
            title: "Production Site",
            text: "<p>Dos Hermanas – Seville, Spain</p>",
            img1: "/img/imagen-somos-interoliva-1.jpg",
            img2: "/img/imagen-somos-interoliva-2.jpg",
            img3: "/img/imagen-somos-interoliva-3.jpg",
          },
        },
      ],
    },
    export: {
      title: "Exports",
      groupIAN_banner: {
        img: "/img/banner-sobre-nosotros-exportacion.jpg",
        title: "About Grupo IAN",
        text:
          "<p>At Grupo Alimentario IAN, we are passionate about taking our products beyond our national borders.<strong>Today, we are one of the biggest international Spanish groups, exporting our products to more than 54 countries</strong>, including Germany, France, the USA, Canada, Australia and Japan. As leaders in <strong>vegetable preserves and a pioneering producer of ready meals</strong>, we strive to offer consumers high-quality, healthy food products, wherever they are in the world. Aside from our vegetable preserves, we also have an extensive catalogue of ready meals based on famous Spanish dishes, such as paella and our pasta meals.</p>",
        btn_text: "FIND OUT MORE",
      },
      in_the_world_banner: {
        title: "Grupo IAN Around The World",
        text:
          "<p>Around 46% of our sales are to countries outside of Spain, with a reach spanning five continents. Each of our products can be easily adapted to the needs of our different markets and customers, whether they require different packaging or their own branding.</p>",
        img1: "/img/banner-proposito-1.jpg",
        img2: "/img/bol-aceitunas.jpg",
        img3: "/img/bodegon-frasco-esparragos.jpg",
        img4: "/img/banner-proposito-4.jpg",
        img5: "/img/banner-proposito-5.jpg",
      },
      branding_banner: {
        img: "/img/banner-creamos-tu-marca.jpg",
        title: "Let Us Create Your Brand",
        text:
          "<p>As well as exporting to numerous countries, we also have <strong>extensive experience in producing white-label products</strong> for our customers. This way, importers and distributors across five continents have the opportunity to create their own brands using our production processes.</p>",
      },
      circles_banner: {
        title: "Strategic Values and Principles",
        text:
          "<p>Ever since Grupo Alimentario IAN was first founded, we have been driven by the pursuit of <strong>excellence, quality, naturalness and innovation</strong>. We are firmly committed to running our business ethically, responsibly and transparently. We want to generate value and employment and contribute towards the well-being and sustainability of society wherever we are present.</p>",
        circles: {
          0: {
            id: "calidad",
            title: "QUALITY AND INNOVATION",
            text:
              "At Grupo IAN, our levels of investment in R&D+i exceed current regional, national and European averages. All our factories are IFS-certified.",
          },
          1: {
            id: "marca-carretilla",
            title: "CARRETILLA BRAND",
            text:
              "First created in 1875, today Carretilla is trusted for its high-quality, natural products that perfectly combine tradition with innovation.",
          },
          2: {
            id: "produccion",
            title: "SPECIALIST PRODUCTION CENTRES",
            text:
              "Each one of the group’s production centres is an independent, specialised factory. Our R&D+I department then achieves synergies by sharing improvements across our sites.",
          },
          3: {
            id: "vocacion",
            title: "INTERNATIONAL PERSPECTIVE",
            text:
              "At Grupo IAN, 43% of our sales consist of exports to customers across 5 continents.",
          },
          4: {
            id: "sostenibilidad",
            title: "SUSTAINABILITY",
            text:
              "Our 1st Sustainability and CSR Strategy establishes three key focus areas: Commitment to the Environment, Commitment to People and Commitment to Best Practices.",
          },
          5: {
            id: "dimension",
            title: "BESPOKE SCALING AND DEVELOPMENTS FOR OUR CUSTOMERS",
            text:
              "The capacity of our plants gives us the flexibility to develop bespoke solutions for private labels and third parties and scale them accordingly.",
          },
        },
      },
      form: {
        title: "Want to talk with us?",
        text:
          "<p><strong>If you have a query or would like more information about Grupo Alimentario IAN, send us a message using the contact form below.<strong></p>",
      },
    },
    certifications: {
      title: "Certifications",
      text:
        "<p>At Grupo IAN, we follow strict quality and safety procedures and comply with the most demanding national and international quality standards.</p>",
      brands: {
        group_ian: {
          id: "ian",
          facilities: [
            {
              title:
                "<p>Production Site | Villafranca - Navarre, Spain</p><p>Microwaveable Ready Meals</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text: "<p>IFS Certified<br>Food Quality and Safety</p>",
                },
                {
                  img: "/img/logo-AAI.png",
                  text: "<p>Integrated Environmental Authorisation (IEA)</p>",
                },
                {
                  img: "/img/logo-ecologico.png",
                  text: "<p>Certified Organic Product</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>FDA Approved</p>",
                },
                {
                  img: "/img/logo-reconcilia.png",
                  text: "<p>Reconcilia Seal for Work-life Balance</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>SAE Certificate</p>",
                },
              ],
            },
            {
              title:
                "<p>Production Site | Villafranca - Navarre, Spain</p><p>Tomatoes and Sauces</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text: "<p>IFS Certified<br>Food Quality and Safety</p>",
                },
                {
                  img: "/img/logo-AAI.png",
                  text: "<p>Integrated Environmental Authorisation (IEA)</p>",
                },
                {
                  img: "/img/logo-ecologico.png",
                  text: "<p>Certified Organic Product</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>FDA Approved</p>",
                },
                {
                  img: "/img/logo-reconcilia.png",
                  text: "<p>Reconcilia Seal for Work-life Balance</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>SAE Certificate</p>",
                },
              ],
            },
          ],
        },
        'ian-aceitunas': {
          id: "ian-aceitunas",
          facilities: [
            {
              title:
                "<p>Production Site | Casas del Monte - Cáceres, Spain</p><p>Olives</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text: "<p>IFS Certified<br>Food Quality and Safety</p>",
                },
                {
                  img: "/img/logo-AAI.png",
                  text: "<p>Integrated Environmental Authorisation (IEA)</p>",
                },
                {
                  img: "/img/logo-ecologico.png",
                  text: "<p>Certified Organic Product</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>FDA Approved</p>",
                },
                {
                  img: "/img/logo-orthodox.png",
                  text: "<p>Orthodox Union (Kosher)</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>SAE Certificate</p>",
                },
              ],
            },
          ],
        },
        taboada: {
          id: "taboada",
          facilities: [
            {
              title:
                "<p>Production Site | Funes - Navarre, Spain</p><p>Tomatoes, Vegetables and Legumes</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text: "<p>IFS Certified<br>Food Quality and Safety</p>",
                },
                {
                  img: "/img/logo-brc-new.png",
                  text: "<p>BRC Certified</p>",
                },
              ],
            },
          ],
        },
        norenense: {
          id: "norenense",
          facilities: [
            {
              title:
                "<p>Production Site | Noreña - Asturias, Spain</p><p>Canned Ready Meals</p>",
              certifications: [
                {
                  img: "/img/logo-ifs.png",
                  text: "<p>IFS Certified<br>Food Quality and Safety</p>",
                },
                {
                  img: "/img/logo-iso.png",
                  text: "<p>ISO 14000 (Environmental Certification)</p>",
                },
                {
                  img: "/img/logo-sae.png",
                  text: "<p>SAE Certificate</p>",
                },
              ],
            },
          ],
        },
        interoliva: {
          id: "interoliva",
          facilities: [
            {
              title:
                "<p>Production Site | Dos Hermanas – Seville, Spain</p><p>olives</p>",
              certifications: [
                {
                  img: "/img/logo-brc-new.png",
                  text: "<p>Global Food Safety Standard</p>",
                },
                {
                  img: "/img/logo-fda.png",
                  text: "<p>FDA Approved</p>",
                },
                {
                  img: "/img/logo-orthodox.png",
                  text: "<p>Orthodox Union (Kosher)</p>",
                },
              ],
            },
          ],
        },
      },
      btn_text: "SEE PLANT",
    },
    press_room: {
      title: "Press Room",
      main_banner: {
        img: "/img/intro-sala-prensa.jpg",
        title: "Contact us!",
        text:
          "<p>Are you in the media industry? We will help you with everything you need to know about Grupo Alimentario IAN.</p>",
      },
    },
    contact: {
      title: "Contact",
      main_banner: {
        img: "/img/intro-contacto.jpg",
        title: "Grupo Alimentario IAN <span>(Head Offices)</span>",
        text:
          "<p class='direccion'>Pol. Ind. Berroa. C/ Berroa 13, 1ª planta. 31192, Tajonar (Navarra)</p><p class='telefono'><a href='tel:948843360'>948 84 33 60</a></p><p class='email'><a href='mailto:info@grupoian.com'>info@grupoian.com</a></p>",
      },
      map: {
        title: "Where to find us",
        locations: {
          "grupo-ian": {
            id: "grupo-ian",
            slug: "grupo-ian",
            name: "Grupo Alimentario IAN",
            subname: "Head Offices",
            pos: {
              lat: 42.77302062940062,
              lng: -1.626974947202869,
            },
            address:
              "Pol. Ind. Berroa. C/ Berroa 13, 1ª planta. 31192, Tajonar (Navarra)",
            phone: ["948 84 33 60", "948 84 33 87"],
            email: ["info@grupoian.com"],
          },
          "ian-sau": {
            id: "ian-sau",
            slug: "ian-sau",
            name: "IAN, S.A.U.",
            subname: "(Villafranca)",
            pos: {
              lat: 42.3022871,
              lng: -1.7381284,
            },
            address: "Pol Peñalfons s/n, 31330 Villafranca, Navarra",
            phone: ["948 84 33 60", "948 84 33 87"],
            email: ["info@grupoian.com"],
          },
          'ian-aceitunas': {
            id: "ian-aceitunas",
            slug: "ian-aceitunas",
            name: "IAN Aceitunas",
            subname: "(Casas del Monte)",
            pos: {
              lat: 40.2084173,
              lng: -5.9851828,
            },
            address:
              "Barrio de la estación, s/n – 10730, Casas del Monte (Cáceres)",
            phone: ["927 179 031"],
          },
          "ian-aceitunas-moron": {
            id: "comaro-moron",
            slug: "ian-aceitunas-moron",
            name: "IAN Aceitunas",
            subname: "(Morón de la Frontera)",
            pos: {
              lat: 37.1245881,
              lng: -5.4630408,
            },
            address:
              "Carretera A 361 Marchena p k 12, 41530 Morón de la Frontera, (Sevilla)",
            phone: ["673 29 27 54"],
          },
          taboada: {
            id: "taboada",
            slug: "taboada",
            name: "Taboada",
            subname: "(Funes)",
            pos: {
              lat: 42.3340688,
              lng: -1.7895691,
            },
            address: "Ctra.Marcilla, s/n, 31360, Funes (Navarra), España",
            phone: ["948 754 179"],
          },
          norenense: {
            id: "norenense",
            slug: "norenense",
            name: "Productos Noreñense",
            subname: "(Noreña)",
            pos: {
              lat: 43.3912238,
              lng: -5.7167731,
            },
            address: "Avenida de Oviedo, 31, 33180, Noreña, (Asturias)",
            phone: ["958 740 276"],
          },
          interoliva: {
            id: "interoliva",
            slug: "interoliva",
            name: "Interoliva",
            subname: "(Dos Hermanas)",
            pos: {
              lat: 37.293047719427456,
              lng: -5.927835131585038,
            },
            address: "Garcilaso de la Vega 2, 41704, Dos Hermanas (Sevilla)",
            phone: ["955 660 440"],
          },
        },
      },
      form: {
        title: "Want to talk with us?",
        text:
          "<p class='waypoints'><strong>If you have a query or would like more information about Grupo Alimentario IAN, send us a message using the contact form below.</strong></p>",
        inputs: [
          {
            id: "communication_media",
            type: "text",
            rules: "required",
            placeholder: "Medio de Comunicación*",
            middle: 0,
            view: "sala-de-prensa",
          },
          {
            id: "fullname",
            type: "text",
            rules: "required",
            placeholder: "First and Last Name*",
            middle: 0,
          },
          {
            id: "email",
            type: "text",
            rules: "required|email",
            placeholder: "E-mail*",
            middle: 1,
          },
          {
            id: "phone",
            type: "text",
            rules: "required",
            placeholder: "Telephone No.*",
            middle: 1,
          },
          {
            id: "subject",
            type: "text",
            rules: "required",
            placeholder: "Subject*",
            middle: 0,
          },
          {
            id: "message",
            type: "text",
            rules: "required",
            placeholder: "Message*",
            middle: 0,
          },
          {
            id: "privacy",
            type: "checkbox",
            rules: "required",
            label:
              "I have read and understood the <a style='text-decoration: underline;' href='/en/privacy-policy' target='_blank'>Privacy Policy.</a>",
          },
        ],
        legal_text:
          "<p class='legal waypoints'>In accordance with current data protection legislation, we hereby inform you that the Data Controller for your personal data is INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. Your data will be used to respond to your requests for information. This processing is based on your given consent. Any personal data collected will not be shared with any third parties under any circumstances unless expressly required to do so by law. You can exercise any of your data protection rights by writing to info@grupoian.com. You can find more information about data protection by clicking on this link.</p>",
        btn_text: "Send",
        success_popup: {
          title: "Message received!",
          text:
            "<p>Thank you for contacting Grupo Alimentario IAN.</p><p>We will contact you as soon as possible.</p>",
          btn_text: "Go Back",
        },
      },
      information_banner: {
        img: "/img/banner-trabaja-en.jpg",
        title: "Work for Grupo IAN",
        text:
          "<p class='waypoints'>Would you like to join our team?<br><strong>We are looking for people like you.</strong></p>",
        btn_href:
          "https://grupoian.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=2&id_origen=web+corporativa",
        btn_text: "Find out more information",
      },
    },
    commitment: {
      title: "IAN’s Commitments",
      main_banner: {
        img: "/img/rsc/banner-intro-en.jpg",
        btn_img: "/img/rsc/hoja-down.svg",
      },
      objectives_banner: {
        text:
          "<p>At Grupo Alimentario IAN, we have a clear purpose that inspires and guides us: <strong>to grow through sustainability</strong>, grounded in honesty, humility, fairness, respect and solidarity. We believe that results are achieved through daily actions aligned with the United Nations Sustainable Development Goals (SDGs).</p><p>Our 2026-2030 CSR and Sustainability Plan strengthens our commitment to the environment and to society, <strong>expanding our scope to cover 14 of the 17 SDGs.</strong> Of these, we prioritise SDG 2, SDG 3, SDG 6, SDG 7, SDG 8, SDG 12 and SDG 13 as key objectives on which to focus the tactical actions of our strategy.</p><p>We also actively contribute to other relevant SDGs such as SDG 4, SDG 5, SDG 9, SDG 10, SDG 11, SDG 16 and SDG 17.</p>",
        img: "/img/rsc/grafica-objetivos-en.svg",
      },
      option_commitments_banner: {
        options: [
          {
            id: "environment",
            img: "/img/rsc/comprometidos-ma-en.svg",
            imgMobile: "/img/rsc/comprometidos-ma-responsive-en.svg",
            alt: "COMMITMENT to the Environment",
          },
          {
            id: "people",
            img: "/img/rsc/comprometidos-personas-en.svg",
            imgMobile: "/img/rsc/comprometidos-personasa-responsive-en.svg",
            alt: "COMMITMENT to People",
          },
          {
            id: "good-practice",
            img: "/img/rsc/comprometidosbuenas-practicas-en.svg",
            imgMobile:
              "/img/rsc/comprometidosbuenas-practicas-responsive-en.svg",
            alt: "COMMITMENT to Best Practices",
          },
        ],
        btn_text: "FIND OUT MORE",
        img: "/img/rsc/bg-campo.svg",
      },
      commitments: [
        {
          id: "environment",
          img: "/img/rsc/img-medio-ambiente.png",
          alt: "COMMITMENT to the Environment",
          title:
            "<p class='title'>COMMITMENT<br><span>to the <span class='green'> Environment</span></span></p>",
          icons: [
            {
              img: "/img/rsc/ma-1-en.png",
            },
            {
              img: "/img/rsc/ma-2-en.png",
            },
            {
              img: "/img/rsc/sello-9-en.svg",
            },
            {
              img: "/img/rsc/ma-3-en.png",
            },
            {
              img: "/img/rsc/ma-4-en.png",
            },
          ],
          text: "<p>We promote and reinforce the protection of our environment.</p>",
          objectives: [
            {
              img: "/img/rsc/eficiencia-energetica.jpg",
              title: "Energy Efficiency Plan: Water and Energy",
              text:
                "<p>We optimise energy consumption and encourage the use of renewables.</p>",
            },
            {
              img: "/img/rsc/reduccion-impactos.jpg",
              title: "Emissions<br> Reduction Plan",
              text:
                "<p>We are progressing towards decarbonisation with a comprehensive plan that reduces our carbon footprint and promotes the use of renewable energy.</p>",
            },
            {
              img: "/img/rsc/economia-circular.jpg",
              title: "Sustainable <br>Packaging",
              text:
                "<p>We promote packaging solutions with a lower environmental impact, opting for biodegradable materials and encouraging their recyclability.</p>",
            },
          ],
        },
        {
          id: "people",
          img: "/img/rsc/img-personas.png",
          alt: "COMMITMENT to People",
          title:
            "<p class='title'>COMMITMENT<br><span>to <span class='green'> People</span></span></p>",
          icons: [
            {
              img: "/img/rsc/cp-1-en.png",
            },
            {
              img: "/img/rsc/cp-2-en.png",
            },
            {
              img: "/img/rsc/cp-3-en.png",
            },
            {
              img: "/img/rsc/cp-4-en.png",
            },
            {
              img: "/img/rsc/sello-8-en.svg",
            },
            {
              img: "/img/rsc/cp-6-en.png",
            },
            {
              img: "/img/rsc/sello-11-en.svg",
            },
          ],
          text:
            "<p>We engage our employees and the wider community in sustainable management based on communication, participation, collaboration and transparency.</p>",
            objectives: [
              {
                img: "/img/rsc/alimentacion-equilibrada.jpg",
                title: "Balanced Nutrition",
                text:
                  "<p>We promote a balanced diet aligned with a healthy lifestyle, based on flavour, quality and respect for people.</p>",
              },
              {
                img: "/img/rsc/hambre-pobreza.jpg",
                title: "Social Commitment and Community Engagement",
                text:
                  "<p>Through our social commitment, we drive charitable initiatives, collaborate with social organisations and support local, social and cultural development.</p>",
              },
              {
                img: "/img/rsc/integridad.jpg",
                id: "integridad",
                title: "Talent, Inclusion and Professional Development",
                text:
                  "<p>We foster a stable and inclusive environment that recognises talent and invests in training and the integration of people.</p>",
              },
              {
                img: "/img/rsc/personas-empleadas.jpg",
                title: "Employee Health and Safety",
                text:
                  "<p>We promote a safe and healthy working environment, implementing prevention and well-being measures that help protect the health of all our employees.</p>",
              },
              {
                img: "/img/rsc/bienestar-beneficios-sociales.jpg",
                title: "Well-being and Employee Benefits",
                text:
                  "<p>We work to create a working environment that supports our employees through their different stages and needs.</p>",
              },
            ],
        },
        {
          id: "good-practice",
          img: "/img/rsc/img-buenas-practicas.png",
          alt: "COMMITMENT to Best Practices",
          title:
            "<p class='title'>COMMITMENT<br><span>to <span class='green'> Best Practices</span></span></p>",
          icons: [
            {
              img: "/img/rsc/sello-2-en.svg",
            },
            {
              img: "/img/rsc/cp-5-en.png",
            },
            {
              img: "/img/rsc/bp-9-en.png",
            },
            {
              img: "/img/rsc/sello-12-en.svg",
            },
            {
              img: "/img/rsc/sello-16-en.svg",
            },
            {
              img: "/img/rsc/bp-17-en.png",
            },
          ],
          text:
            "<p>We drive our economic growth in a sustainable manner.</p>",
            objectives: [
              {
                id: "rural",
                img: "/img/rsc/innovacion-investigacion.jpg",
                title: "Innovation and Research",
                text:
                  "<p>We explore food solutions with a positive impact, driving innovation to create new products and advance sustainability.</p>",
              },
              {
                id: "culturaEtica",
                img: "/img/rsc/derechos-humanos-cadena-valor.jpg",
                title: "Human Rights in the Value Chain",
                text:
                  "<p>We foster responsible relationships with our suppliers to ensure an ethical supply chain.</p><p style='font-size: 14px;text-decoration: underline;'><a href='https://empresasproveedoras.grupoian.com/en' target='_blank'><strong>SEE MORE</strong></p> <strong></strong></a>",
                // knowMore:
                //   "<p style='font-size: 14px;'><strong>VER MÁS</strong><img style='margin-left:5px;width:12px;height:10px;position:relative;' src='/img/arrow-down-white.svg'></p>",
                // banner_consult_code_ethics: {
                //   img: "/img/rsc/banner-consult-code-ethics.png",
                //   alt: "Consultar nuestro código ético",
                //   options: [
                //     {
                //       text: "Consulta nuestro Código Ético y de Conducta",
                //       link: "/pdf/GRUPO_IAN_Codigo_Etico_Conducta.pdf",
                //     },
                //     {
                //       text:
                //         "Consulta nuestro Código Ético de Empresas Proveedoras",
                //       link: "https://empresasproveedoras.grupoian.com/",
                //     },
                //   ],
                // },
              },
              {
                id: "rural",
                img: "/img/rsc/seguridad-alimentaria.jpg",
                title: "Food Safety",
                text:
                  "<p>We maintain our firm commitment to food safety through certified processes and a focus on continuous improvement.</p>",
              },
              {
                id: "digitalizacion",
                img: "/img/rsc/cultura-corporativa.jpg",
                title: "Corporate Culture",
                text:
                  "<p>Our business is guided by transparency, business ethics and sustainability, through active communication and certified regulatory compliance.</p>",
              },
              {
                id: "idi",
                img: "/img/rsc/gestion-riesgos.jpg",
                title: "Risk Management",
                text:
                  "<p>We promote a culture of responsible management, focused on quality, safety and the constant improvement of our processes.</p>",
              },
            ],
        },
      ],
      commitment_banner: {
        img: "/img/rsc/futuro-mejor-en.svg",
        alt: "Commitment to a Better Future",
        img_bottom: "/img/rsc/bg-campo.svg",
      },
      banner_consult_code_ethics: {
        img: "/img/rsc/banner-consult-code-ethics.png",
        alt: "Consultar nuestro código ético",
        options: [
          {
            text: "Consulta nuestro Código Ético y de Conducta",
            link: "/pdf/GRUPO_IAN_Codigo_Etico_Conducta.pdf",
          },
          {
            text: "Consulta nuestro Código Ético de Empresas Proveedoras",
            link: "https://empresasproveedoras.grupoian.com/en",
          },
        ],
      },
      rsc_projects_banner: {
        title: "Learn about our CSR projects",
        text:
          "<p class='waypoints'>At Grupo Alimentario IAN, we develop initiatives related to social and economic commitment to help drive the development of the environments and communities in which we operate.</p>",
        subtitle:
          "More information about our<br> 2026-2030 CSR and Sustainability Plan",
        download_pdf: "/docs/Grupo-Alimentario-IAN-CSR-and-Sustainability-Plan2026-2030.pdf",
        download: "Download",
      },
    },
    show_more: "See more",
    show_less: "See less",
    gamas_y_formatos: "Range and Formats",
    quieres_conocer_nuestra_gama:
      "¿Quieres conocer nuestra gama completa y sus formatos",
    nos_adaptamos: "We can cater for your needs. Just tell us what they are.",
    categorias_productos: {
      "vegetable-preserves": {
        id: "conservas-vegetales",
        name: "Vegetable Preserves",
        seo: {
          title: "Canned vegetables| Grupo Alimentario IAN",
          description:
            "Delicious, high-quality canned vegetables. Asparagus, tomatoes and sauces, olives, peppers, vegetables and legumes.",
        },
        descripcion:
          "<p>We offer a wide range of high-quality food products that are ideal for both the home and the catering sector. We select only the best produce and use the most advanced packaging techniques to preserve quality and freshness.</p>",
        productos: {
          asparagus: {
            id: "esparragos",
            name: "Asparagus",
            categoria: "Vegetable Preserves",
            title: "Since 1875",
            seo: {
              title:
                "Premium quality white asparagus | Grupo Alimentario IAN | Carretilla",
              description:
                "Delicious premium quality whole white asparagus. Known for their flavour, colour and tender texture, with no stringy fibres. Which do you prefer?",
            },
            subtitle:
              "The very best quality from the field to your kitchen. Recognised for their white colour, unmistakable taste and tender texture with no stringy fibres.",
            descripcion:
              "<p>Carretilla selects only the best asparagus and peels it by hand before packaging it immediately to preserve its freshness and nutritional properties.</p>",
            cta_link: "CARRETILLA ASPARAGUS WEBSITE",
            link: "https://esparragoscarretilla.es/",
            texto_gama_formatos:
              "<p>Aside from our popular whole white asparagus, stalks and tips, the Carretilla range also includes green asparagus. All our products are available in jars, cans or tins in a range of sizes to suit every need.</p>",
          },
          "tomatoes-and-sauces": {
            id: "tomates-y-salsas",
            name: "Tomatoes and Sauces",
            categoria: "Vegetable Preserves",
            title: "Ideal for the home or the catering sector",
            seo: {
              title: "Canned tomatoes and sauces | Grupo Alimentario IAN",
              description:
                "In our different varieties of canned tomatoes—whole, chopped and fried, as well as in our tomato sauces—we offer you the highest quality and natural flavour. Try them!",
            },
            subtitle:
              "Recognised for their all-natural taste and produced without preservatives or thickening agents.",
            descripcion:
              "<p>We have <strong>decades of experience</strong> producing different varieties of tomatoes through our Carretilla and IAN brands. We produce whole, natural peeled tomatoes, chopped tomatoes, fried tomatoes, strained tomatoes, gazpacho, tumaca and many other tomato-based products at our Villafranca and Funes sites.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>We carefully select and prepare the fruit to preserve its natural flavour, texture and aroma. Our tomato products are available in different formats to cater for your every need in the kitchen.</p>",
          },
          olives: {
            id: "aceitunas",
            name: "Olives",
            categoria: "Vegetable Preserves",
            title: "Tasty and nutritious!",
            seo: {
              title: "Black and green olives | Grupo Alimentario IAN",
              description:
                "Enjoy the quality and flavour of our black and green olives, one of the most typical ingredients of the Mediterranean diet. Our olives come in different formats: whole, pitted, stuffed and sliced.",
            },
            subtitle: "A classic part of the traditional Mediterranean diet.",
            descripcion:
              "<p><strong>Since 1975</strong>, we have processed both green and black olives at our COMARO sites in Casas del Monte (Cáceres) and Morón de la Frontera (Seville).</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>We market our olives in different formats: whole, stoned, stuffed and sliced. We also produce green olives with special fillings to cater for all tastes, including anchovies, cheese, peppers, lemon, almonds, salmon, tuna, pepper paste and much more.</p>",
          },
          peppers: {
            id: "pimientos",
            name: "Peppers",
            categoria: "Vegetable Preserves",
            title: "Top quality",
            seo: {
              title: "Canned Piquillo Peppers |Grupo Alimentario IAN",
              description:
                "Carretilla Piquillo peppers, an ideal and versatile food for a healthy and balanced diet. Discover our varieties of piquillo peppers.",
            },
            subtitle:
              "Our piquillo peppers are consistent in size and carefully selected by hand.",
            descripcion:
              "<p>Carretilla Piquillo Peppers <strong>are collected by hand</strong>, roasted, peeled and presented with the centre removed and practically no seeds at all.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Once ready, our peppers are packaged straight away so that they reach consumers with their high-quality taste, size, colour and texture, as well as the distinctive Carretilla roasted flavour. They are also available in strips or in our “Al ajillo” variety with added garlic.</p>",
          },
          "vegetables-and-legumes": {
            id: "verduras-y-legumbres",
            name: "Vegetables and Legumes",
            categoria: "Vegetable Preserves",
            title: "With all their natural flavour",
            seo: {
              title: "Canned vegetables and legumes | Grupo Alimentario IAN",
              description:
                "Through our brands, Carretilla and Taboada, we produce a wide range of canned vegetables and legumes. Essential ingredients in the kitchen for preparing a wide variety of recipes.",
            },
            subtitle: "Essential, versatile ingredients in any kitchen.",
            descripcion:
              "<p>Our vegetables and legumes <strong>are collected at just the right level of ripeness</strong>. They are then sorted and processed to preserve all their nutritional properties.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>We offer a wide range of vegetables and legumes through our Taboada and Carretilla brands. They can be combined in countless ways to create complete, nutritious, balanced dishes.</p>",
          },
        },
      },
      "ready-meals": {
        id: "platos-preparados",
        name: "Ready Meals",
        seo: {
          title:
            "Carretilla ready meals |Homemade flavour | Grupo Alimentario IAN",
          description:
            "Discover our ready meals! Through our Carretilla brand, we offer more than 60 different ready meals, microwave-ready in just 1 minute: salads, pasta dishes, rice dishes, legume dishes, vegetable dishes, and Tex-Mex dishes.",
        },
        descripcion:
          "<p>We offer a wide variety of high-quality, traditional recipes, available in easy-to-use formats, such as cans or microwaveable bowls and cardboard trays.</p>",
        productos: {
          "microwaveable-ready-meals": {
            id: "platos-preparados-en-envase-microondable",
            name: "Microwaveable Ready Meals",
            categoria: "Ready Meals",
            title: "The biggest menu on the market",
            seo: {
              title:
                "Prepared dishes in microwaveable packaging | IAN food group.",
              description:
                "Carretilla prepared dishes in 1 minute, convenient and very delicious. Made with natural ingredients, they do not need cold to be preserved, thanks to the Exclusive Wheelbarrow Process.",
            },
            subtitle:
              "Everything you need for a varied, balanced diet. We offer a range of different pasta, rice, meat, vegetable, legume, soup and salad dishes, and even tapas and Mexican food!",
            descripcion:
              "<p>Make life easier. Convenient, delicious and ready to eat <strong>in less than a minute! Produced using all-natural ingredients</strong>. Better still, thanks to <strong>Carretilla’s exclusive process, they don’t need to be refrigerated</strong>, so you can enjoy them whenever and wherever you want.</p>",
            cta_link: "Carretilla Ready meals",

            link: "https://carretilla.info/microwavable-meals",
            texto_gama_formatos:
              "<p>All our products are adapted to the needs of our customers and markets. They are available in both individual formats and larger formats, such as bowls, cardboard trays or ½ Gastronorm trays. Ideal for the catering sector.</p>",
          },
          "canned-ready-meals": {
            id: "platos-preparados-en-lata",
            name: "Canned Ready Meals",
            categoria: "Ready Meals",
            title: "Meat and vegetable recipes since 1969",
            seo: {
              title:
                "Carretilla ready meals | Traditional recipes | Grupo Alimentario IAN",
              description:
                "Discover our canned ready meals! A wide range of meat and vegetable dishes prepared according to traditional recipes. 100% natural ingredients, with no additives.",
            },
            subtitle:
              "Made with traditional know-how and state-of-the-art food technology. Ready when you heat them up.",
            descripcion:
              "<p>We have decades of experience producing high-quality, traditional meat and legume dishes. With absolutely no additives, all our recipes use 100% natural ingredients and our own sausages produced at our factory in Noreña, Asturias.</p>",
            cta_link: false,
            link: false,
            texto_gama_formatos:
              "<p>Through our Carretilla and La Nora brands, as well as our gourmet brand, El Yantar de Pepe, we offer a huge catalogue of canned ready meals, including pork, chicken, beef, vegetable and legume recipes. They are available in a range of sizes and are produced without flavour enhancers or preservatives.</p>",
          },
        },
      },
    },
    map_web: {
      title: "Site Map",
    },
    policy_cookies:
      '<h1>Cookies Policy</h1> <p dir="ltr"> Date of last update: 08/05/2025 </p><h2 dir="ltr"> WHAT ARE COOKIES? </h2><p dir="ltr"> Cookies are small files that are installed on the hard drive or browser of your computer, tablet, smartphone or equivalent device with Internet browsing functions and help, among other things, to: personalize the services provided by the website owner, facilitate browsing and usability through the website, gather aggregated information about website visitors, enable the reproduction and display of multimedia content on the website, allow interaction between the user and the site, provide security tools, etc. </p><p dir="ltr"> DEFINITIONS USED IN THIS COOKIE POLICY </p><p dir="ltr"> § Data: This refers to the information obtained from the user’s terminal equipment through data storage and retrieval devices (cookies or others). The data is considered personal when it relates to identified or identifiable natural persons, as defined in Article 4 of the GDPR. </p><p dir="ltr"> § Aggregated information: non-nominal information, typically numerical, used for statistical purposes. </p><p dir="ltr"> § Terminal equipment: The device from which the user accesses the service, such as a personal computer, mobile phone, tablet, etc., and from which the information is obtained. </p><p>§ Publisher: the person responsible for or owner of the website</p><p>§ Third party: an external entity, collaborator, service provider or entity related to the publisher, involved in the management of certain cookies</p><p> § Cookie controller: the publisher, controller, owner of the website or, in some cases, even a third party</p><p> § Browsing habits: patterns or behaviours shown by the user while browsing a website, such as the time spent on the site, sections visited, most frequently accessed areas, origin of the visit, destination of the visit, among others.</p><h2 dir="ltr"> WHAT TYPES OF COOKIES ARE THERE? </h2><p dir="ltr"> According to the entity that manages them: </p><p dir="ltr"> First-party cookies: these are cookies that are sent to the user’s terminal equipment from a computer or domain managed by the publisher and from which the service requested by the user is provided. </p><p dir="ltr"> Third-party cookies: these are cookies that are sent to the user’s terminal equipment from a computer or domain that is not managed by the editor but by another company which processes the data that the cookies provide. </p><p dir="ltr"> According to the length of time they remain active on the terminal equipment: </p><p dir="ltr"> Session cookies: these are cookies that are designed to gather and store data while the user accesses a website. They are usually used to store information that is only relevant to provide the service requested by the user on one single occasion (for example, a list of acquired products) and they disappear when the session is ended. </p><p dir="ltr"> Persistent cookies: these are cookies that ensure data remains stored in the user´s computer system, and they may be accessed and processed for a period defined by the entity responsible for the cookie, which may range from a few minutes to several years. </p><p dir="ltr"> According to the purpose for which the data obtained through the cookies is processed: </p><p dir="ltr"> Technical cookies: these are cookies allow the user to browse through a website, platform, or application and use the different options or services available, including those used by the publisher to manage and operate the website and enable its functions and services. For example, these cookies may control traffic and data communication, identify the session, access restricted areas, remember the items in a shopping cart, complete the purchase process, manage payment, monitor fraud related to service security, request registration or participation in an event, count visits for software licence billing purposes (for the website, platform, or application), use security elements during navigation, store content for video or audio distribution, enable dynamic content (such as loading text or image animation), or share content through social media. Also belonging to this category, due to their technical nature, are the cookies that enable the most efficient management of advertising spaces that, as an element of design or "layout" of the service offered to the user, the publisher has included on a website, application, or platform based on criteria such as the edited content, without collecting user information for other purposes, such as personalizing that advertising content or other content. </p><p dir="ltr"> Preference or personalization cookies: these are cookies that remember information so that the user can access the service with certain features that may differentiate their experience from that of other users, such as, for example, the language, the number of results to display when the user performs a search, the appearance or content of the service depending on the type of browser the user uses to access the service or the region from which they access the service, etc. </p><p dir="ltr"> Analytical or measurement cookies: these are cookies that enable the entity responsible for them to track and analyse user behaviour on related websites, including quantification of the impact achieved by advertisements. The information gathered by these cookies is used to measure the activity made on websites, applications or platforms. </p><p dir="ltr"> Advertising cookies: these are cookies that allow the management, in the most efficient way possible, of advertising spaces that the publisher has included on the website, application or platform from which the requested service is provided. The advertisements are displayed based on criteria such as the content that is published or how frequently the advertisements are shown. </p><p dir="ltr"> Behavioural advertising cookies: these are cookies that allow the management, in the most efficient way possible, of advertising spaces that the publisher has included on the website, application or platform from which the requested service is provided. These cookies store information on the behaviour of users obtained through the continuous observation of their browsing habits, from which a specific profile is created so that advertising can be displayed based on it. </p><p dir="ltr"> List of cookies we collect </p><br /><div dir="ltr" align="left"><table><colgroup><col width="77" /><col width="118" /><col width="93" /><col width="114" /><col width="104" /><col width="85" /></colgroup><tbody><tr><td><p dir="ltr"> Cookie name </p></td><td><p dir="ltr"> First-party / Third-party*<br> *(includes URL to cookie policy) </p></td><td><p dir="ltr"> Cookie type </p></td><td><p dir="ltr"> Purpose </p></td><td><p dir="ltr"> Duration </p></td><td><p dir="ltr"> Transfer of data outside the European Union </p></td></tr><tr><td><p dir="ltr"> CookieConsent </p></td><td><p dir="ltr"> Third-party ( <a href="https://www.cookiebot.com/goto/privacy-policy/"> Cookiebot </a> ) </p></td><td><p dir="ltr"> Technical </p></td><td><p dir=‘ltr’> Stores the user´s cookie consent status for the current user´s cookie consent status for the current domain </p></td><td><p dir=‘ltr’> It is a cookie with a permanence of 1 year. </p></td><td><p dir=‘ltr’> No </p></td></tr><tr><td><p dir="ltr"> PHPSESSID </p><br /></td><td><p > First-party </p></td><td><p > Technical </p></td><td><p > Stores a unique session identifier to keep track of user states across all page requests. </p></td><td><p > Temporary (Session cookies) </p></td><td><p > No </p></td></tr><tr><td><p dir="ltr"> CONSENT </p></td><td><p dir="ltr"> Third-party <a href="https://policies.google.com/privacy"> YouTube </a></p></td><td><p dir="ltr"> Technical </p></td><td><p dir="ltr"> Used to detect if the visitor has accepted the marketing category in the cookie banner. This cookie is necessary for the website to comply with the GDPR. </p><br /></td><td><p dir="ltr"> It is a cookie with a lifespan of 6079 days. </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> _ga </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Analytics or measurement </p></td><td><p dir="ltr"> Registers a unique ID used to generate statistical data about how the visitor uses the website. </p><br /></td><td><p dir="ltr"> It is a cookie with a lifespan of 2 years. </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> _gat </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Analytics or measurement </p></td><td><p dir="ltr"> Used by Google Analytics to throttle the request rate. </p></td><td><p dir="ltr"> It is a cookie with a lifespan of 1 day. </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> _gid </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Analytics or measurement </p></td><td><p dir="ltr"> Registers a unique ID used to generate statistical data about how the visitor uses the website. </p></td><td><p dir="ltr"> It is a cookie with a lifespan of 1 day. </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> collect </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Analytics or measurement </p></td><td><p dir="ltr"> Used to send data to Google Analytics about the visitor´s device and behavior. Tracks the visitor across devices and marketing channels. </p></td><td><p dir="ltr"> Session (Temporary cookies) </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> IDE </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Used by Google DoubleClick to register and report user actions on the website after viewing or clicking on an advertiser´s ad, with the purpose of measuring ad effectiveness and serving targeted ads to the user. </p></td><td><p dir="ltr"> It is a cookie with a lifespan of 1 year </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> test_cookie </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> Google </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Used to check if the user´s browser supports cookies. </p></td><td><p dir="ltr"> It is a cookie with a lifespan of 1 day </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> VISITOR_INFO1_LIVE </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Attempts to estimate the user´s bandwidth on pages with embedded YouTube videos. </p></td><td><p dir="ltr"> It is a cookie with a lifespan of 179 days </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> YSC </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Registers a unique ID to keep statistics on which YouTube videos the user has watched. </p></td><td><p dir="ltr"> Session (Temporary cookies) </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> yt.innertube::nextId </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Registers a unique ID to maintain statistics of which YouTube videos the user has watched. </p></td><td><p dir="ltr"> Persistent </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> yt.innertube::requests </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Registers a unique ID to keep statistics on which YouTube videos the user has watched. </p></td><td><p dir="ltr"> Persistent </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> yt-remote-cast-installed </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Records the user´s video player preferences when watching embedded YouTube videos. </p></td><td><p dir="ltr"> Session (Temporary cookies) </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> yt-remote-connected-devices </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Records the user´s video player preferences when watching embedded YouTube videos. </p></td><td><p dir="ltr"> Persistent </p></td><td><p dir="ltr"> Yes, Google LLC </p></td></tr><tr><td><p dir="ltr"> yt-remote-device-id </p><br /></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Records the user´s video player preferences when watching embedded YouTube videos. </p><br /></td><td><p dir="ltr"> Persistent </p></td><td><p dir="ltr"> Yes, Google LLC </p><br /><br /></td></tr><tr><td><p dir="ltr"> yt-remote-fast-check-period </p><br /></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Records the user´s video player preferences when watching embedded YouTube videos. </p><br /></td><td><p dir="ltr"> Session (Temporary cookies) </p></td><td><p dir="ltr"> Yes, Google LLC </p><br /></td></tr><tr><td><p dir="ltr"> yt-remote-session-app </p></td><td><p dir="ltr"> Third-party ( <a href="https://policies.google.com/privacy"> YouTube </a> ) </p></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Records the user´s video player preferences when watching embedded YouTube videos. </p><br /></td><td><p dir="ltr"> Session (Temporary cookies) </p></td><td><p dir="ltr"> Yes, Google LLC </p><br /></td></tr><tr><td><p dir="ltr"> yt-remote-session-name </p><br /></td><td><br /></td><td><p dir="ltr"> Behavioral advertising cookies </p></td><td><p dir="ltr"> Records the user´s video player preferences when watching embedded YouTube videos. </p><br /></td><td><p dir="ltr"> Session (Temporary cookies) </p></td><td><p dir="ltr"> Yes, Google LLC </p><br /></td></tr></tbody></table></div><p dir="ltr"> Cookies are not used to create profiles of users who browse the website, and therefore no automated decisions are made based on this data. </p><p dir="ltr"> You can find information about transfers to third countries made by the third parties identified in this cookie policy, as well as the risks associated with such transfers according to their own policies, which are separate from this website. You can access their respective cookie policies provided in each case in the table above. </p><h2 dir="ltr"> HOW TO DISABLE COOKIES </h2><p dir="ltr"> Blocking or disabling all cookies helps protect privacy, but it may also limit your experience on some websites, as it can restrict certain functionalities or even prevent proper browsing or the use of some services. </p><p dir="ltr"> You can enable or disable the cookies described above (except for technical cookies, which are necessary for proper functioning) through the configurator that appears in the cookie usage notice when accessing our homepage. Please note that if you accept third-party cookies, you will need to delete them through your browser options or through the system provided by the third party itself. </p><p dir="ltr"> Similarly, if you want to know how to disable cookies in the most popular web browsers, please refer to the following tutorials: </p><p dir="ltr"> § <a href="http://support.google.com/chrome/answer/95647?hl=es"> Google Chrome </a></p><p dir="ltr"> § <a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we"> Mozilla Firefox </a></p><p dir="ltr"> § <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"> Internet Explorer </a></p><p dir="ltr"> § <a href="http://support.apple.com/es-es/HT1677"> Safari</a></p><p dir="ltr"> § <a href="http://support.google.com/chrome/answer/2392971?hl=es"> Chrome para Android </a></p><p dir="ltr"> If you have any questions or concerns about this Cookie Policy, you can contact us through the contact methods available on our website. </p><p dir="ltr"> If you would like complete and specific information about personal data protection, please refer to our privacy policy. </p>',
    policy_privacy:
      "<h1>PRIVACY POLICY</h1><p> Date of last update: 08/05/2025 </p><p> This Privacy Policy has been developed in accordance with the provisions of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (hereinafter the GDPR) and with Organic Law 3/2018, of 5 December, on Protection of Personal Data and guarantee of digital rights (hereinafter, LOPDGDD), and other applicable regulations. </p><p> The purpose of this Privacy Policy is to inform individuals who provide their personal data, and/or that of the person they represent, about the specific aspects related to the processing of such data, including the purposes of the processing, contact details for exercising their rights, data retention periods, and security measures, among other things. </p><h2> WHO IS THE DATA CONTROLLER? </h2><p> In terms of data protection, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U shall be considered the Data Controller in relation to the processing of personal data carried out by this entity. </p><p> The contact details of the Data Controller are as follows: </p><p> o Identity of the data controller: INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U (A31204175) </p><p> • Physical address: P.I. PEÑALFONS, S/N, 31330, VILLAFRANCA, NAVARRA </p><p> • Email: <a href='mailto:info@grupoian.com'> info@grupoian.com </a></p><p> Telephone: Telephone: 948 84 33 60 </p><h2> WHO IS THE DATA PROTECTION OFFICER? </h2><p> This entity has appointed a Data Protection Officer, who can be contacted via the following email address: GESPRODAT S.L dpd@gesprodat.net 902 929 926, or by writing to the registered address of this entity for the attention of the “Data Protection Officer”. </p><h2> WHAT PERSONAL DATA DO WE PROCESS? </h2><p> All information collected by INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U will be processed in a fair, lawful, and transparent manner. </p><p> Likewise, the data requested in each of the processing activities carried out will consist solely of those that are strictly necessary to fulfil the specific, informed purpose in each case. </p><p> In this way, the data collected will be adequate, relevant, and not excessive in relation to the purposes for which they are processed in each case. Therefore, your personal data will be collected for specific, explicit and legitimate purposes and will not be further processed in a manner incompatible with those purposes. In addition, they will be updated whenever necessary. </p><p> In general terms, within the scope of the various processing activities carried out by the organization, the following types of data are collected: </p><p> • Identifying data. </p><p> • Identifying data. </p><p> • Administrative data. </p><p> • Commercial information. </p><h2> WHAT IS THE SOURCE OF THE PERSONAL DATA? </h2><p> As a general rule, personal data is always collected directly from the data subject. However, in certain exceptions, data may be collected through third parties, entities, or services other than the data subject. </p><p> In this regard, this matter will be communicated to the data subject through the informational clauses included in the various data collection channels, and within a reasonable time or during the first notification made to the data subject. </p><p> FOR WHAT PURPOSES AND IN WHAT SPECIFIC CASES DO WE PROCESS PERSONAL DATA? </h2><p> In general terms, personal data is processed for the following purposes: </p><p> • User registration management: The information you provide in the registration form will be processed for the management of users on our platforms. </p><p> • Newsletters: when previously authorized, via email, fax, SMS, MMS, social communities, or any other present or future electronic or physical means that enables commercial communications, as well as sending the website's newsletter. These communications will be made by the Data Controller or any of the companies in the Data Controller's group, about its products and services, or by its collaborators or suppliers with whom it has reached a promotion agreement. In this case, third-parties will never have access to personal data. </p><p> • Contact: In order to respond to your request, we will process the necessary data, which generally corresponds to contact details (email), or the issue you communicate to us, as well as responding to information requests regarding the products and services offered or any type of request made by the user through any of the contact methods available to them. </p><p> When using social media to send us queries, please avoid entering personal data. Remember that we have no control over the data entered on these platforms, so we advise you to carefully read the privacy policies of the social media platform you are using. </p><p> • Surveys: For conducting customer service and/or product quality surveys carried out by the Data Controller or any of the companies in the Data Controller's group. In order to improve these services, we will process your personal data to obtain information about our products or the service provided by our customer support team. </p><p> The personal data collected will not be used to create profiles or make automated decisions. However, all the specific purposes for which each of the processing activities is carried out are outlined in the informational clauses included in each of the data collection channels (web forms, paper forms, voice recordings or posters, informational notes, invoices, contracts, and other documents containing personal data). </p><h2> WHAT IS THE LEGAL BASIS FOR THE PROCESSING OF PERSONAL DATA? </h2><p> As a general rule, prior to the processing of personal data, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U informs about the legal basis upon which the legitimacy of the processing is established. </p><p> However, the organization may process personal information for the following purposes: </p><p> • Compliance with legal and regulatory obligations: For example and without limitation: General Law for the Defence of Consumers and Users, General Tax Law, Corporate Tax Law, Auditing Law, Value Added Tax Law, Civil Code, Commercial Code, also in the case of any specific law or regulation that authorizes or requires the processing of the data subject's data, which will be stated in the corresponding informational clause. </p><p> • Performance of a Contract: for the prior management of a contracted service or product, the performance of a contract or subsequent procedures arising from such operations. </p><p> • Consent: there are processing activities based on the explicit and unequivocal consent of the data subject, obtained through the inclusion of informed consent clauses in the various data collection systems, with consent being provided through a declaration or a clear affirmative action, such as checking a box provided for this purpose, subscribing to the relevant document, or submitting data through the indicated contact methods. Additionally, we inform you that we will only use personal information in accordance with this Privacy Policy and, in general, we will request your consent for uses that are different from those for which you initially provided it. </p><p> • Legitimate interest: data processing based on the legitimate interest of the controller will primarily be carried out for sending communications or commercial events regarding products or services similar to those contracted. In accordance with Article 21.2 of the Law on Information Society Services, this processing will only be valid when, as a customer, you have not expressly objected at the time of data collection or in any of the communications we send. </p><h2> HOW LONG DO WE PROCESS PERSONAL DATA? </h2><p> At http://www.carretilla.info/, personal data is processed for the time necessary to fulfil the purpose for which it was collected, as long as the service or employment/contractual relationship is maintained, there is mutual interest, and/or for the period stipulated by the relevant regulations. </p><p> WHO DO WE SHARE PERSONAL DATA WITH? </p><p> As a general rule, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U does not transfer or disclose your data to third parties, except when required by law. </p><p> Nevertheless, if necessary, such data transfers or disclosures will be notified to the data subject through the informational clauses included in the various data collection channels. </p><h2> ARE ANY INTERNATIONAL TRANSFERS CARRIED OUT? </h2><p> We also inform you of the data transfer to Mailchimp (The Rocket Science Group) outside the European Economic Area, based on the existence of adequate safeguards in accordance with the GDPR, with these safeguards being available to anyone who explicitly requests them at rgpd@grupoian.com. </p><p> Specifically, the following safeguards are established: </p><p> • The data controller has been certified in accordance with certification mechanisms approved under Article 42 of the GDPR, along with binding and enforceable commitments in the third country to apply adequate safeguards, including those related to the rights of the data subjects. </p><h2> WHAT RIGHTS CAN YOU EXERCISE? </h2><p> According to European regulations, you have the following rights: </p><p> • Right of Access, the right to request information from the data controller about whether your personal data is being processed. </p><p> • Right of Rectification, the right to request the modification of data that is inaccurate or incomplete. </p><p> • Right to Object, the right of a person to object to the processing of their personal data or to have it deleted. </p><p> • Right to Individual Automated Decisions, the right not to be subject to a decision based solely on automated processing, including profiling, which produces legal effects on the data subject or significantly affects them in a similar manner. </p><p> • Right to Restriction, the right to suspend the processing of the user's personal data in certain cases. </p><p> • Right to Erasure or to be Forgotten, the right to have the personal data of the data subject erased. </p><p> • Right to Portability, the right to request that the data controller to provide personal data in a structured, commonly used, and readable format to another controller. </p><p> • Right to lodge a complaint with the relevant supervisory authority if the data subject considers that the processing does not comply with current regulations. </p><h2> HOW CAN YOU EXERCISE YOUR RIGHTS </h2><p> The applicant can exercise their rights through the following means: </p><p> •By email to <a href='mailto:rgpd@grupoian.com'> rgpd@grupoian.com </a> , providing documentation proving the identity of the applicant (copy of the front of the National Identity Document, or equivalent) </p><p> • By post to P.I. PEÑALFONS, S/N, 31330, VILLAFRANCA, NAVARRA, providing documentation proving the identity of the applicant (copy of the front of the National Identity Document, or equivalent) </p><p> In any case, you can request the oversight of the Spanish Data Protection Agency through its website. </p><p> In this regard, INDUSTRIAS ALIMENTARIAS DENAVARRA S.A.U will respond to your request as soon as possible and taking into account the deadlines established in the data protection regulations. </p><h2> WHAT ARE THE POTENTIAL CONSEQUENCES OF NOT PROVIDING THE INFORMATION? </h2><p> The data requested in the fields marked with an asterisk (*) or provided in the documents or channels where the information is given, are those strictly necessary in relation to the purpose for which they are collected, either for providing optimal service to the data subject, for a legal obligation imposed on the data controller, or a necessary requirement for entering into a contract. The inclusion of data in the remaining fields is voluntary. </p><p> In the event that all the data is not provided, it is not guaranteed that the information and services provided will be completely adjusted to their needs. </p><p> Therefore, if the required data is not provided or is provided incorrectly or incompletely, we will not be able to process your request, making it entirely impossible to provide the requested information or carry out the service contract. </p><p> Similarly, the user guarantees that the information provided in any of the forms is truthful, accurate, and corresponds to data they own. </p><p> The services on our platforms are not intended for minors, and therefore, only individuals over 18 years of age are allowed to register. In the event that a minor registers, it is hereby noted that any potential liabilities arising from the use of our platforms will be the responsibility of the minor's parents or guardians. </p><p> To prevent the use of our services by minors, we make an effort to verify the age of our users when they complete their registration by requesting their date of birth. </p><h2> WHAT SECURITY MEASURES HAVE WE IMPLEMENTED? </h2><p> The security measures adopted by INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U are those required in accordance with the provisions of Article 32 of the GDPR. </p><p> In this regard, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U, taking into account the state of the art, the application costs, and the nature, scope, context, and purposes of the processing, as well as the varying probability and severity of risks to the rights and freedoms of individuals, has established the appropriate technical and organizational measures to ensure a level of security that is adequate to the existing risk. </p><p> In any case, INDUSTRIAS ALIMENTARIAS DE NAVARRA S.A.U has implemented sufficient mechanisms to: </p><p> Ensure the ongoing confidentiality, integrity, availability and resilience of the processing systems and services. </p><p> Restore the availability and access to personal data in a timely manner in the event of a physical or technical incident. </p><p> Regularly verify, assess and evaluate the efficacy of the technical and organizational measures implemented to guarantee the security of the processing. </p><h2> CHANGES TO THIS PRIVACY POLICY </h2><p> This Privacy Policy may be revised from time to time in order to align it with changes in current legislation, update our procedures for the collection and use of personal information, and reflect the appearance of new services or the exclusion of others. These changes will take effect from the moment they are published on the website, so it is important that you regularly review this Privacy Policy in order to stay informed about any updates. </p>",
    legal_notice:
      "<h1>TERMS AND CONDITIONS</h1> <p>Date of last update: 08/05/2025<h2>1. Identification details (Law 34/2002, of 11 July, on information society services and electronic commerce):</h2><p>Company name: INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U.<p>Tax ID Code: A/31204175,<p>Address: POLIGONO PEÑALFONS S/N 31330 VILLAFRANCA-NAVARRA-SPAIN<p>Telephone: 948 84 33 60<p>Fax: 948 84 33 87<p>Registration details: Registered in the Commercial Registry of Navarra, Volume 606, Page 93, Sheet NA-363<h2>2. Use of the website:</h2><p>www.carretilla.info provides access to a wide range of information and services (hereinafter, “the content”) belonging to INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. (hereinafter, “IAN S.A.U.”). The USER assumes responsibility for the use of the website. This responsibility covers any registration process needed to access certain services or content. In this registration process, it is the USER’s responsibility to provide true, lawful information. The USER undertakes to use the content and services offered by IAN S.A.U. through its website in a suitable manner, and not to use them for purposes including but not limited to the following:<p>(I) Carrying out activities that are unlawful, illegal or contrary to good faith and public order.<p>(II) Disseminating content or propaganda of a racist, xenophobic or pornographic nature, or any which countenances terrorism or infringes human rights.<p>(III) Damaging any physical or logical systems belonging to IAN S.A.U, its providers or third parties, or introducing or spreading on the network any computer viruses or any other physical or logical systems that may cause the aforementioned damage.<p>(IV) Attempting to access or use other users’ email accounts and manipulate their messages.<p>IAN S.A.U reserves the right to remove any comments or contributions that do not respect personal dignity, that are discriminatory, xenophobic, racist or pornographic, that are harmful to minors, that threaten public order or safety, or that it deems inappropriate for publication due to their lack of relevance to the purpose. In any case, IAN S.A.U, as the administrator of its website, will act diligently as soon as it becomes aware of any actions that contravene this Legal Notice.<h2>3. Link policy:</h2><p>The linked websites are not controlled by IAN S.A.U and IAN S.A.U is not liable for the content of any linked site or any link found on any linked website, nor for any changes or updates to such websites (except as stipulated in clause 5). IAN S.A.U is only providing these links to you for your convenience, and the inclusion of any link does not imply endorsement of the website by IAN S.A.U.<h2>4. Intellectual property rights:</h2><p>IAN S.A.U, either directly or as assignee, is the owner of all the intellectual and industrial property rights of its website, as well as the elements contained therein (including images, sound, audio, video, software and texts; brands and logos, colour schemes, structure and design, selection of materials used, computer programs necessary for its operation, access and use, etc.), whether owned by INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. or its licensors. All rights reserved. By virtue of the provisions of Articles 8 and 32.1, second paragraph of Royal Legislative Decree 1/1996 of 12 April, which approves the consolidated text of the Intellectual Property Law, standardizing, clarifying, and harmonizing the current legal provisions on the matter, the reproduction, distribution, and public communication, including the provision of access, of all or part of the content of this website for commercial purposes, on any medium and by any technical means, is expressly prohibited without the authorization of IAN S.A.U. The USER undertakes to respect the intellectual and industrial property rights owned by INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U.<p>All content published on the website, and in particular the designs, texts, images, videos, graphics, logos, icons, buttons, as well as the commercial names, trademarks or designs of IAN S.A.U. and any other sign susceptible to industrial and commercial use, are subject to the intellectual and industrial property rights of INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. Under no circumstances shall it be understood that any licence is granted or that there is any waiver, transfer, total or partial assignment of such rights, nor shall any right or expectation of rights be conferred, in particular, the right to alter, exploit, reproduce, distribute or publicly communicate such content without the prior express authorization of INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U.<p>INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. has obtained authorization for the publication of its customers' images, texts, and logos on its website.<h2>5. Limitation of liability:</h2><p>IAN S.A.U. will be liable for any damages the user may suffer as a result of using the website when such damages are directly attributable to an improper action by this entity, provided it is proven that it has failed to comply with the legal and regulatory requirements and obligations established. It is the user´s responsibility to take all appropriate technical measures to reasonably control the risks of open internet browsing and to prevent damage to their equipment, loss of data and theft of confidential information. IAN S.A.U. is not liable for any damages that may arise from interferences, omissions, interruptions, computer viruses, breakdowns, and/or disconnections in the operational functioning of this website or in the users' computer devices and equipment, caused by factors outside of IAN S.A.U.'s control, which prevent or delay the provision of services or browsing of the website. It is also not liable for delays or disruptions in usage caused by deficiencies or overloads in the internet or other systems, nor for the inability to provide the service or allow access due to reasons not attributable to IAN S.A.U., whether caused by the user, third parties, or force majeure. IAN S.A.U. will not be liable if it is not duly aware that the activity or information to which it links or recommends through its links is illegal or infringes on the property or rights of a third party that are subject to compensation, or if it is duly aware, it acts diligently to remove or disable the link or corresponding information.<h2>6. Jurisdiction and applicable law:</h2><p>The law applicable to this contract will be Spanish law. For any disputes that may arise in connection with this contract, the parties, waiving their right to their own jurisdiction, expressly submit to the Courts and Tribunals of Navarra.<h2>7. General considerations</h2><p>INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U. will pursue any breach of these terms and conditions, and in the event of any unlawful use of its website, instigating such legal proceedings as are applicable by law.<h2>8. Modifications to the Legal Notice:</h2><p>These Terms of Use may be revised from time to time in order to align with changes in current legislation, update our procedures for collecting and using information, and reflect the appearance of new services or the exclusion of others. These changes will take effect from the moment they are published on the website, so it is important that you regularly review these Terms of Use in order to stay informed about any updates.",
  },
};
